export const ECAGeoJson = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -67.537222,
              17.310278
            ],
            [
              -63.988333,
              16.996944
            ],
            [
              -63.978056,
              17.083333
            ],
            [
              -63.965833,
              17.193333
            ],
            [
              -63.932222,
              17.505833
            ],
            [
              -63.919444,
              17.618889
            ],
            [
              -63.914722,
              17.661111
            ],
            [
              -63.889167,
              17.943889
            ],
            [
              -63.898333,
              17.964167
            ],
            [
              -63.950278,
              17.979722
            ],
            [
              -64.017778,
              17.999444
            ],
            [
              -64.041389,
              18.003333
            ],
            [
              -64.265833,
              18.034167
            ],
            [
              -64.335556,
              18.041944
            ],
            [
              -64.352222,
              18.041667
            ],
            [
              -64.450556,
              18.0475
            ],
            [
              -64.493056,
              18.048889
            ],
            [
              -64.634167,
              18.050556
            ],
            [
              -64.649444,
              18.1925
            ],
            [
              -64.661389,
              18.278611
            ],
            [
              -64.660556,
              18.289722
            ],
            [
              -64.637778,
              18.318611
            ],
            [
              -64.637222,
              18.320833
            ],
            [
              -64.6425,
              18.344167
            ],
            [
              -64.637778,
              18.356111
            ],
            [
              -64.639722,
              18.364167
            ],
            [
              -64.670833,
              18.365833
            ],
            [
              -64.683333,
              18.372778
            ],
            [
              -64.700833,
              18.370833
            ],
            [
              -64.707778,
              18.373889
            ],
            [
              -64.716111,
              18.373611
            ],
            [
              -64.726667,
              18.375
            ],
            [
              -64.728333,
              18.3775
            ],
            [
              -64.74,
              18.376944
            ],
            [
              -64.743333,
              18.378333
            ],
            [
              -64.745,
              18.3775
            ],
            [
              -64.755556,
              18.376944
            ],
            [
              -64.776944,
              18.386944
            ],
            [
              -64.783611,
              18.405
            ],
            [
              -64.799167,
              18.407778
            ],
            [
              -64.816667,
              18.403056
            ],
            [
              -64.828056,
              18.396667
            ],
            [
              -64.838056,
              18.393333
            ],
            [
              -64.856389,
              18.395
            ],
            [
              -64.863889,
              18.3975
            ],
            [
              -64.871944,
              18.408333
            ],
            [
              -64.8775,
              18.4225
            ],
            [
              -64.889444,
              18.459722
            ],
            [
              -64.8975,
              18.489444
            ],
            [
              -64.9925,
              18.687222
            ],
            [
              -65.006111,
              18.753611
            ],
            [
              -65.102222,
              19.206944
            ],
            [
              -65.28,
              19.507778
            ],
            [
              -67.445833,
              19.187222
            ],
            [
              -67.537222,
              17.310278
            ]
          ]
        ]
      },
      "properties": {
        "name": "Caribbean Sea"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              13.82,
              62
            ],
            [
              13.82,
              57.743
            ],
            [
              10.57,
              57.743
            ],
            [
              10.4,
              57.629
            ],
            [
              9,
              55.5
            ],
            [
              9.3,
              54.175
            ],
            [
              10.5,
              53.2
            ],
            [
              31,
              53.2
            ],
            [
              31,
              66.64
            ],
            [
              18,
              66.64
            ],
            [
              13.82,
              62
            ]
          ]
        ]
      },
      "properties": {
        "name": "Baltic Sea"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -153.009167,
              22.548333
            ],
            [
              -153.476667,
              23.101389
            ],
            [
              -154.036667,
              23.536389
            ],
            [
              -154.613333,
              23.863056
            ],
            [
              -155.853611,
              24.363611
            ],
            [
              -156.4575,
              24.696389
            ],
            [
              -157.371389,
              24.959167
            ],
            [
              -157.903611,
              25.228056
            ],
            [
              -158.51,
              25.425278
            ],
            [
              -159.163056,
              25.521944
            ],
            [
              -159.905833,
              25.508611
            ],
            [
              -160.664722,
              25.364722
            ],
            [
              -161.6425,
              25.001667
            ],
            [
              -162.220278,
              24.680278
            ],
            [
              -162.718889,
              24.264722
            ],
            [
              -163.216667,
              23.680556
            ],
            [
              -163.549444,
              23.055556
            ],
            [
              -163.744722,
              22.335833
            ],
            [
              -163.7675,
              21.6125
            ],
            [
              -163.628889,
              20.923889
            ],
            [
              -163.320278,
              20.226111
            ],
            [
              -162.896667,
              19.650833
            ],
            [
              -162.343056,
              19.161944
            ],
            [
              -161.320556,
              18.654444
            ],
            [
              -160.641667,
              18.508611
            ],
            [
              -159.938056,
              18.491944
            ],
            [
              -159.235556,
              18.178056
            ],
            [
              -158.948611,
              17.521389
            ],
            [
              -158.508056,
              16.901667
            ],
            [
              -157.990278,
              16.430278
            ],
            [
              -157.293056,
              15.999167
            ],
            [
              -156.351667,
              15.676944
            ],
            [
              -155.371111,
              15.626667
            ],
            [
              -154.776944,
              15.729444
            ],
            [
              -154.218056,
              15.925556
            ],
            [
              -152.819722,
              16.774167
            ],
            [
              -152.008889,
              17.561667
            ],
            [
              -151.506667,
              18.504444
            ],
            [
              -151.371389,
              19.046389
            ],
            [
              -151.329722,
              19.579444
            ],
            [
              -151.382778,
              20.128333
            ],
            [
              -151.526667,
              20.645278
            ],
            [
              -151.997222,
              21.485833
            ],
            [
              -152.523611,
              22.116111
            ],
            [
              -153.009167,
              22.548333
            ]
          ]
        ]
      },
      "properties": {
        "name": "Hawaiian Islands"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -64.16,
              60
            ],
            [
              -74.179688,
              49.61071
            ],
            [
              -101.513672,
              49.781264
            ],
            [
              -101.5,
              34.41
            ],
            [
              -97.146389,
              25.956667
            ],
            [
              -97.139167,
              25.956667
            ],
            [
              -97.085556,
              25.961389
            ],
            [
              -97.031667,
              25.966111
            ],
            [
              -96.978056,
              25.970833
            ],
            [
              -96.924444,
              25.975556
            ],
            [
              -96.808333,
              26.009167
            ],
            [
              -95.6575,
              26.008889
            ],
            [
              -93.564444,
              25.998611
            ],
            [
              -93.066389,
              26.295556
            ],
            [
              -91.880556,
              25.861944
            ],
            [
              -90.784722,
              25.744167
            ],
            [
              -90.494722,
              25.781667
            ],
            [
              -88.55,
              25.706944
            ],
            [
              -87.493056,
              26.023333
            ],
            [
              -86.618611,
              26.562778
            ],
            [
              -86.220833,
              26.456111
            ],
            [
              -86.1125,
              26.220278
            ],
            [
              -86.353889,
              25.720833
            ],
            [
              -86.501944,
              25.178889
            ],
            [
              -85.999722,
              24.899167
            ],
            [
              -85.719722,
              24.738056
            ],
            [
              -85.531667,
              24.649167
            ],
            [
              -85.105278,
              24.443611
            ],
            [
              -84.999722,
              24.391667
            ],
            [
              -84.768611,
              24.278056
            ],
            [
              -84.644167,
              24.222222
            ],
            [
              -84.490833,
              24.160278
            ],
            [
              -83.999722,
              23.977222
            ],
            [
              -83.803056,
              23.929722
            ],
            [
              -83.693056,
              23.901111
            ],
            [
              -83.550278,
              23.874167
            ],
            [
              -83.430278,
              23.856111
            ],
            [
              -83.249722,
              23.831111
            ],
            [
              -82.999722,
              23.823333
            ],
            [
              -82.853056,
              23.825556
            ],
            [
              -82.814722,
              23.828333
            ],
            [
              -82.666389,
              23.853889
            ],
            [
              -82.416389,
              23.853889
            ],
            [
              -82.166389,
              23.828333
            ],
            [
              -82.003056,
              23.818056
            ],
            [
              -81.833056,
              23.818056
            ],
            [
              -81.666389,
              23.833889
            ],
            [
              -81.499722,
              23.847778
            ],
            [
              -81.328611,
              23.897778
            ],
            [
              -81.215278,
              23.925556
            ],
            [
              -81.187778,
              24
            ],
            [
              -81.151389,
              24.038889
            ],
            [
              -81.051667,
              24.124444
            ],
            [
              -81.0325,
              24.140556
            ],
            [
              -81.030833,
              24.141667
            ],
            [
              -81.018611,
              24.149444
            ],
            [
              -80.9975,
              24.163333
            ],
            [
              -80.996389,
              24.164167
            ],
            [
              -80.781667,
              24.309722
            ],
            [
              -80.780278,
              24.310556
            ],
            [
              -80.763056,
              24.321111
            ],
            [
              -80.755833,
              24.325278
            ],
            [
              -80.664167,
              24.368611
            ],
            [
              -80.648889,
              24.375833
            ],
            [
              -80.6025,
              24.391667
            ],
            [
              -80.539444,
              24.418611
            ],
            [
              -80.491667,
              24.441667
            ],
            [
              -80.455556,
              24.456389
            ],
            [
              -80.419444,
              24.468333
            ],
            [
              -80.409722,
              24.471667
            ],
            [
              -80.351389,
              24.493889
            ],
            [
              -80.328889,
              24.501667
            ],
            [
              -80.3225,
              24.503889
            ],
            [
              -80.296389,
              24.515833
            ],
            [
              -80.281944,
              24.524167
            ],
            [
              -80.254444,
              24.536944
            ],
            [
              -80.2225,
              24.551389
            ],
            [
              -80.211944,
              24.555
            ],
            [
              -80.064167,
              24.6075
            ],
            [
              -79.999444,
              24.642222
            ],
            [
              -79.8825,
              24.696389
            ],
            [
              -79.847222,
              24.71
            ],
            [
              -79.827222,
              24.717778
            ],
            [
              -79.823333,
              24.738333
            ],
            [
              -79.765833,
              24.924444
            ],
            [
              -79.746667,
              24.984167
            ],
            [
              -79.734722,
              25.008333
            ],
            [
              -79.715556,
              25.05
            ],
            [
              -79.708056,
              25.065278
            ],
            [
              -79.695833,
              25.150833
            ],
            [
              -79.693333,
              25.164167
            ],
            [
              -79.691944,
              25.1775
            ],
            [
              -79.691944,
              25.265833
            ],
            [
              -79.69,
              25.281111
            ],
            [
              -79.702222,
              25.358056
            ],
            [
              -79.705556,
              25.3725
            ],
            [
              -79.703333,
              25.401111
            ],
            [
              -79.703056,
              25.466389
            ],
            [
              -79.703333,
              25.5175
            ],
            [
              -79.7075,
              25.618889
            ],
            [
              -79.7075,
              25.676944
            ],
            [
              -79.713333,
              25.708611
            ],
            [
              -79.716389,
              25.727778
            ],
            [
              -79.7125,
              25.771111
            ],
            [
              -79.712222,
              25.773889
            ],
            [
              -79.706667,
              25.805556
            ],
            [
              -79.706389,
              25.806667
            ],
            [
              -79.704444,
              25.825833
            ],
            [
              -79.699722,
              25.865
            ],
            [
              -79.696111,
              25.89
            ],
            [
              -79.693889,
              25.901111
            ],
            [
              -79.685,
              25.938333
            ],
            [
              -79.677222,
              25.963333
            ],
            [
              -79.668889,
              25.987778
            ],
            [
              -79.6675,
              25.991667
            ],
            [
              -79.639444,
              26.047778
            ],
            [
              -79.609722,
              26.116389
            ],
            [
              -79.6025,
              26.129722
            ],
            [
              -79.598056,
              26.135833
            ],
            [
              -79.556389,
              26.253611
            ],
            [
              -79.554722,
              26.257222
            ],
            [
              -79.531944,
              26.315833
            ],
            [
              -79.498333,
              26.389167
            ],
            [
              -79.498611,
              26.391389
            ],
            [
              -79.499444,
              26.425278
            ],
            [
              -79.498056,
              26.484722
            ],
            [
              -79.504167,
              26.52
            ],
            [
              -79.510556,
              26.569722
            ],
            [
              -79.512778,
              26.580833
            ],
            [
              -79.513889,
              26.589167
            ],
            [
              -79.518333,
              26.608333
            ],
            [
              -79.525556,
              26.636944
            ],
            [
              -79.533611,
              26.686667
            ],
            [
              -79.538889,
              26.727778
            ],
            [
              -79.539722,
              26.741667
            ],
            [
              -79.544722,
              26.762778
            ],
            [
              -79.574167,
              26.899444
            ],
            [
              -79.5775,
              26.921111
            ],
            [
              -79.588056,
              27.007778
            ],
            [
              -79.588611,
              27.099722
            ],
            [
              -79.582222,
              27.198333
            ],
            [
              -79.571667,
              27.270278
            ],
            [
              -79.527222,
              27.433611
            ],
            [
              -79.476389,
              27.882222
            ],
            [
              -79.189722,
              28.286667
            ],
            [
              -76.669444,
              28.286944
            ],
            [
              -76.8,
              28.616389
            ],
            [
              -76.945,
              29.421389
            ],
            [
              -77.308056,
              30.213333
            ],
            [
              -76.527222,
              30.761667
            ],
            [
              -75.855,
              31.054444
            ],
            [
              -75.255556,
              31.453889
            ],
            [
              -74.200556,
              31.920278
            ],
            [
              -72.901389,
              32.758611
            ],
            [
              -72.286667,
              33.323056
            ],
            [
              -71.876389,
              33.913611
            ],
            [
              -71.617778,
              34.552778
            ],
            [
              -71.433889,
              35.582778
            ],
            [
              -71.566389,
              36.540278
            ],
            [
              -71.1425,
              37.310278
            ],
            [
              -70.630556,
              37.879444
            ],
            [
              -70.4025,
              37.963056
            ],
            [
              -69.568611,
              37.970556
            ],
            [
              -68.781944,
              38.091389
            ],
            [
              -68.033611,
              38.322222
            ],
            [
              -67.349722,
              38.654444
            ],
            [
              -66.809167,
              39.031667
            ],
            [
              -66.353889,
              39.473333
            ],
            [
              -65.9975,
              39.968056
            ],
            [
              -65.885278,
              40.095556
            ],
            [
              -64.991944,
              40.129444
            ],
            [
              -64.143611,
              40.292222
            ],
            [
              -63.180278,
              40.615278
            ],
            [
              -62.296944,
              41.081111
            ],
            [
              -61.234167,
              40.762778
            ],
            [
              -60.205556,
              40.6425
            ],
            [
              -59.088333,
              40.693889
            ],
            [
              -58.048611,
              40.926111
            ],
            [
              -57.086944,
              41.339167
            ],
            [
              -56.159444,
              41.971944
            ],
            [
              -55.528889,
              42.67
            ],
            [
              -55.128056,
              43.494722
            ],
            [
              -54.155556,
              43.353889
            ],
            [
              -53.336944,
              43.330556
            ],
            [
              -52.289444,
              43.399722
            ],
            [
              -51.344722,
              43.601667
            ],
            [
              -50.566944,
              43.8875
            ],
            [
              -49.856389,
              44.277222
            ],
            [
              -49.280556,
              44.727222
            ],
            [
              -48.724444,
              45.329167
            ],
            [
              -48.015,
              46.586667
            ],
            [
              -47.782222,
              47.406944
            ],
            [
              -47.921389,
              48.656111
            ],
            [
              -48.159722,
              49.400833
            ],
            [
              -48.1175,
              50.041111
            ],
            [
              -48.267778,
              50.670833
            ],
            [
              -48.879167,
              51.572222
            ],
            [
              -49.9525,
              52.335
            ],
            [
              -50.168056,
              53.083056
            ],
            [
              -50.121389,
              53.748333
            ],
            [
              -50.295556,
              54.389167
            ],
            [
              -51.828333,
              56.303611
            ],
            [
              -52.391389,
              56.8025
            ],
            [
              -53.132778,
              57.238889
            ],
            [
              -54.016389,
              57.586944
            ],
            [
              -55.063056,
              57.847778
            ],
            [
              -55.634722,
              58.900278
            ],
            [
              -56.716667,
              60
            ],
            [
              -64.16,
              60
            ]
          ]
        ]
      },
      "properties": {
        "name": "US East Coast"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -117.103056,
              32.536111
            ],
            [
              -122,
              58.851111
            ],
            [
              -149.26,
              65.07
            ],
            [
              -155.64,
              60.28
            ],
            [
              -153.250833,
              58.851111
            ],
            [
              -142.815833,
              56.621944
            ],
            [
              -142.288611,
              56.475556
            ],
            [
              -141.605,
              56.12
            ],
            [
              -140.929167,
              55.338333
            ],
            [
              -139.938611,
              54.656944
            ],
            [
              -139.543889,
              54.229167
            ],
            [
              -138.814722,
              53.6775
            ],
            [
              -138.676667,
              53.488889
            ],
            [
              -138.337222,
              52.753333
            ],
            [
              -137.698333,
              51.901111
            ],
            [
              -136.7625,
              51.055
            ],
            [
              -135.316944,
              50.031111
            ],
            [
              -134.264167,
              49.3775
            ],
            [
              -133.246389,
              48.963056
            ],
            [
              -132.683333,
              48.542222
            ],
            [
              -131.261389,
              47.665278
            ],
            [
              -129.074722,
              46.565278
            ],
            [
              -128.816944,
              46.183611
            ],
            [
              -128.667222,
              45.511944
            ],
            [
              -128.689722,
              44.411944
            ],
            [
              -129.023889,
              43.439444
            ],
            [
              -129.095,
              42.792778
            ],
            [
              -129.010556,
              42.213611
            ],
            [
              -128.672778,
              41.2275
            ],
            [
              -128.762778,
              40.313056
            ],
            [
              -128.523056,
              39.418056
            ],
            [
              -127.883333,
              38.418889
            ],
            [
              -127.633889,
              37.760833
            ],
            [
              -127.121667,
              37.026389
            ],
            [
              -126.758333,
              36.273611
            ],
            [
              -126.314722,
              35.733333
            ],
            [
              -125.723056,
              35.243889
            ],
            [
              -125.281111,
              34.524444
            ],
            [
              -124.454167,
              33.67
            ],
            [
              -124.196389,
              32.944167
            ],
            [
              -123.845556,
              32.366111
            ],
            [
              -123.289444,
              31.769722
            ],
            [
              -121.791389,
              30.556944
            ],
            [
              -118.605833,
              31.133056
            ],
            [
              -117.826111,
              32.627222
            ],
            [
              -117.464722,
              32.589722
            ],
            [
              -117.366944,
              32.5725
            ],
            [
              -117.263889,
              32.553611
            ],
            [
              -117.238889,
              32.5275
            ],
            [
              -117.124722,
              32.534444
            ],
            [
              -117.103056,
              32.536111
            ]
          ]
        ]
      },
      "properties": {
        "name": "US West Coast"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -4,
              62
            ],
            [
              -4,
              58.324
            ],
            [
              -5,
              57.25
            ],
            [
              -4,
              55.41
            ],
            [
              -2.36,
              55.41
            ],
            [
              -2.07,
              51.18
            ],
            [
              -4.57,
              50.53
            ],
            [
              -5,
              50.2
            ],
            [
              -5,
              48.5
            ],
            [
              2.241211,
              48.502048
            ],
            [
              7.844238,
              47.323931
            ],
            [
              10.546875,
              47.353711
            ],
            [
              10.5,
              53.2
            ],
            [
              9.3,
              54.175
            ],
            [
              9,
              55.5
            ],
            [
              10.4,
              57.629
            ],
            [
              10.57,
              57.743
            ],
            [
              13.82,
              57.743
            ],
            [
              13.82,
              62
            ],
            [
              -4,
              62
            ]
          ]
        ]
      },
      "properties": {
        "name": "North Sea"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              124.168333,
              39.828056
            ],
            [
              122.954,
              37.3699
            ],
            [
              122.95,
              37.3581
            ],
            [
              122.805,
              36.8976
            ],
            [
              122.754,
              36.807
            ],
            [
              122.683,
              36.7448
            ],
            [
              122.41,
              36.5858
            ],
            [
              121.051,
              35.7456
            ],
            [
              120.216,
              34.991
            ],
            [
              121.54,
              33.4795
            ],
            [
              121.854,
              33.1053
            ],
            [
              122.445,
              31.5357
            ],
            [
              123.392,
              30.8211
            ],
            [
              123.41,
              30.7644
            ],
            [
              123.158,
              30.0954
            ],
            [
              122.474,
              28.7921
            ],
            [
              122.125,
              28.3162
            ],
            [
              122.101,
              28.2838
            ],
            [
              121.32,
              27.3586
            ],
            [
              120.708,
              26.2924
            ],
            [
              120.603,
              26.0672
            ],
            [
              120.116,
              25.3103
            ],
            [
              119.624,
              24.8255
            ],
            [
              118.388,
              24.015
            ],
            [
              117.842,
              23.3879
            ],
            [
              117.374,
              23.0515
            ],
            [
              117.331,
              23.0258
            ],
            [
              116.582,
              22.7514
            ],
            [
              115.217,
              22.1342
            ],
            [
              114.036,
              21.6174
            ],
            [
              112.848,
              21.3738
            ],
            [
              112.489,
              21.2868
            ],
            [
              111.45,
              19.8661
            ],
            [
              111.395,
              19.7819
            ],
            [
              110.649,
              18.5196
            ],
            [
              110.628,
              18.5067
            ],
            [
              110.252,
              18.2669
            ],
            [
              110.157,
              18.2126
            ],
            [
              109.759,
              17.9842
            ],
            [
              109.718,
              17.9843
            ],
            [
              109.574,
              17.9551
            ],
            [
              109.061,
              18.053
            ],
            [
              108.845,
              18.1496
            ],
            [
              108.552,
              18.3522
            ],
            [
              108.528,
              18.375
            ],
            [
              108.519,
              18.3862
            ],
            [
              108.479,
              18.4263
            ],
            [
              108.413,
              18.8204
            ],
            [
              108.389,
              19.2131
            ],
            [
              108.379167,
              20.401389
            ],
            [
              108.208611,
              21.209722
            ],
            [
              108.134722,
              21.27556
            ],
            [
              108.095472,
              21.452278
            ],
            [
              108.094111,
              21.456417
            ],
            [
              108.094417,
              21.457833
            ],
            [
              108.097639,
              21.460972
            ],
            [
              108.099361,
              21.463917
            ],
            [
              108.100444,
              21.467139
            ],
            [
              108.101194,
              21.470139
            ],
            [
              108.101194,
              21.9
            ],
            [
              103.579102,
              26.94166
            ],
            [
              103.886719,
              32.583849
            ],
            [
              121.289063,
              41.607228
            ],
            [
              124.168333,
              39.828056
            ]
          ]
        ]
      },
      "properties": {
        "name": "China"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -6.0333,
              36.1833
            ],
            [
              -5.3208,
              36.1995
            ],
            [
              -5.1752,
              36.4148
            ],
            [
              -4.8598,
              36.5075
            ],
            [
              -4.7579,
              36.4856
            ],
            [
              -4.6391,
              36.5063
            ],
            [
              -4.5099,
              36.5991
            ],
            [
              -4.4226,
              36.7124
            ],
            [
              -4.2502,
              36.7105
            ],
            [
              -4.0793,
              36.7469
            ],
            [
              -3.956,
              36.7266
            ],
            [
              -3.8359,
              36.7537
            ],
            [
              -3.7638,
              36.7292
            ],
            [
              -3.601,
              36.7435
            ],
            [
              -3.468,
              36.6935
            ],
            [
              -3.2603,
              36.753
            ],
            [
              -2.9757,
              36.738
            ],
            [
              -2.8486,
              36.695
            ],
            [
              -2.6457,
              36.7037
            ],
            [
              -2.5657,
              36.8131
            ],
            [
              -2.3671,
              36.8415
            ],
            [
              -2.1937,
              36.7213
            ],
            [
              -2.1369,
              36.7287
            ],
            [
              -2.0083,
              36.8338
            ],
            [
              -1.8496,
              37.0692
            ],
            [
              -1.8093,
              37.2111
            ],
            [
              -1.671,
              37.3568
            ],
            [
              -1.5185,
              37.4315
            ],
            [
              -1.326,
              37.5623
            ],
            [
              -0.9527,
              37.5576
            ],
            [
              -0.7211,
              37.6062
            ],
            [
              -0.8598,
              37.7194
            ],
            [
              -0.7585,
              37.8261
            ],
            [
              -0.7508,
              37.8968
            ],
            [
              -0.6473,
              37.9996
            ],
            [
              -0.638,
              38.1371
            ],
            [
              -0.5107,
              38.2015
            ],
            [
              -0.5117,
              38.3236
            ],
            [
              -0.3755,
              38.4419
            ],
            [
              -0.1474,
              38.5365
            ],
            [
              -0.0049,
              38.6299
            ],
            [
              0.0685,
              38.6394
            ],
            [
              0.2022,
              38.7317
            ],
            [
              0.177,
              38.8136
            ],
            [
              -0.0143,
              38.8711
            ],
            [
              -0.1532,
              38.991
            ],
            [
              -0.2081,
              39.0726
            ],
            [
              -0.2204,
              39.1871
            ],
            [
              -0.3329,
              39.4147
            ],
            [
              -0.3161,
              39.5232
            ],
            [
              -0.0875,
              39.8558
            ],
            [
              -0.0055,
              39.9154
            ],
            [
              0.0537,
              40.0385
            ],
            [
              0.1199,
              40.0616
            ],
            [
              0.1837,
              40.1628
            ],
            [
              0.3872,
              40.3406
            ],
            [
              0.6013,
              40.6219
            ],
            [
              0.7705,
              40.6478
            ],
            [
              0.8735,
              40.7066
            ],
            [
              0.6999,
              40.8011
            ],
            [
              0.9926,
              41.0423
            ],
            [
              1.5324,
              41.1819
            ],
            [
              1.6739,
              41.1976
            ],
            [
              2.1353,
              41.2972
            ],
            [
              2.2562,
              41.4516
            ],
            [
              2.5515,
              41.5781
            ],
            [
              2.7776,
              41.6496
            ],
            [
              3.0446,
              41.7786
            ],
            [
              3.1811,
              41.8748
            ],
            [
              3.2316,
              41.9693
            ],
            [
              3.2037,
              42.0808
            ],
            [
              3.1266,
              42.127
            ],
            [
              3.1201,
              42.2302
            ],
            [
              3.2743,
              42.2542
            ],
            [
              3.1861,
              42.3433
            ],
            [
              3.13,
              42.5181
            ],
            [
              3.057,
              42.5369
            ],
            [
              3.0261,
              42.8107
            ],
            [
              2.9572,
              42.8475
            ],
            [
              3.0717,
              43.0452
            ],
            [
              3.2467,
              43.22
            ],
            [
              3.3845,
              43.2837
            ],
            [
              3.5158,
              43.2742
            ],
            [
              3.6587,
              43.3912
            ],
            [
              3.7988,
              43.4417
            ],
            [
              3.9074,
              43.5174
            ],
            [
              4.1014,
              43.5549
            ],
            [
              4.1377,
              43.4817
            ],
            [
              4.2346,
              43.459
            ],
            [
              4.5792,
              43.4333
            ],
            [
              4.5809,
              43.3622
            ],
            [
              4.8557,
              43.335
            ],
            [
              4.9332,
              43.4327
            ],
            [
              5.0415,
              43.3278
            ],
            [
              5.3636,
              43.3105
            ],
            [
              5.3679,
              43.207
            ],
            [
              5.5332,
              43.2126
            ],
            [
              5.8096,
              43.1127
            ],
            [
              6.1814,
              43.1076
            ],
            [
              6.497,
              43.151
            ],
            [
              6.665,
              43.2112
            ],
            [
              6.7321,
              43.4081
            ],
            [
              6.92,
              43.4486
            ],
            [
              6.972,
              43.5454
            ],
            [
              7.1007,
              43.5706
            ],
            [
              7.1495,
              43.6477
            ],
            [
              7.4062,
              43.7185
            ],
            [
              7.539,
              43.7824
            ],
            [
              7.6728,
              43.7759
            ],
            [
              7.9671,
              43.8515
            ],
            [
              8.1746,
              43.9582
            ],
            [
              8.2735,
              44.142
            ],
            [
              8.385,
              44.1804
            ],
            [
              8.4409,
              44.2746
            ],
            [
              8.5712,
              44.3566
            ],
            [
              8.7464,
              44.4272
            ],
            [
              9.2374,
              44.3451
            ],
            [
              9.4938,
              44.2355
            ],
            [
              9.6352,
              44.1335
            ],
            [
              9.834,
              44.0487
            ],
            [
              10.0181,
              44.0459
            ],
            [
              10.1467,
              43.9748
            ],
            [
              10.2405,
              43.8718
            ],
            [
              10.3295,
              43.4764
            ],
            [
              10.4249,
              43.3988
            ],
            [
              10.527,
              43.2393
            ],
            [
              10.5381,
              43.0884
            ],
            [
              10.499,
              42.9361
            ],
            [
              10.6777,
              42.9494
            ],
            [
              10.7851,
              42.8854
            ],
            [
              10.7436,
              42.7982
            ],
            [
              10.9637,
              42.7308
            ],
            [
              11.0093,
              42.6612
            ],
            [
              11.158,
              42.5616
            ],
            [
              11.1914,
              42.4902
            ],
            [
              11.0982,
              42.3918
            ],
            [
              11.1586,
              42.3618
            ],
            [
              11.2629,
              42.4199
            ],
            [
              11.4613,
              42.3743
            ],
            [
              11.6366,
              42.2925
            ],
            [
              11.8398,
              42.0296
            ],
            [
              11.9144,
              42.0393
            ],
            [
              12.1544,
              41.9039
            ],
            [
              12.2358,
              41.7385
            ],
            [
              12.3627,
              41.6926
            ],
            [
              12.5509,
              41.5362
            ],
            [
              12.6234,
              41.4442
            ],
            [
              12.8469,
              41.4134
            ],
            [
              12.9695,
              41.3469
            ],
            [
              13.0464,
              41.2265
            ],
            [
              13.2901,
              41.2973
            ],
            [
              13.5481,
              41.2069
            ],
            [
              13.6219,
              41.2606
            ],
            [
              13.7159,
              41.2508
            ],
            [
              13.812,
              41.1867
            ],
            [
              14.081,
              40.828
            ],
            [
              14.2813,
              40.8393
            ],
            [
              14.482,
              40.6985
            ],
            [
              14.4213,
              40.6099
            ],
            [
              14.5765,
              40.6134
            ],
            [
              14.7976,
              40.6599
            ],
            [
              14.9012,
              40.5562
            ],
            [
              14.9844,
              40.4239
            ],
            [
              14.927,
              40.2314
            ],
            [
              15.1181,
              40.1766
            ],
            [
              15.2851,
              40.0345
            ],
            [
              15.4191,
              39.9902
            ],
            [
              15.518,
              40.0703
            ],
            [
              15.6185,
              40.0685
            ],
            [
              15.781,
              39.8917
            ],
            [
              15.7858,
              39.8169
            ],
            [
              15.8818,
              39.5437
            ],
            [
              15.9963,
              39.4419
            ],
            [
              16.057,
              39.2713
            ],
            [
              16.0979,
              39.0346
            ],
            [
              16.2191,
              38.9221
            ],
            [
              16.184,
              38.7485
            ],
            [
              16.101,
              38.7115
            ],
            [
              15.9866,
              38.7231
            ],
            [
              15.8534,
              38.6618
            ],
            [
              15.9314,
              38.5459
            ],
            [
              15.7953,
              38.2806
            ],
            [
              15.6362,
              38.2317
            ],
            [
              15.6389,
              38.0023
            ],
            [
              15.7642,
              37.9162
            ],
            [
              16.0632,
              37.9241
            ],
            [
              16.1448,
              38.0324
            ],
            [
              16.1603,
              38.1271
            ],
            [
              16.3237,
              38.2936
            ],
            [
              16.4561,
              38.3358
            ],
            [
              16.5828,
              38.4554
            ],
            [
              16.5588,
              38.6817
            ],
            [
              16.6048,
              38.8127
            ],
            [
              16.7767,
              38.8961
            ],
            [
              16.9594,
              38.9395
            ],
            [
              17.1015,
              38.9055
            ],
            [
              17.1982,
              39.0262
            ],
            [
              17.1074,
              39.112
            ],
            [
              17.147,
              39.2065
            ],
            [
              17.111,
              39.3159
            ],
            [
              17.1538,
              39.399
            ],
            [
              17.0309,
              39.4756
            ],
            [
              16.8707,
              39.5362
            ],
            [
              16.78,
              39.6158
            ],
            [
              16.6014,
              39.6259
            ],
            [
              16.5225,
              39.661
            ],
            [
              16.5023,
              39.826
            ],
            [
              16.6298,
              39.9656
            ],
            [
              16.6091,
              40.0841
            ],
            [
              16.689,
              40.1481
            ],
            [
              16.8698,
              40.403
            ],
            [
              16.9909,
              40.4942
            ],
            [
              17.1292,
              40.5175
            ],
            [
              17.2514,
              40.4491
            ],
            [
              17.2353,
              40.4
            ],
            [
              17.5051,
              40.295
            ],
            [
              17.6714,
              40.305
            ],
            [
              17.9037,
              40.2571
            ],
            [
              17.9941,
              40.1321
            ],
            [
              18.0467,
              39.929
            ],
            [
              18.2016,
              39.8401
            ],
            [
              18.3742,
              39.7997
            ],
            [
              18.4036,
              39.962
            ],
            [
              18.5203,
              40.1084
            ],
            [
              18.4239,
              40.2941
            ],
            [
              18.2436,
              40.4403
            ],
            [
              18.0361,
              40.5658
            ],
            [
              18.0176,
              40.6416
            ],
            [
              17.8391,
              40.6912
            ],
            [
              17.7073,
              40.7589
            ],
            [
              17.4731,
              40.8318
            ],
            [
              17.2822,
              40.9702
            ],
            [
              17.0555,
              41.0778
            ],
            [
              16.5834,
              41.2078
            ],
            [
              15.9822,
              41.4449
            ],
            [
              15.9004,
              41.5354
            ],
            [
              15.9011,
              41.6163
            ],
            [
              16.189,
              41.7744
            ],
            [
              16.1525,
              41.9086
            ],
            [
              16.0022,
              41.9456
            ],
            [
              15.4193,
              41.9002
            ],
            [
              15.0994,
              41.9342
            ],
            [
              14.9984,
              41.9958
            ],
            [
              14.8515,
              42.0361
            ],
            [
              14.7181,
              42.1056
            ],
            [
              14.7167,
              42.1735
            ],
            [
              14.5114,
              42.25
            ],
            [
              14.4101,
              42.3601
            ],
            [
              14.2598,
              42.4409
            ],
            [
              14.1089,
              42.5631
            ],
            [
              13.9942,
              42.7103
            ],
            [
              13.88,
              42.9656
            ],
            [
              13.8426,
              43.1033
            ],
            [
              13.6245,
              43.4989
            ],
            [
              13.6274,
              43.5492
            ],
            [
              13.5041,
              43.6309
            ],
            [
              13.4308,
              43.6172
            ],
            [
              13.2852,
              43.6793
            ],
            [
              12.9095,
              43.9207
            ],
            [
              12.7173,
              43.9726
            ],
            [
              12.5033,
              44.1153
            ],
            [
              12.3593,
              44.2654
            ],
            [
              12.2872,
              44.4671
            ],
            [
              12.2835,
              44.5958
            ],
            [
              12.2403,
              44.694
            ],
            [
              12.3013,
              44.9521
            ],
            [
              12.4919,
              44.9705
            ],
            [
              12.3494,
              45.0826
            ],
            [
              12.3295,
              45.1674
            ],
            [
              12.2197,
              45.1923
            ],
            [
              12.1557,
              45.2591
            ],
            [
              12.1511,
              45.3648
            ],
            [
              12.3566,
              45.5054
            ],
            [
              12.5388,
              45.5745
            ],
            [
              12.7398,
              45.5325
            ],
            [
              12.9177,
              45.6128
            ],
            [
              13.098,
              45.6355
            ],
            [
              13.114,
              45.7395
            ],
            [
              13.2283,
              45.7548
            ],
            [
              13.4849,
              45.7042
            ],
            [
              13.5456,
              45.7844
            ],
            [
              13.6341,
              45.7658
            ],
            [
              13.7529,
              45.6795
            ],
            [
              13.7193,
              45.5431
            ],
            [
              13.4905,
              45.4845
            ],
            [
              13.5396,
              45.3281
            ],
            [
              13.5871,
              45.2839
            ],
            [
              13.607,
              45.1158
            ],
            [
              13.8017,
              44.931
            ],
            [
              13.8672,
              44.8091
            ],
            [
              13.9824,
              44.8517
            ],
            [
              14.0502,
              44.937
            ],
            [
              14.1691,
              44.9789
            ],
            [
              14.1632,
              45.0448
            ],
            [
              14.3335,
              45.3513
            ],
            [
              14.4605,
              45.3202
            ],
            [
              14.74,
              45.1384
            ],
            [
              14.8443,
              45.1037
            ],
            [
              14.927,
              44.9509
            ],
            [
              14.8791,
              44.791
            ],
            [
              14.8964,
              44.6957
            ],
            [
              14.9892,
              44.5732
            ],
            [
              15.2771,
              44.366
            ],
            [
              15.4078,
              44.3169
            ],
            [
              15.1787,
              44.2429
            ],
            [
              15.1631,
              44.1764
            ],
            [
              15.4689,
              43.914
            ],
            [
              15.748,
              43.7505
            ],
            [
              15.8794,
              43.7293
            ],
            [
              15.9277,
              43.5505
            ],
            [
              16.0932,
              43.4728
            ],
            [
              16.3575,
              43.5514
            ],
            [
              16.7105,
              43.4203
            ],
            [
              16.8898,
              43.3934
            ],
            [
              17.1674,
              43.1765
            ],
            [
              17.3453,
              43.1032
            ],
            [
              17.4442,
              42.952
            ],
            [
              17.2699,
              43.0109
            ],
            [
              17.2209,
              42.9792
            ],
            [
              17.442,
              42.8694
            ],
            [
              17.7287,
              42.7917
            ],
            [
              17.8063,
              42.8061
            ],
            [
              18.0613,
              42.6489
            ],
            [
              18.1991,
              42.623
            ],
            [
              18.2341,
              42.5582
            ],
            [
              18.5077,
              42.408
            ],
            [
              18.671,
              42.459
            ],
            [
              18.7072,
              42.3223
            ],
            [
              18.9054,
              42.22
            ],
            [
              19.1434,
              42.0398
            ],
            [
              19.1639,
              41.9397
            ],
            [
              19.5184,
              41.8417
            ],
            [
              19.5811,
              41.7459
            ],
            [
              19.5683,
              41.5878
            ],
            [
              19.4211,
              41.3856
            ],
            [
              19.436,
              41.3104
            ],
            [
              19.5168,
              41.2385
            ],
            [
              19.4374,
              41.1469
            ],
            [
              19.4567,
              41.0758
            ],
            [
              19.3693,
              40.7272
            ],
            [
              19.3128,
              40.6624
            ],
            [
              19.3782,
              40.5319
            ],
            [
              19.4602,
              40.4625
            ],
            [
              19.485,
              40.3509
            ],
            [
              19.3709,
              40.3386
            ],
            [
              19.4442,
              40.2337
            ],
            [
              19.8557,
              40.043
            ],
            [
              19.9526,
              39.8966
            ],
            [
              20.0206,
              39.8457
            ],
            [
              19.9866,
              39.7431
            ],
            [
              20.1867,
              39.6243
            ],
            [
              20.1642,
              39.5553
            ],
            [
              20.2607,
              39.5089
            ],
            [
              20.2333,
              39.4456
            ],
            [
              20.2868,
              39.3268
            ],
            [
              20.4438,
              39.28
            ],
            [
              20.4737,
              39.2203
            ],
            [
              20.6827,
              39.0724
            ],
            [
              20.9256,
              39.0113
            ],
            [
              21.0548,
              39.0274
            ],
            [
              21.1522,
              38.995
            ],
            [
              21.1393,
              38.9231
            ],
            [
              21.0201,
              38.8969
            ],
            [
              20.9707,
              38.9444
            ],
            [
              20.7961,
              38.9195
            ],
            [
              20.7396,
              38.852
            ],
            [
              20.7632,
              38.7576
            ],
            [
              20.8698,
              38.7953
            ],
            [
              20.9206,
              38.6706
            ],
            [
              20.9885,
              38.6687
            ],
            [
              21.0273,
              38.5027
            ],
            [
              21.1107,
              38.4523
            ],
            [
              21.1033,
              38.3695
            ],
            [
              21.228,
              38.3155
            ],
            [
              21.3735,
              38.4142
            ],
            [
              21.527,
              38.3126
            ],
            [
              21.6396,
              38.3573
            ],
            [
              21.7718,
              38.3342
            ],
            [
              21.9351,
              38.4068
            ],
            [
              22.1438,
              38.3441
            ],
            [
              22.2862,
              38.3379
            ],
            [
              22.5036,
              38.3816
            ],
            [
              22.7857,
              38.2821
            ],
            [
              22.808,
              38.2252
            ],
            [
              23.107,
              38.2057
            ],
            [
              23.2218,
              38.1561
            ],
            [
              23.1132,
              38.0594
            ],
            [
              22.9642,
              38.0793
            ],
            [
              22.8726,
              37.9332
            ],
            [
              22.727,
              38.0346
            ],
            [
              22.4909,
              38.136
            ],
            [
              22.214,
              38.1811
            ],
            [
              22.0105,
              38.3133
            ],
            [
              21.7789,
              38.3071
            ],
            [
              21.6707,
              38.1672
            ],
            [
              21.6003,
              38.1432
            ],
            [
              21.3712,
              38.2114
            ],
            [
              21.364,
              38.115
            ],
            [
              21.2568,
              37.97
            ],
            [
              21.1305,
              37.9368
            ],
            [
              21.111,
              37.842
            ],
            [
              21.2729,
              37.7863
            ],
            [
              21.3204,
              37.7028
            ],
            [
              21.5233,
              37.5749
            ],
            [
              21.6216,
              37.4827
            ],
            [
              21.6989,
              37.3106
            ],
            [
              21.566,
              37.1644
            ],
            [
              21.5768,
              37.0626
            ],
            [
              21.7101,
              36.9431
            ],
            [
              21.7035,
              36.8172
            ],
            [
              21.9344,
              36.7618
            ],
            [
              21.9352,
              36.9865
            ],
            [
              22.0499,
              37.0273
            ],
            [
              22.1535,
              37.0142
            ],
            [
              22.163,
              36.8917
            ],
            [
              22.2938,
              36.8167
            ],
            [
              22.3632,
              36.6753
            ],
            [
              22.3678,
              36.4778
            ],
            [
              22.4665,
              36.4102
            ],
            [
              22.503,
              36.4962
            ],
            [
              22.4768,
              36.6137
            ],
            [
              22.5631,
              36.7691
            ],
            [
              22.6244,
              36.8054
            ],
            [
              22.7828,
              36.7985
            ],
            [
              22.8307,
              36.6889
            ],
            [
              22.9682,
              36.5213
            ],
            [
              23.1392,
              36.5404
            ],
            [
              23.0324,
              36.6258
            ],
            [
              23.0258,
              36.7271
            ],
            [
              23.1,
              36.779
            ],
            [
              22.9587,
              37.1152
            ],
            [
              22.7732,
              37.3873
            ],
            [
              22.7173,
              37.5626
            ],
            [
              22.9805,
              37.5138
            ],
            [
              23.133,
              37.4097
            ],
            [
              23.2246,
              37.3774
            ],
            [
              23.4549,
              37.4139
            ],
            [
              23.5167,
              37.4538
            ],
            [
              23.3736,
              37.5515
            ],
            [
              23.3213,
              37.532
            ],
            [
              23.1587,
              37.6173
            ],
            [
              23.178,
              37.8046
            ],
            [
              23.1319,
              37.9194
            ],
            [
              23.2407,
              37.9751
            ],
            [
              23.3802,
              37.9705
            ],
            [
              23.4506,
              38.0232
            ],
            [
              23.7162,
              37.907
            ],
            [
              23.7702,
              37.8133
            ],
            [
              23.9004,
              37.7748
            ],
            [
              23.9377,
              37.6727
            ],
            [
              24.073,
              37.6843
            ],
            [
              24.0308,
              37.9905
            ],
            [
              23.9806,
              38.097
            ],
            [
              24.0694,
              38.1632
            ],
            [
              23.9547,
              38.2849
            ],
            [
              23.6778,
              38.3397
            ],
            [
              23.5709,
              38.4583
            ],
            [
              23.3358,
              38.5321
            ],
            [
              23.1993,
              38.6792
            ],
            [
              23.1117,
              38.6248
            ],
            [
              23.0304,
              38.7552
            ],
            [
              22.7725,
              38.7777
            ],
            [
              22.7535,
              38.8688
            ],
            [
              22.9897,
              38.9437
            ],
            [
              23.0368,
              39.0374
            ],
            [
              22.9821,
              39.0995
            ],
            [
              22.8506,
              39.1538
            ],
            [
              22.8219,
              39.2762
            ],
            [
              23.02,
              39.3156
            ],
            [
              23.1194,
              39.3052
            ],
            [
              23.2213,
              39.1809
            ],
            [
              23.3499,
              39.1846
            ],
            [
              23.2766,
              39.3137
            ],
            [
              23.0993,
              39.4966
            ],
            [
              22.9331,
              39.5812
            ],
            [
              22.8514,
              39.8011
            ],
            [
              22.7362,
              39.8685
            ],
            [
              22.7102,
              39.9509
            ],
            [
              22.5949,
              40.0113
            ],
            [
              22.5479,
              40.1439
            ],
            [
              22.66,
              40.3642
            ],
            [
              22.6019,
              40.4757
            ],
            [
              22.7154,
              40.5005
            ],
            [
              22.7409,
              40.5568
            ],
            [
              22.9518,
              40.6213
            ],
            [
              22.9375,
              40.5132
            ],
            [
              22.8193,
              40.4992
            ],
            [
              22.9113,
              40.3802
            ],
            [
              23.1448,
              40.2731
            ],
            [
              23.3052,
              40.2297
            ],
            [
              23.3044,
              40.1001
            ],
            [
              23.3802,
              40.0067
            ],
            [
              23.5925,
              39.921
            ],
            [
              23.6775,
              39.971
            ],
            [
              23.508,
              40.0262
            ],
            [
              23.3312,
              40.1985
            ],
            [
              23.4247,
              40.2773
            ],
            [
              23.6508,
              40.2249
            ],
            [
              23.7624,
              40.1282
            ],
            [
              23.8106,
              40.03
            ],
            [
              23.9418,
              39.9381
            ],
            [
              24.021,
              40.0089
            ],
            [
              23.9759,
              40.1256
            ],
            [
              23.7803,
              40.1892
            ],
            [
              23.694,
              40.286
            ],
            [
              23.8618,
              40.3699
            ],
            [
              24.0396,
              40.2925
            ],
            [
              24.1638,
              40.2791
            ],
            [
              24.3049,
              40.1145
            ],
            [
              24.3964,
              40.1412
            ],
            [
              24.2495,
              40.308
            ],
            [
              24.1547,
              40.3588
            ],
            [
              23.9304,
              40.3806
            ],
            [
              23.8364,
              40.4422
            ],
            [
              23.8346,
              40.5184
            ],
            [
              23.6937,
              40.6716
            ],
            [
              23.7307,
              40.747
            ],
            [
              23.8477,
              40.7858
            ],
            [
              24.0464,
              40.7186
            ],
            [
              24.3176,
              40.8206
            ],
            [
              24.3988,
              40.9346
            ],
            [
              24.5559,
              40.9507
            ],
            [
              24.6285,
              40.8629
            ],
            [
              24.8014,
              40.8458
            ],
            [
              25.0937,
              41.0187
            ],
            [
              25.1705,
              40.9421
            ],
            [
              25.358,
              40.937
            ],
            [
              25.5627,
              40.8568
            ],
            [
              25.9498,
              40.8424
            ],
            [
              26.0336,
              40.7728
            ],
            [
              26.0763,
              40.6175
            ],
            [
              26.3038,
              40.5905
            ],
            [
              26.7957,
              40.6569
            ],
            [
              26.8375,
              40.5844
            ],
            [
              26.7078,
              40.5124
            ],
            [
              26.5888,
              40.4968
            ],
            [
              26.2196,
              40.3196
            ],
            [
              26.2703,
              40.1938
            ],
            [
              26.1748,
              40.0436
            ],
            [
              26.2114,
              40.006
            ],
            [
              26.1427,
              39.8443
            ],
            [
              26.1635,
              39.6595
            ],
            [
              26.0643,
              39.4791
            ],
            [
              26.1317,
              39.4531
            ],
            [
              26.3669,
              39.481
            ],
            [
              26.4878,
              39.5276
            ],
            [
              26.7275,
              39.5671
            ],
            [
              26.9517,
              39.5471
            ],
            [
              26.9317,
              39.4856
            ],
            [
              26.6372,
              39.2927
            ],
            [
              26.7342,
              39.2386
            ],
            [
              26.8809,
              39.0645
            ],
            [
              26.7995,
              39.0319
            ],
            [
              26.802,
              38.9508
            ],
            [
              27.0049,
              38.913
            ],
            [
              27.0074,
              38.8663
            ],
            [
              26.8311,
              38.7612
            ],
            [
              26.7287,
              38.7257
            ],
            [
              26.7328,
              38.6481
            ],
            [
              26.8404,
              38.5869
            ],
            [
              26.9341,
              38.3837
            ],
            [
              26.7647,
              38.3685
            ],
            [
              26.5998,
              38.4339
            ],
            [
              26.6325,
              38.5118
            ],
            [
              26.478,
              38.6728
            ],
            [
              26.3653,
              38.6613
            ],
            [
              26.3812,
              38.5196
            ],
            [
              26.5155,
              38.4311
            ],
            [
              26.4512,
              38.3477
            ],
            [
              26.2789,
              38.2909
            ],
            [
              26.6036,
              38.1029
            ],
            [
              26.6707,
              38.2073
            ],
            [
              26.7737,
              38.2093
            ],
            [
              26.8843,
              38.0519
            ],
            [
              26.9809,
              38.0747
            ],
            [
              27.2774,
              37.9274
            ],
            [
              27.2594,
              37.7616
            ],
            [
              27.0961,
              37.6386
            ],
            [
              27.2277,
              37.4719
            ],
            [
              27.1936,
              37.3548
            ],
            [
              27.3541,
              37.3699
            ],
            [
              27.4735,
              37.2853
            ],
            [
              27.611,
              37.2575
            ],
            [
              27.4908,
              37.0949
            ],
            [
              27.3773,
              37.1506
            ],
            [
              27.2264,
              37.0587
            ],
            [
              27.2642,
              36.9651
            ],
            [
              27.4294,
              37.0346
            ],
            [
              27.5596,
              36.9849
            ],
            [
              27.7812,
              36.9925
            ],
            [
              27.9263,
              37.0308
            ],
            [
              28.2134,
              36.9934
            ],
            [
              28.0749,
              36.9415
            ],
            [
              28.0249,
              36.7905
            ],
            [
              27.815,
              36.8124
            ],
            [
              27.6014,
              36.763
            ],
            [
              27.4321,
              36.748
            ],
            [
              27.514,
              36.6772
            ],
            [
              27.6766,
              36.701
            ],
            [
              27.75,
              36.7653
            ],
            [
              27.8485,
              36.7478
            ],
            [
              28.1001,
              36.7681
            ],
            [
              28.0702,
              36.6736
            ],
            [
              28.1762,
              36.679
            ],
            [
              28.2663,
              36.7304
            ],
            [
              28.2456,
              36.8324
            ],
            [
              28.3984,
              36.7849
            ],
            [
              28.5662,
              36.8192
            ],
            [
              28.6481,
              36.7218
            ],
            [
              28.7897,
              36.6857
            ],
            [
              28.9493,
              36.7366
            ],
            [
              29.1218,
              36.6473
            ],
            [
              29.0322,
              36.6074
            ],
            [
              29.1132,
              36.489
            ],
            [
              29.1383,
              36.3605
            ],
            [
              29.4772,
              36.211
            ],
            [
              29.6445,
              36.1963
            ],
            [
              29.666,
              36.1465
            ],
            [
              30.1061,
              36.2454
            ],
            [
              30.2009,
              36.3152
            ],
            [
              30.2753,
              36.3156
            ],
            [
              30.4007,
              36.2522
            ],
            [
              30.4864,
              36.2788
            ],
            [
              30.4768,
              36.3975
            ],
            [
              30.5874,
              36.5775
            ],
            [
              30.5569,
              36.6192
            ],
            [
              30.5782,
              36.8005
            ],
            [
              30.7008,
              36.8841
            ],
            [
              30.7589,
              36.8449
            ],
            [
              31.0062,
              36.8579
            ],
            [
              31.2785,
              36.8185
            ],
            [
              31.5803,
              36.703
            ],
            [
              31.6647,
              36.6492
            ],
            [
              32.0516,
              36.5242
            ],
            [
              32.1648,
              36.4183
            ],
            [
              32.2956,
              36.2348
            ],
            [
              32.5173,
              36.0969
            ],
            [
              32.8052,
              36.0232
            ],
            [
              32.9505,
              36.1038
            ],
            [
              33.0916,
              36.0859
            ],
            [
              33.1263,
              36.1309
            ],
            [
              33.5636,
              36.1278
            ],
            [
              33.6876,
              36.1598
            ],
            [
              33.8667,
              36.315
            ],
            [
              34.0422,
              36.2953
            ],
            [
              34.0773,
              36.3988
            ],
            [
              34.2785,
              36.5855
            ],
            [
              34.4292,
              36.6635
            ],
            [
              34.5607,
              36.7682
            ],
            [
              34.6559,
              36.8054
            ],
            [
              34.8338,
              36.7901
            ],
            [
              34.9082,
              36.7239
            ],
            [
              34.9977,
              36.7133
            ],
            [
              35.3246,
              36.5588
            ],
            [
              35.4393,
              36.5917
            ],
            [
              35.5653,
              36.5653
            ],
            [
              35.6383,
              36.6586
            ],
            [
              36.0076,
              36.9306
            ],
            [
              36.1467,
              36.8567
            ],
            [
              36.2056,
              36.7834
            ],
            [
              36.1954,
              36.6004
            ],
            [
              36.0371,
              36.5337
            ],
            [
              35.9021,
              36.4383
            ],
            [
              35.7812,
              36.2988
            ],
            [
              35.8961,
              36.1592
            ],
            [
              35.9805,
              36.0149
            ],
            [
              35.8798,
              35.8738
            ],
            [
              35.8145,
              35.8569
            ],
            [
              35.8454,
              35.7513
            ],
            [
              35.7335,
              35.5638
            ],
            [
              35.9012,
              35.4355
            ],
            [
              35.9508,
              35.1894
            ],
            [
              35.8872,
              35.1058
            ],
            [
              35.8808,
              34.8824
            ],
            [
              35.9855,
              34.6067
            ],
            [
              35.9863,
              34.5297
            ],
            [
              35.7348,
              34.3749
            ],
            [
              35.6584,
              34.2846
            ],
            [
              35.6265,
              34.1501
            ],
            [
              35.6417,
              34.0127
            ],
            [
              35.582,
              33.915
            ],
            [
              35.473,
              33.9018
            ],
            [
              35.4781,
              33.7931
            ],
            [
              35.3664,
              33.5655
            ],
            [
              35.2879,
              33.4617
            ],
            [
              35.2048,
              33.2044
            ],
            [
              35.1039,
              33.0959
            ],
            [
              35.0423,
              32.8228
            ],
            [
              34.9558,
              32.8253
            ],
            [
              34.9103,
              32.5771
            ],
            [
              34.7839,
              32.1292
            ],
            [
              34.6499,
              31.8303
            ],
            [
              34.4596,
              31.5537
            ],
            [
              34.3319,
              31.4206
            ],
            [
              34.1731,
              31.2922
            ],
            [
              33.8688,
              31.1592
            ],
            [
              33.6815,
              31.1178
            ],
            [
              33.5398,
              31.1153
            ],
            [
              33.3829,
              31.1625
            ],
            [
              33.175,
              31.0482
            ],
            [
              33.0878,
              31.1793
            ],
            [
              32.955,
              31.0959
            ],
            [
              32.7904,
              31.0442
            ],
            [
              32.6024,
              31.0584
            ],
            [
              32.3495,
              31.2311
            ],
            [
              32.31,
              31.0936
            ],
            [
              32.3191,
              30.8282
            ],
            [
              32.3437,
              30.7241
            ],
            [
              32.3438,
              30.6912
            ],
            [
              32.3275,
              30.6214
            ],
            [
              32.3064,
              30.5778
            ],
            [
              32.3129,
              30.5472
            ],
            [
              32.3395,
              30.5126
            ],
            [
              32.3657,
              30.4141
            ],
            [
              32.4471,
              30.2917
            ],
            [
              32.5627,
              30.2351
            ],
            [
              32.5731,
              30.0681
            ],
            [
              32.5238,
              30.2441
            ],
            [
              32.4564,
              30.2316
            ],
            [
              32.3496,
              30.2844
            ],
            [
              32.3022,
              30.3513
            ],
            [
              32.3569,
              30.4138
            ],
            [
              32.2995,
              30.5579
            ],
            [
              32.2707,
              30.5815
            ],
            [
              32.3081,
              30.5898
            ],
            [
              32.3243,
              30.6219
            ],
            [
              32.3426,
              30.7058
            ],
            [
              32.3225,
              30.747
            ],
            [
              32.3167,
              30.8162
            ],
            [
              32.3022,
              31.2281
            ],
            [
              32.2952,
              31.2333
            ],
            [
              32.5437,
              31.2333
            ],
            [
              32.4747,
              31.4833
            ],
            [
              32.2667,
              31.4833
            ],
            [
              32.2667,
              31.2506
            ],
            [
              32.0067,
              31.4083
            ],
            [
              31.9454,
              31.5137
            ],
            [
              31.8437,
              31.527
            ],
            [
              31.7323,
              31.4762
            ],
            [
              31.5324,
              31.4471
            ],
            [
              31.3226,
              31.5435
            ],
            [
              31.1047,
              31.6025
            ],
            [
              30.9772,
              31.5876
            ],
            [
              30.5191,
              31.4576
            ],
            [
              30.3632,
              31.4663
            ],
            [
              30.3134,
              31.3547
            ],
            [
              30.1638,
              31.2678
            ],
            [
              30.0575,
              31.3194
            ],
            [
              29.8209,
              31.136
            ],
            [
              29.7621,
              31.1168
            ],
            [
              29.548,
              30.9719
            ],
            [
              29.3461,
              30.878
            ],
            [
              29.1545,
              30.824
            ],
            [
              28.999,
              30.8255
            ],
            [
              28.7105,
              31.0024
            ],
            [
              28.5999,
              31.02
            ],
            [
              28.4323,
              31.088
            ],
            [
              28.3165,
              31.0672
            ],
            [
              28.1589,
              31.0923
            ],
            [
              28.013,
              31.0869
            ],
            [
              27.8987,
              31.1128
            ],
            [
              27.8651,
              31.2251
            ],
            [
              27.7257,
              31.1873
            ],
            [
              27.4497,
              31.2143
            ],
            [
              27.3854,
              31.2621
            ],
            [
              27.3288,
              31.3726
            ],
            [
              27.1829,
              31.3591
            ],
            [
              26.9829,
              31.4427
            ],
            [
              26.8452,
              31.4406
            ],
            [
              26.7484,
              31.4832
            ],
            [
              26.6031,
              31.4883
            ],
            [
              26.3269,
              31.5269
            ],
            [
              26.055,
              31.6012
            ],
            [
              25.8863,
              31.6285
            ],
            [
              25.5196,
              31.5238
            ],
            [
              25.3954,
              31.5029
            ],
            [
              25.2122,
              31.5194
            ],
            [
              25.1305,
              31.7203
            ],
            [
              25.0292,
              31.8497
            ],
            [
              24.9958,
              31.9626
            ],
            [
              24.6638,
              32.0214
            ],
            [
              24.5446,
              31.9823
            ],
            [
              24.0882,
              32.012
            ],
            [
              23.9742,
              32.1056
            ],
            [
              23.7697,
              32.1662
            ],
            [
              23.4211,
              32.1741
            ],
            [
              23.2538,
              32.2034
            ],
            [
              23.2155,
              32.2736
            ],
            [
              23.0895,
              32.3282
            ],
            [
              23.1585,
              32.4566
            ],
            [
              23.11,
              32.5014
            ],
            [
              23.1043,
              32.636
            ],
            [
              22.9109,
              32.6749
            ],
            [
              22.4868,
              32.815
            ],
            [
              22.3737,
              32.8723
            ],
            [
              22.2158,
              32.8758
            ],
            [
              22.1745,
              32.9267
            ],
            [
              21.923,
              32.8938
            ],
            [
              21.7161,
              32.9407
            ],
            [
              21.6443,
              32.9288
            ],
            [
              21.4395,
              32.7974
            ],
            [
              21.3703,
              32.7775
            ],
            [
              21.1017,
              32.7708
            ],
            [
              20.5528,
              32.5332
            ],
            [
              20.3738,
              32.4166
            ],
            [
              20.1015,
              32.1816
            ],
            [
              20.0351,
              32.0632
            ],
            [
              19.959,
              31.992
            ],
            [
              19.9215,
              31.7464
            ],
            [
              19.9922,
              31.4723
            ],
            [
              20.1498,
              31.2367
            ],
            [
              20.1662,
              31.0778
            ],
            [
              20.0543,
              30.8473
            ],
            [
              19.9075,
              30.6645
            ],
            [
              19.7755,
              30.5312
            ],
            [
              19.6146,
              30.4152
            ],
            [
              19.5788,
              30.4209
            ],
            [
              19.381,
              30.3176
            ],
            [
              19.1852,
              30.2671
            ],
            [
              18.9421,
              30.2876
            ],
            [
              18.7944,
              30.3832
            ],
            [
              18.6869,
              30.4046
            ],
            [
              18.5767,
              30.5123
            ],
            [
              18.4101,
              30.5957
            ],
            [
              18.1747,
              30.7897
            ],
            [
              17.912,
              30.8557
            ],
            [
              17.8513,
              30.9249
            ],
            [
              17.7208,
              30.9437
            ],
            [
              17.3,
              31.0846
            ],
            [
              17.0487,
              31.1532
            ],
            [
              16.699,
              31.2192
            ],
            [
              16.3798,
              31.2185
            ],
            [
              16.1244,
              31.2519
            ],
            [
              15.8073,
              31.3627
            ],
            [
              15.6605,
              31.449
            ],
            [
              15.5204,
              31.6146
            ],
            [
              15.3653,
              31.9467
            ],
            [
              15.3574,
              32.1663
            ],
            [
              15.214,
              32.3745
            ],
            [
              14.9105,
              32.438
            ],
            [
              14.7517,
              32.4395
            ],
            [
              14.6061,
              32.4977
            ],
            [
              14.5026,
              32.5041
            ],
            [
              14.2196,
              32.6979
            ],
            [
              14.0051,
              32.733
            ],
            [
              13.9458,
              32.7718
            ],
            [
              13.789,
              32.7992
            ],
            [
              13.5826,
              32.7972
            ],
            [
              13.3911,
              32.8959
            ],
            [
              13.2391,
              32.911
            ],
            [
              12.9565,
              32.8227
            ],
            [
              12.7424,
              32.793
            ],
            [
              12.3405,
              32.8232
            ],
            [
              12.2077,
              32.8711
            ],
            [
              11.8532,
              33.0685
            ],
            [
              11.6444,
              33.098
            ],
            [
              11.5703,
              33.1634
            ],
            [
              11.4712,
              33.1632
            ],
            [
              11.1751,
              33.2079
            ],
            [
              11.1234,
              33.2954
            ],
            [
              11.1728,
              33.3415
            ],
            [
              11.0942,
              33.4461
            ],
            [
              11.1079,
              33.5575
            ],
            [
              11.048,
              33.6254
            ],
            [
              10.9226,
              33.6188
            ],
            [
              10.9257,
              33.5279
            ],
            [
              10.7496,
              33.4741
            ],
            [
              10.6973,
              33.4932
            ],
            [
              10.7431,
              33.6773
            ],
            [
              10.4809,
              33.6539
            ],
            [
              10.3316,
              33.7092
            ],
            [
              10.1844,
              33.8235
            ],
            [
              10.0848,
              33.9322
            ],
            [
              10.035,
              34.0387
            ],
            [
              10.0212,
              34.1705
            ],
            [
              10.1223,
              34.3169
            ],
            [
              10.3719,
              34.4188
            ],
            [
              10.4398,
              34.4926
            ],
            [
              10.5927,
              34.5382
            ],
            [
              10.6547,
              34.6361
            ],
            [
              10.9221,
              34.8866
            ],
            [
              10.9261,
              34.9661
            ],
            [
              11.0064,
              35.0144
            ],
            [
              11.0244,
              35.111
            ],
            [
              11.1434,
              35.2376
            ],
            [
              11.0415,
              35.3254
            ],
            [
              11.0458,
              35.62
            ],
            [
              10.8626,
              35.6831
            ],
            [
              10.8058,
              35.7848
            ],
            [
              10.6474,
              35.8146
            ],
            [
              10.4811,
              36.0596
            ],
            [
              10.4773,
              36.2364
            ],
            [
              10.5233,
              36.3453
            ],
            [
              10.8116,
              36.4601
            ],
            [
              10.8791,
              36.6027
            ],
            [
              11.0206,
              36.7853
            ],
            [
              11.1356,
              36.8753
            ],
            [
              11.0406,
              37.0845
            ],
            [
              10.9154,
              37.0469
            ],
            [
              10.7589,
              36.9028
            ],
            [
              10.6095,
              36.8787
            ],
            [
              10.5363,
              36.7573
            ],
            [
              10.4119,
              36.7146
            ],
            [
              10.2866,
              36.7821
            ],
            [
              10.3495,
              36.8765
            ],
            [
              10.212,
              36.9717
            ],
            [
              10.1726,
              37.0446
            ],
            [
              10.2475,
              37.17
            ],
            [
              10.0679,
              37.263
            ],
            [
              9.9654,
              37.2478
            ],
            [
              9.9137,
              37.158
            ],
            [
              9.8155,
              37.1408
            ],
            [
              9.8002,
              37.2373
            ],
            [
              9.8594,
              37.3352
            ],
            [
              9.6671,
              37.3384
            ],
            [
              9.5726,
              37.2952
            ],
            [
              9.3294,
              37.2314
            ],
            [
              9.2126,
              37.2376
            ],
            [
              9.0278,
              37.1392
            ],
            [
              8.8347,
              36.9745
            ],
            [
              8.7399,
              36.9696
            ],
            [
              8.515,
              36.9078
            ],
            [
              8.2823,
              36.915
            ],
            [
              8.2265,
              36.9517
            ],
            [
              8.0548,
              36.8785
            ],
            [
              7.9107,
              36.844
            ],
            [
              7.7653,
              36.8749
            ],
            [
              7.7656,
              36.9587
            ],
            [
              7.6219,
              36.9622
            ],
            [
              7.512,
              37.0431
            ],
            [
              7.2747,
              37.066
            ],
            [
              7.1768,
              36.9258
            ],
            [
              6.9221,
              36.8825
            ],
            [
              6.8401,
              36.9563
            ],
            [
              6.6678,
              36.9485
            ],
            [
              6.5703,
              36.9823
            ],
            [
              6.5084,
              37.0771
            ],
            [
              6.3371,
              37.0686
            ],
            [
              6.2627,
              37.0247
            ],
            [
              6.2124,
              36.9085
            ],
            [
              5.9777,
              36.8345
            ],
            [
              5.793,
              36.8064
            ],
            [
              5.7392,
              36.8291
            ],
            [
              5.5991,
              36.7778
            ],
            [
              5.5529,
              36.7149
            ],
            [
              5.4312,
              36.6553
            ],
            [
              5.2724,
              36.6376
            ],
            [
              5.102,
              36.6963
            ],
            [
              5.0474,
              36.7832
            ],
            [
              4.9221,
              36.8506
            ],
            [
              4.7603,
              36.895
            ],
            [
              4.7048,
              36.8795
            ],
            [
              3.9656,
              36.8975
            ],
            [
              3.8923,
              36.9231
            ],
            [
              3.718,
              36.8785
            ],
            [
              3.4991,
              36.7693
            ],
            [
              3.3178,
              36.7874
            ],
            [
              3.0921,
              36.7471
            ],
            [
              3.0114,
              36.8199
            ],
            [
              2.9287,
              36.8051
            ],
            [
              2.8135,
              36.7049
            ],
            [
              2.6033,
              36.6011
            ],
            [
              2.4747,
              36.5915
            ],
            [
              2.3306,
              36.6416
            ],
            [
              2.1146,
              36.5835
            ],
            [
              1.9198,
              36.5754
            ],
            [
              1.6061,
              36.537
            ],
            [
              1.3382,
              36.5492
            ],
            [
              0.936,
              36.4468
            ],
            [
              0.9003,
              36.3886
            ],
            [
              0.7601,
              36.3348
            ],
            [
              0.6652,
              36.3319
            ],
            [
              0.4751,
              36.2311
            ],
            [
              0.3385,
              36.1906
            ],
            [
              0.1397,
              36.0429
            ],
            [
              0.0377,
              35.8731
            ],
            [
              -0.1159,
              35.788
            ],
            [
              -0.3017,
              35.8355
            ],
            [
              -0.3864,
              35.908
            ],
            [
              -0.4713,
              35.8867
            ],
            [
              -0.5035,
              35.7907
            ],
            [
              -0.6347,
              35.7102
            ],
            [
              -0.8052,
              35.7719
            ],
            [
              -0.9379,
              35.7284
            ],
            [
              -1.1614,
              35.5723
            ],
            [
              -1.1884,
              35.577
            ],
            [
              -1.2616,
              35.3866
            ],
            [
              -1.3869,
              35.3047
            ],
            [
              -1.4627,
              35.3086
            ],
            [
              -1.7047,
              35.178
            ],
            [
              -1.9692,
              35.0732
            ],
            [
              -2.2063,
              35.0832
            ],
            [
              -2.4205,
              35.1413
            ],
            [
              -2.5657,
              35.0814
            ],
            [
              -2.8997,
              35.1451
            ],
            [
              -2.9315,
              35.2936
            ],
            [
              -3.0051,
              35.3926
            ],
            [
              -3.0667,
              35.2944
            ],
            [
              -3.1935,
              35.2256
            ],
            [
              -3.333,
              35.1863
            ],
            [
              -3.4913,
              35.1993
            ],
            [
              -3.705,
              35.288
            ],
            [
              -3.8488,
              35.1967
            ],
            [
              -3.9803,
              35.2363
            ],
            [
              -4.2555,
              35.1871
            ],
            [
              -4.3563,
              35.1474
            ],
            [
              -4.6818,
              35.2046
            ],
            [
              -4.7842,
              35.2389
            ],
            [
              -5.0624,
              35.4072
            ],
            [
              -5.1733,
              35.5315
            ],
            [
              -5.2431,
              35.5529
            ],
            [
              -5.3421,
              35.742
            ],
            [
              -5.3485,
              35.8
            ],
            [
              -5.9167,
              35.8
            ],
            [
              -6.0333,
              36.1833
            ]
          ]
        ]
      },
      "properties": {
        "name": "Mediterranean Sea"
      }
    }
  ]
}


export const HRAGeoJson = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              39,
              -5
            ],
            [
              50,
              -5
            ],
            [
              55,
              0
            ],
            [
              60,
              10
            ],
            [
              60,
              14
            ],
            [
              53.258,
              19.295
            ],
            [
              45,
              15
            ],
            [
              39,
              15
            ],
            [
              39,
              -5
            ]
          ]
        ]
      },
      "properties": {
        "name": "Indian Ocean Piracy Area"
      }
    }
  ]
}

export const JWCGeoJson = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              65,
              -12
            ],
            [
              65,
              25.046113
            ],
            [
              65.184964,
              25.092858
            ],
            [
              65.366122,
              25.03395
            ],
            [
              65.638748,
              24.9453
            ],
            [
              65.885814,
              24.864962
            ],
            [
              66.047685,
              24.812326
            ],
            [
              66.320309,
              24.723676
            ],
            [
              66.531052,
              24.655015
            ],
            [
              66.685205,
              24.468728
            ],
            [
              66.844985,
              24.275638
            ],
            [
              66.959111,
              24.137717
            ],
            [
              67.136003,
              23.923941
            ],
            [
              67.272945,
              23.758444
            ],
            [
              67.290764,
              23.739503
            ],
            [
              67.326891,
              23.712153
            ],
            [
              67.478688,
              23.620456
            ],
            [
              67.507852,
              23.605637
            ],
            [
              67.777911,
              23.492225
            ],
            [
              67.916088,
              23.434198
            ],
            [
              67.995974,
              23.518836
            ],
            [
              68.06694,
              23.591489
            ],
            [
              68.050811,
              23.598265
            ],
            [
              68.131714,
              23.659619
            ],
            [
              68.26355,
              23.956136
            ],
            [
              68.406372,
              23.99629
            ],
            [
              68.735962,
              23.99629
            ],
            [
              68.746948,
              24.36211
            ],
            [
              68.664551,
              24.382124
            ],
            [
              68.59314,
              24.322071
            ],
            [
              68.59314,
              24.191858
            ],
            [
              68.433838,
              24.101633
            ],
            [
              68.241577,
              24.091604
            ],
            [
              67.851563,
              24.16179
            ],
            [
              67.659302,
              24.016362
            ],
            [
              67.494507,
              24.05148
            ],
            [
              67.456055,
              24.131715
            ],
            [
              67.543945,
              24.357105
            ],
            [
              67.384644,
              24.45215
            ],
            [
              67.362671,
              24.771772
            ],
            [
              67.208862,
              24.791722
            ],
            [
              67.093506,
              24.731864
            ],
            [
              66.934204,
              24.85155
            ],
            [
              66.703491,
              24.841581
            ],
            [
              66.659546,
              24.87647
            ],
            [
              66.73645,
              25.214881
            ],
            [
              66.324463,
              25.468074
            ],
            [
              65.643311,
              25.34899
            ],
            [
              65.297241,
              25.373809
            ],
            [
              65.217131,
              25.295594
            ],
            [
              65.193333,
              25.303333
            ],
            [
              65,
              25.254469
            ],
            [
              65,
              25.311554
            ],
            [
              64.440308,
              25.249664
            ],
            [
              63.737183,
              25.398623
            ],
            [
              62.600098,
              25.274504
            ],
            [
              61.737671,
              25.060721
            ],
            [
              60.633545,
              25.319201
            ],
            [
              59.463501,
              25.477992
            ],
            [
              59.106445,
              25.453195
            ],
            [
              58.793335,
              25.596948
            ],
            [
              58.106346,
              25.560097
            ],
            [
              58,
              25.647652
            ],
            [
              58,
              25.577218
            ],
            [
              57.758333,
              25.636111
            ],
            [
              57.336579,
              25.784481
            ],
            [
              57.335752,
              25.791816
            ],
            [
              57.316623,
              25.808277
            ],
            [
              57.301009,
              25.806758
            ],
            [
              57.29749,
              25.837263
            ],
            [
              57.27925,
              25.925351
            ],
            [
              57.254115,
              25.974997
            ],
            [
              57.233915,
              25.995329
            ],
            [
              57.20254,
              26.008399
            ],
            [
              57.202162,
              26.021862
            ],
            [
              57.190511,
              26.031082
            ],
            [
              57.186976,
              26.051207
            ],
            [
              57.190411,
              26.077099
            ],
            [
              57.183787,
              26.096531
            ],
            [
              57.191102,
              26.10191
            ],
            [
              57.22138,
              26.144922
            ],
            [
              57.221733,
              26.171323
            ],
            [
              57.194874,
              26.186522
            ],
            [
              57.185798,
              26.210024
            ],
            [
              57.139435,
              26.229844
            ],
            [
              57.1368,
              26.244885
            ],
            [
              57.116557,
              26.275026
            ],
            [
              57.117177,
              26.294515
            ],
            [
              57.110621,
              26.306396
            ],
            [
              57.099365,
              26.305487
            ],
            [
              57.079693,
              26.330182
            ],
            [
              57.06184,
              26.373281
            ],
            [
              57.065885,
              26.448895
            ],
            [
              57.07428,
              26.454927
            ],
            [
              57.083184,
              26.492111
            ],
            [
              57.078076,
              26.507574
            ],
            [
              57.083877,
              26.538512
            ],
            [
              57.085045,
              26.567815
            ],
            [
              57.07787,
              26.630134
            ],
            [
              57.065992,
              26.687624
            ],
            [
              57.05989,
              26.708051
            ],
            [
              57.031013,
              26.772838
            ],
            [
              57.021799,
              26.807763
            ],
            [
              57.008014,
              26.837089
            ],
            [
              56.97081,
              26.878529
            ],
            [
              56.947657,
              26.891212
            ],
            [
              56.951071,
              26.905272
            ],
            [
              56.93394,
              26.908034
            ],
            [
              56.926193,
              26.919474
            ],
            [
              56.928518,
              26.93256
            ],
            [
              56.913601,
              26.955477
            ],
            [
              56.925541,
              26.956021
            ],
            [
              56.942467,
              26.940902
            ],
            [
              56.95012,
              26.952191
            ],
            [
              56.945035,
              26.97169
            ],
            [
              56.956413,
              27.01204
            ],
            [
              56.926445,
              27.004651
            ],
            [
              56.906241,
              27.003489
            ],
            [
              56.902933,
              27.024787
            ],
            [
              56.889808,
              27.023485
            ],
            [
              56.877421,
              27.005346
            ],
            [
              56.842402,
              27.036987
            ],
            [
              56.859182,
              27.044605
            ],
            [
              56.860886,
              27.05627
            ],
            [
              56.814442,
              27.090569
            ],
            [
              56.800555,
              27.103057
            ],
            [
              56.797031,
              27.117976
            ],
            [
              56.769776,
              27.136037
            ],
            [
              56.750938,
              27.137852
            ],
            [
              56.736626,
              27.131187
            ],
            [
              56.720904,
              27.153459
            ],
            [
              56.707029,
              27.15371
            ],
            [
              56.69611,
              27.144543
            ],
            [
              56.680126,
              27.145164
            ],
            [
              56.661519,
              27.152572
            ],
            [
              56.637797,
              27.151476
            ],
            [
              56.595663,
              27.16232
            ],
            [
              56.594444,
              27.141667
            ],
            [
              56.590424,
              27.137646
            ],
            [
              56.200562,
              27.171582
            ],
            [
              55.535889,
              26.912274
            ],
            [
              54.805298,
              26.52465
            ],
            [
              54.343872,
              26.701453
            ],
            [
              53.695679,
              26.760326
            ],
            [
              53.421021,
              26.975933
            ],
            [
              52.58606,
              27.396155
            ],
            [
              52.706909,
              27.44004
            ],
            [
              52.069702,
              27.834219
            ],
            [
              51.564331,
              27.86336
            ],
            [
              51.333618,
              28.081674
            ],
            [
              50.839233,
              28.892779
            ],
            [
              50.679932,
              29.161756
            ],
            [
              50.059204,
              30.197366
            ],
            [
              49.559326,
              30.0263
            ],
            [
              48.922119,
              30.372875
            ],
            [
              48.883667,
              30.016787
            ],
            [
              48.449707,
              29.931135
            ],
            [
              48.175049,
              30.050077
            ],
            [
              48.614502,
              29.668963
            ],
            [
              48.777092,
              29.739565
            ],
            [
              48.806236,
              29.649728
            ],
            [
              49.476736,
              29.775412
            ],
            [
              49.671794,
              29.5694
            ],
            [
              49.89427,
              29.334425
            ],
            [
              50.017865,
              29.203884
            ],
            [
              50.126197,
              29.089831
            ],
            [
              50.300772,
              28.882287
            ],
            [
              50.474454,
              28.675522
            ],
            [
              50.584449,
              28.544571
            ],
            [
              50.775489,
              28.317132
            ],
            [
              50.966523,
              28.089694
            ],
            [
              51.122819,
              27.90361
            ],
            [
              51.247817,
              27.754711
            ],
            [
              51.264846,
              27.729838
            ],
            [
              51.299987,
              27.688321
            ],
            [
              51.324602,
              27.666935
            ],
            [
              51.372532,
              27.639501
            ],
            [
              51.416822,
              27.624985
            ],
            [
              51.729001,
              27.43839
            ],
            [
              51.898518,
              27.337066
            ],
            [
              52.160498,
              27.180475
            ],
            [
              52.330013,
              27.079152
            ],
            [
              52.538053,
              26.954801
            ],
            [
              52.699861,
              26.858084
            ],
            [
              52.954128,
              26.7061
            ],
            [
              53.09281,
              26.623205
            ],
            [
              53.127431,
              26.606258
            ],
            [
              53.462268,
              26.475271
            ],
            [
              53.646432,
              26.403227
            ],
            [
              53.816979,
              26.336478
            ],
            [
              53.839857,
              26.325544
            ],
            [
              53.885798,
              26.310074
            ],
            [
              53.941072,
              26.297491
            ],
            [
              53.993847,
              26.293542
            ],
            [
              54.029525,
              26.29586
            ],
            [
              54.066764,
              26.30119
            ],
            [
              54.262447,
              26.298709
            ],
            [
              54.268064,
              26.248677
            ],
            [
              54.279791,
              26.215324
            ],
            [
              54.31259,
              26.157166
            ],
            [
              54.337256,
              26.124719
            ],
            [
              54.35642,
              26.106455
            ],
            [
              54.381761,
              26.087653
            ],
            [
              54.355605,
              26.070551
            ],
            [
              54.327653,
              26.046325
            ],
            [
              54.304794,
              26.018079
            ],
            [
              54.287721,
              25.986673
            ],
            [
              54.276949,
              25.953064
            ],
            [
              54.272801,
              25.918275
            ],
            [
              54.273626,
              25.885828
            ],
            [
              54.279196,
              25.855619
            ],
            [
              54.297084,
              25.8114
            ],
            [
              54.329266,
              25.767949
            ],
            [
              54.357209,
              25.743781
            ],
            [
              54.389352,
              25.724368
            ],
            [
              54.420157,
              25.711747
            ],
            [
              54.449331,
              25.703407
            ],
            [
              54.517959,
              25.692886
            ],
            [
              54.572222,
              25.694444
            ],
            [
              54.595,
              25.698611
            ],
            [
              54.640833,
              25.712222
            ],
            [
              54.678333,
              25.729722
            ],
            [
              54.702711,
              25.747797
            ],
            [
              54.731049,
              25.777633
            ],
            [
              54.750299,
              25.807155
            ],
            [
              54.768413,
              25.853225
            ],
            [
              54.774746,
              25.884326
            ],
            [
              54.776619,
              25.916057
            ],
            [
              54.774372,
              25.940077
            ],
            [
              54.767223,
              25.970017
            ],
            [
              54.749159,
              26.01254
            ],
            [
              54.728724,
              26.044744
            ],
            [
              54.711764,
              26.064647
            ],
            [
              54.667992,
              26.099348
            ],
            [
              54.705263,
              26.134531
            ],
            [
              54.72146,
              26.156342
            ],
            [
              54.740317,
              26.189857
            ],
            [
              54.756973,
              26.236818
            ],
            [
              54.760787,
              26.255679
            ],
            [
              54.762602,
              26.292631
            ],
            [
              54.812466,
              26.293456
            ],
            [
              54.923393,
              26.30408
            ],
            [
              54.966459,
              26.333088
            ],
            [
              55.009135,
              26.355568
            ],
            [
              55.041638,
              26.368232
            ],
            [
              55.09651,
              26.383399
            ],
            [
              55.14125,
              26.388405
            ],
            [
              55.191004,
              26.386893
            ],
            [
              55.230557,
              26.399885
            ],
            [
              55.264473,
              26.40751
            ],
            [
              55.358748,
              26.412927
            ],
            [
              55.382136,
              26.411393
            ],
            [
              55.437834,
              26.399257
            ],
            [
              55.494731,
              26.37915
            ],
            [
              55.520157,
              26.366721
            ],
            [
              55.873238,
              26.40975
            ],
            [
              55.931677,
              26.418121
            ],
            [
              55.985352,
              26.435486
            ],
            [
              56.02409,
              26.457372
            ],
            [
              56.132041,
              26.503536
            ],
            [
              56.143056,
              26.518056
            ],
            [
              56.173611,
              26.547222
            ],
            [
              56.241667,
              26.590278
            ],
            [
              56.275,
              26.593056
            ],
            [
              56.327778,
              26.616667
            ],
            [
              56.55,
              26.704167
            ],
            [
              56.557602,
              26.706067
            ],
            [
              56.581615,
              26.730973
            ],
            [
              56.599642,
              26.755337
            ],
            [
              56.620544,
              26.793352
            ],
            [
              56.631241,
              26.82372
            ],
            [
              56.672384,
              26.906322
            ],
            [
              56.711378,
              26.862896
            ],
            [
              56.724142,
              26.832754
            ],
            [
              56.742641,
              26.800226
            ],
            [
              56.764346,
              26.771164
            ],
            [
              56.783305,
              26.752377
            ],
            [
              56.812544,
              26.730368
            ],
            [
              56.82101,
              26.704033
            ],
            [
              56.84864,
              26.638943
            ],
            [
              56.856549,
              26.598225
            ],
            [
              56.861292,
              26.556298
            ],
            [
              56.855137,
              26.514266
            ],
            [
              56.848714,
              26.494598
            ],
            [
              56.841905,
              26.457715
            ],
            [
              56.836386,
              26.386974
            ],
            [
              56.842452,
              26.338257
            ],
            [
              56.84669,
              26.321168
            ],
            [
              56.867469,
              26.265585
            ],
            [
              56.882046,
              26.237733
            ],
            [
              56.912973,
              26.193814
            ],
            [
              56.946853,
              26.129349
            ],
            [
              56.96138,
              26.109538
            ],
            [
              56.960743,
              26.086233
            ],
            [
              56.969853,
              25.998192
            ],
            [
              56.979447,
              25.966798
            ],
            [
              56.994408,
              25.933565
            ],
            [
              57.009541,
              25.907037
            ],
            [
              57.032664,
              25.878635
            ],
            [
              57.068085,
              25.848674
            ],
            [
              57.075171,
              25.815862
            ],
            [
              57.074828,
              25.784617
            ],
            [
              57.08077,
              25.750041
            ],
            [
              57.096587,
              25.7101
            ],
            [
              57.127095,
              25.666325
            ],
            [
              57.142989,
              25.649661
            ],
            [
              57.171635,
              25.626959
            ],
            [
              57.210304,
              25.606047
            ],
            [
              57.239682,
              25.594763
            ],
            [
              57.296545,
              25.582424
            ],
            [
              57.343768,
              25.566613
            ],
            [
              57.678331,
              25.448941
            ],
            [
              57.700941,
              25.442232
            ],
            [
              58,
              25.369358
            ],
            [
              58,
              24.054145
            ],
            [
              58.108063,
              24.072798
            ],
            [
              58.201447,
              24.059631
            ],
            [
              58.721237,
              23.796654
            ],
            [
              58.945084,
              23.636347
            ],
            [
              59.000015,
              23.519293
            ],
            [
              59.111938,
              23.429229
            ],
            [
              59.133224,
              23.367471
            ],
            [
              59.545898,
              22.836946
            ],
            [
              59.919434,
              22.725524
            ],
            [
              60.062256,
              22.451649
            ],
            [
              59.974365,
              22.09582
            ],
            [
              59.490967,
              21.279137
            ],
            [
              59.095459,
              20.992214
            ],
            [
              59.194336,
              20.457896
            ],
            [
              58.721924,
              19.983674
            ],
            [
              58.260498,
              20.148785
            ],
            [
              58.084717,
              20.086889
            ],
            [
              57.963867,
              19.642588
            ],
            [
              58.051758,
              18.968637
            ],
            [
              57.843018,
              18.760713
            ],
            [
              57.293701,
              18.739906
            ],
            [
              56.887207,
              18.5317
            ],
            [
              56.744385,
              18.030975
            ],
            [
              56.557617,
              17.863747
            ],
            [
              56.612549,
              17.465953
            ],
            [
              56.447754,
              17.319176
            ],
            [
              55.50293,
              17.256236
            ],
            [
              55.250244,
              16.909684
            ],
            [
              54.854736,
              16.730907
            ],
            [
              54.481201,
              16.83609
            ],
            [
              53.206787,
              16.467695
            ],
            [
              53.10791,
              16.688817
            ],
            [
              52.437744,
              16.436085
            ],
            [
              52.174072,
              16.088042
            ],
            [
              52.218018,
              15.623037
            ],
            [
              51.306152,
              15.24179
            ],
            [
              49.119873,
              14.594216
            ],
            [
              48.68042,
              14.093957
            ],
            [
              48.010254,
              14.051331
            ],
            [
              47.438965,
              13.710035
            ],
            [
              46.713867,
              13.453737
            ],
            [
              45.933838,
              13.432367
            ],
            [
              45.604248,
              13.368243
            ],
            [
              45.373535,
              13.10088
            ],
            [
              44.87915,
              12.768946
            ],
            [
              44.538574,
              12.801088
            ],
            [
              44.241943,
              12.640338
            ],
            [
              43.516846,
              12.768946
            ],
            [
              43.231201,
              13.282719
            ],
            [
              43.286133,
              13.710035
            ],
            [
              43.000488,
              14.43468
            ],
            [
              42.890625,
              14.944785
            ],
            [
              42.891593,
              15.000536
            ],
            [
              42.884992,
              15.001953
            ],
            [
              42.86854,
              15.028929
            ],
            [
              42.861221,
              15.081457
            ],
            [
              42.87155,
              15.107306
            ],
            [
              42.853422,
              15.145512
            ],
            [
              42.836644,
              15.160641
            ],
            [
              42.788499,
              15.186299
            ],
            [
              42.720644,
              15.207805
            ],
            [
              42.676786,
              15.216337
            ],
            [
              42.665737,
              15.207047
            ],
            [
              42.66519,
              15.18463
            ],
            [
              42.6494,
              15.17927
            ],
            [
              42.622792,
              15.188761
            ],
            [
              42.616222,
              15.210238
            ],
            [
              42.597245,
              15.227457
            ],
            [
              42.600225,
              15.246707
            ],
            [
              42.607544,
              15.253759
            ],
            [
              42.629055,
              15.236826
            ],
            [
              42.651373,
              15.233067
            ],
            [
              42.667635,
              15.234642
            ],
            [
              42.678952,
              15.245445
            ],
            [
              42.678751,
              15.25797
            ],
            [
              42.688276,
              15.2741
            ],
            [
              42.667794,
              15.300733
            ],
            [
              42.668267,
              15.314709
            ],
            [
              42.689524,
              15.331059
            ],
            [
              42.689021,
              15.30902
            ],
            [
              42.719877,
              15.308991
            ],
            [
              42.729275,
              15.294392
            ],
            [
              42.726244,
              15.280757
            ],
            [
              42.745392,
              15.278813
            ],
            [
              42.7683,
              15.265671
            ],
            [
              42.764073,
              15.250941
            ],
            [
              42.774732,
              15.235037
            ],
            [
              42.804063,
              15.268449
            ],
            [
              42.809993,
              15.286143
            ],
            [
              42.795526,
              15.303413
            ],
            [
              42.781424,
              15.306299
            ],
            [
              42.791856,
              15.33095
            ],
            [
              42.793075,
              15.360917
            ],
            [
              42.779154,
              15.362606
            ],
            [
              42.781167,
              15.387516
            ],
            [
              42.758959,
              15.422838
            ],
            [
              42.773388,
              15.442083
            ],
            [
              42.773772,
              15.461619
            ],
            [
              42.760848,
              15.478469
            ],
            [
              42.761998,
              15.489077
            ],
            [
              42.740181,
              15.535541
            ],
            [
              42.723921,
              15.543441
            ],
            [
              42.706834,
              15.544756
            ],
            [
              42.696295,
              15.557715
            ],
            [
              42.705863,
              15.566168
            ],
            [
              42.719459,
              15.606126
            ],
            [
              42.703865,
              15.615704
            ],
            [
              42.703908,
              15.628683
            ],
            [
              42.693704,
              15.644531
            ],
            [
              42.696934,
              15.666279
            ],
            [
              42.708006,
              15.68021
            ],
            [
              42.702895,
              15.695825
            ],
            [
              42.674487,
              15.692994
            ],
            [
              42.683428,
              15.727348
            ],
            [
              42.712857,
              15.738014
            ],
            [
              42.7367,
              15.754928
            ],
            [
              42.746515,
              15.789898
            ],
            [
              42.757182,
              15.789431
            ],
            [
              42.764467,
              15.809782
            ],
            [
              42.778879,
              15.821857
            ],
            [
              42.779369,
              15.837558
            ],
            [
              42.810822,
              15.870119
            ],
            [
              42.817611,
              15.929369
            ],
            [
              42.824721,
              15.947555
            ],
            [
              42.827876,
              15.973263
            ],
            [
              42.82319,
              15.989701
            ],
            [
              42.83424,
              16.018544
            ],
            [
              42.832618,
              16.048543
            ],
            [
              42.836337,
              16.070173
            ],
            [
              42.825673,
              16.090278
            ],
            [
              42.829675,
              16.098818
            ],
            [
              42.818557,
              16.130477
            ],
            [
              42.820879,
              16.147596
            ],
            [
              42.816962,
              16.168046
            ],
            [
              42.825238,
              16.17994
            ],
            [
              42.820267,
              16.19934
            ],
            [
              42.808898,
              16.209687
            ],
            [
              42.810653,
              16.21868
            ],
            [
              42.801925,
              16.235952
            ],
            [
              42.805006,
              16.266372
            ],
            [
              42.796708,
              16.284662
            ],
            [
              42.79242,
              16.314043
            ],
            [
              42.797061,
              16.324101
            ],
            [
              42.784763,
              16.355933
            ],
            [
              42.771724,
              16.364537
            ],
            [
              42.75782,
              16.3829
            ],
            [
              42.76411,
              16.404111
            ],
            [
              42.75018,
              16.404111
            ],
            [
              42.709351,
              16.586185
            ],
            [
              42.681885,
              16.759838
            ],
            [
              42.533569,
              16.886032
            ],
            [
              42.528076,
              17.014768
            ],
            [
              42.344055,
              17.198522
            ],
            [
              42.30835,
              17.42927
            ],
            [
              41.885376,
              17.795766
            ],
            [
              41.646423,
              18.015304
            ],
            [
              41.44043,
              18.39623
            ],
            [
              41.410217,
              18.523888
            ],
            [
              41.32782,
              18.588982
            ],
            [
              41.261902,
              18.604601
            ],
            [
              41.212463,
              18.716496
            ],
            [
              41.234436,
              18.838714
            ],
            [
              41.138306,
              18.955649
            ],
            [
              41.163025,
              19.069906
            ],
            [
              40.957031,
              19.368159
            ],
            [
              40.819702,
              19.580493
            ],
            [
              40.550537,
              19.906219
            ],
            [
              40.259399,
              20.133313
            ],
            [
              39.723816,
              20.385825
            ],
            [
              39.248657,
              20.999907
            ],
            [
              39.105835,
              21.32264
            ],
            [
              39.201965,
              21.396819
            ],
            [
              38.9328,
              22.004175
            ],
            [
              39.105835,
              22.357696
            ],
            [
              39.083862,
              22.59119
            ],
            [
              38.795471,
              23.041825
            ],
            [
              38.452148,
              23.807962
            ],
            [
              37.834167,
              24.189353
            ],
            [
              37.518311,
              24.28953
            ],
            [
              37.177734,
              24.816654
            ],
            [
              37.295837,
              24.978589
            ],
            [
              37.224426,
              25.209911
            ],
            [
              36.664124,
              25.844393
            ],
            [
              36.702576,
              26.03951
            ],
            [
              36.515808,
              26.111053
            ],
            [
              36.216431,
              26.645004
            ],
            [
              35.793457,
              27.134924
            ],
            [
              35.79895,
              27.242421
            ],
            [
              35.540771,
              27.525323
            ],
            [
              35.191956,
              27.994401
            ],
            [
              35.0354,
              28.125283
            ],
            [
              34.572599,
              28.107142
            ],
            [
              34.581667,
              28.125278
            ],
            [
              34.615833,
              28.163056
            ],
            [
              34.639167,
              28.181944
            ],
            [
              34.648889,
              28.201111
            ],
            [
              34.673333,
              28.261111
            ],
            [
              34.725833,
              28.371389
            ],
            [
              34.740495,
              28.408496
            ],
            [
              34.77225,
              28.479194
            ],
            [
              34.804444,
              28.527778
            ],
            [
              34.791667,
              28.578333
            ],
            [
              34.774722,
              28.663056
            ],
            [
              34.777222,
              28.674167
            ],
            [
              34.814722,
              28.776389
            ],
            [
              34.828611,
              28.8325
            ],
            [
              34.819167,
              28.884444
            ],
            [
              34.8425,
              28.973056
            ],
            [
              34.847222,
              29.026944
            ],
            [
              34.866667,
              29.091389
            ],
            [
              34.879167,
              29.144167
            ],
            [
              34.910833,
              29.225556
            ],
            [
              34.928152,
              29.28988
            ],
            [
              34.944167,
              29.323056
            ],
            [
              34.955941,
              29.358107
            ],
            [
              34.885352,
              29.375206
            ],
            [
              34.870391,
              29.343092
            ],
            [
              34.857223,
              29.323811
            ],
            [
              34.833828,
              29.278998
            ],
            [
              34.822921,
              29.219364
            ],
            [
              34.813397,
              29.187093
            ],
            [
              34.790021,
              29.132916
            ],
            [
              34.777728,
              29.111082
            ],
            [
              34.762331,
              29.051298
            ],
            [
              34.765947,
              29.010272
            ],
            [
              34.764989,
              28.983676
            ],
            [
              34.755575,
              28.949587
            ],
            [
              34.735827,
              28.914847
            ],
            [
              34.733462,
              28.874963
            ],
            [
              34.735377,
              28.834805
            ],
            [
              34.723877,
              28.806834
            ],
            [
              34.708025,
              28.719562
            ],
            [
              34.695529,
              28.688774
            ],
            [
              34.68541,
              28.655451
            ],
            [
              34.675466,
              28.57214
            ],
            [
              34.668739,
              28.546558
            ],
            [
              34.650469,
              28.515175
            ],
            [
              34.639015,
              28.471005
            ],
            [
              34.609711,
              28.40873
            ],
            [
              34.586637,
              28.377816
            ],
            [
              34.577412,
              28.349993
            ],
            [
              34.545035,
              28.275078
            ],
            [
              34.545697,
              28.241198
            ],
            [
              34.53487,
              28.187012
            ],
            [
              34.510611,
              28.112453
            ],
            [
              34.489198,
              28.059498
            ],
            [
              34.468191,
              28.029362
            ],
            [
              34.460968,
              27.994721
            ],
            [
              34.462346,
              27.965639
            ],
            [
              34.455895,
              27.921331
            ],
            [
              34.460719,
              27.886485
            ],
            [
              34.477902,
              27.812714
            ],
            [
              34.490288,
              27.773771
            ],
            [
              34.518635,
              27.712881
            ],
            [
              34.679976,
              27.699956
            ],
            [
              34.972715,
              27.635706
            ],
            [
              35.054303,
              27.554242
            ],
            [
              35.087761,
              27.526937
            ],
            [
              35.138867,
              27.492972
            ],
            [
              35.256618,
              27.397765
            ],
            [
              35.332495,
              27.319759
            ],
            [
              35.427437,
              27.15083
            ],
            [
              35.450011,
              27.118653
            ],
            [
              35.506941,
              27.052356
            ],
            [
              35.565938,
              26.892212
            ],
            [
              35.589243,
              26.84795
            ],
            [
              35.688658,
              26.706751
            ],
            [
              35.802155,
              26.548161
            ],
            [
              35.887578,
              26.443209
            ],
            [
              35.9009,
              26.428459
            ],
            [
              36.065462,
              26.262896
            ],
            [
              36.156177,
              26.096299
            ],
            [
              36.178054,
              26.064165
            ],
            [
              36.191494,
              26.049508
            ],
            [
              36.2775,
              25.964366
            ],
            [
              36.308697,
              25.820499
            ],
            [
              36.268046,
              25.698897
            ],
            [
              36.261856,
              25.675333
            ],
            [
              36.258539,
              25.640472
            ],
            [
              36.261951,
              25.605615
            ],
            [
              36.271984,
              25.571822
            ],
            [
              36.288329,
              25.540119
            ],
            [
              36.313508,
              25.503675
            ],
            [
              36.502016,
              25.271866
            ],
            [
              36.519655,
              25.252774
            ],
            [
              36.654446,
              25.124002
            ],
            [
              36.73708,
              24.919201
            ],
            [
              36.783622,
              24.794662
            ],
            [
              36.838075,
              24.635973
            ],
            [
              36.907899,
              24.432477
            ],
            [
              36.952272,
              24.323409
            ],
            [
              36.967748,
              24.293439
            ],
            [
              36.982299,
              24.273311
            ],
            [
              37.011339,
              24.244324
            ],
            [
              37.03786,
              24.2257
            ],
            [
              37.075941,
              24.207552
            ],
            [
              37.10272,
              24.199484
            ],
            [
              37.290909,
              24.154935
            ],
            [
              37.513047,
              24.015835
            ],
            [
              37.709998,
              23.730924
            ],
            [
              37.769608,
              23.656047
            ],
            [
              37.84689,
              23.542199
            ],
            [
              37.876037,
              23.50811
            ],
            [
              37.904037,
              23.485882
            ],
            [
              38.087395,
              23.363719
            ],
            [
              38.302782,
              23.088364
            ],
            [
              38.389072,
              22.978047
            ],
            [
              38.393788,
              22.749911
            ],
            [
              38.397078,
              22.718667
            ],
            [
              38.406883,
              22.684861
            ],
            [
              38.431113,
              22.640938
            ],
            [
              38.635738,
              22.361042
            ],
            [
              38.552533,
              22.114555
            ],
            [
              38.542993,
              22.066327
            ],
            [
              38.530237,
              21.868011
            ],
            [
              38.533157,
              21.820889
            ],
            [
              38.550327,
              21.770432
            ],
            [
              38.631655,
              21.608982
            ],
            [
              38.713073,
              21.367805
            ],
            [
              38.82457,
              21.037502
            ],
            [
              38.837816,
              21.007154
            ],
            [
              38.855233,
              20.980358
            ],
            [
              38.981199,
              20.816923
            ],
            [
              39.077993,
              20.650808
            ],
            [
              39.191577,
              20.400098
            ],
            [
              39.27618,
              20.213348
            ],
            [
              39.287646,
              20.191732
            ],
            [
              39.329753,
              20.131583
            ],
            [
              39.486259,
              19.936377
            ],
            [
              39.586871,
              19.810886
            ],
            [
              39.724235,
              19.639701
            ],
            [
              39.822867,
              19.404965
            ],
            [
              39.889118,
              19.165299
            ],
            [
              39.92685,
              18.994502
            ],
            [
              39.930783,
              18.96922
            ],
            [
              39.945145,
              18.925961
            ],
            [
              39.96187,
              18.89549
            ],
            [
              39.979403,
              18.872488
            ],
            [
              40.014434,
              18.840942
            ],
            [
              40.209601,
              18.701655
            ],
            [
              40.319226,
              18.623419
            ],
            [
              40.460482,
              18.427796
            ],
            [
              40.512655,
              18.176308
            ],
            [
              40.523825,
              18.140403
            ],
            [
              40.589313,
              17.984787
            ],
            [
              40.628702,
              17.908434
            ],
            [
              40.71333,
              17.772291
            ],
            [
              40.840505,
              17.567697
            ],
            [
              40.983027,
              17.287881
            ],
            [
              41.072462,
              17.112287
            ],
            [
              41.19786,
              16.866075
            ],
            [
              41.215159,
              16.822666
            ],
            [
              41.224528,
              16.805207
            ],
            [
              41.314936,
              16.65615
            ],
            [
              41.338714,
              16.624474
            ],
            [
              41.412349,
              16.544148
            ],
            [
              41.493269,
              16.43161
            ],
            [
              41.515635,
              16.405523
            ],
            [
              41.544519,
              16.381811
            ],
            [
              41.679627,
              16.29
            ],
            [
              41.783333,
              16.29
            ],
            [
              41.92088,
              16.332806
            ],
            [
              41.918634,
              16.336008
            ],
            [
              41.986999,
              16.348309
            ],
            [
              41.984337,
              16.327785
            ],
            [
              41.983409,
              16.282602
            ],
            [
              41.989856,
              16.239293
            ],
            [
              41.995878,
              16.220499
            ],
            [
              42.011224,
              16.188757
            ],
            [
              42.029063,
              16.162656
            ],
            [
              42.06566,
              16.125387
            ],
            [
              42.069539,
              16.099236
            ],
            [
              42.077625,
              16.071905
            ],
            [
              42.096998,
              16.033691
            ],
            [
              42.124028,
              16.000355
            ],
            [
              42.102481,
              15.968831
            ],
            [
              42.0901,
              15.942124
            ],
            [
              42.080755,
              15.908281
            ],
            [
              42.078062,
              15.886933
            ],
            [
              42.078465,
              15.851465
            ],
            [
              42.084825,
              15.818158
            ],
            [
              42.095655,
              15.788922
            ],
            [
              42.082564,
              15.750507
            ],
            [
              42.075605,
              15.697098
            ],
            [
              42.078473,
              15.651294
            ],
            [
              42.087856,
              15.617459
            ],
            [
              42.103155,
              15.585715
            ],
            [
              42.123835,
              15.555121
            ],
            [
              42.151628,
              15.52317
            ],
            [
              42.15797,
              15.481562
            ],
            [
              42.163969,
              15.462765
            ],
            [
              42.193317,
              15.401394
            ],
            [
              42.223139,
              15.358918
            ],
            [
              42.259819,
              15.323509
            ],
            [
              42.289098,
              15.302711
            ],
            [
              42.327763,
              15.283334
            ],
            [
              42.333067,
              15.255415
            ],
            [
              42.347873,
              15.216612
            ],
            [
              42.360749,
              15.193794
            ],
            [
              42.315352,
              15.234258
            ],
            [
              42.297958,
              15.271914
            ],
            [
              42.274215,
              15.30462
            ],
            [
              42.25384,
              15.325059
            ],
            [
              42.217829,
              15.350479
            ],
            [
              42.191459,
              15.362922
            ],
            [
              42.141555,
              15.375887
            ],
            [
              42.105503,
              15.377799
            ],
            [
              42.052155,
              15.369245
            ],
            [
              42.014832,
              15.354695
            ],
            [
              41.976033,
              15.329723
            ],
            [
              41.946244,
              15.299797
            ],
            [
              41.929843,
              15.276237
            ],
            [
              41.908795,
              15.227791
            ],
            [
              41.890685,
              15.159712
            ],
            [
              41.887566,
              15.124809
            ],
            [
              41.892045,
              15.08341
            ],
            [
              41.900091,
              15.056073
            ],
            [
              41.915625,
              15.023718
            ],
            [
              41.9322,
              15
            ],
            [
              40.456418,
              15
            ],
            [
              41.099854,
              14.657997
            ],
            [
              41.671143,
              13.955392
            ],
            [
              42.242432,
              13.624633
            ],
            [
              42.39624,
              13.229251
            ],
            [
              42.572021,
              13.197165
            ],
            [
              42.688065,
              13.062757
            ],
            [
              42.867279,
              13.047372
            ],
            [
              43.076019,
              12.839251
            ],
            [
              43.132324,
              12.704651
            ],
            [
              43.294373,
              12.79841
            ],
            [
              43.266907,
              12.685894
            ],
            [
              43.308105,
              12.605496
            ],
            [
              43.428955,
              12.551883
            ],
            [
              43.634949,
              12.517028
            ],
            [
              43.656921,
              12.433894
            ],
            [
              43.599243,
              12.286334
            ],
            [
              43.626709,
              12.068867
            ],
            [
              43.500366,
              11.837783
            ],
            [
              43.406982,
              11.789391
            ],
            [
              43.431702,
              11.722167
            ],
            [
              43.621216,
              11.665686
            ],
            [
              43.728333,
              11.331946
            ],
            [
              43.90686,
              11.003208
            ],
            [
              44.401245,
              10.60122
            ],
            [
              44.870911,
              10.639014
            ],
            [
              45.332336,
              10.865676
            ],
            [
              45.791016,
              11.086775
            ],
            [
              46.054687,
              10.968157
            ],
            [
              46.263428,
              11.000512
            ],
            [
              46.428223,
              10.90883
            ],
            [
              46.983032,
              11.18918
            ],
            [
              47.076416,
              11.356182
            ],
            [
              47.241211,
              11.442339
            ],
            [
              47.70813,
              11.323867
            ],
            [
              48.059692,
              11.334639
            ],
            [
              48.262939,
              11.458491
            ],
            [
              48.658447,
              11.530488
            ],
            [
              48.937225,
              11.445031
            ],
            [
              48.922119,
              11.245756
            ],
            [
              48.960571,
              11.253837
            ],
            [
              50.443726,
              11.706031
            ],
            [
              50.553589,
              11.910354
            ],
            [
              50.784302,
              11.996338
            ],
            [
              51.278687,
              11.835094
            ],
            [
              51.097412,
              11.243062
            ],
            [
              51.124878,
              10.509417
            ],
            [
              50.916138,
              10.314919
            ],
            [
              50.861206,
              9.45448
            ],
            [
              50.663452,
              9.085824
            ],
            [
              50.454712,
              8.857934
            ],
            [
              50.141602,
              8.189742
            ],
            [
              49.844971,
              7.955877
            ],
            [
              49.833984,
              7.776309
            ],
            [
              49.185791,
              6.72462
            ],
            [
              49.037476,
              6.146016
            ],
            [
              47.988281,
              4.510714
            ],
            [
              46.005249,
              2.427252
            ],
            [
              44.609985,
              1.614776
            ],
            [
              43.59375,
              0.758035
            ],
            [
              42.434692,
              -0.455928
            ],
            [
              41.5448,
              -1.642231
            ],
            [
              41.709595,
              -1.801461
            ],
            [
              40.418701,
              -3.085666
            ],
            [
              40.358276,
              -3.348922
            ],
            [
              39.671631,
              -4.65308
            ],
            [
              39.946289,
              -4.65308
            ],
            [
              40.089111,
              -4.97056
            ],
            [
              39.814453,
              -6.315299
            ],
            [
              40.12207,
              -6.83917
            ],
            [
              40.100098,
              -7.798079
            ],
            [
              39.814453,
              -8.624472
            ],
            [
              40.023193,
              -9.687398
            ],
            [
              40.638428,
              -10.16356
            ],
            [
              40.935059,
              -10.951978
            ],
            [
              40.847168,
              -11.716788
            ],
            [
              40.847168,
              -12
            ],
            [
              65,
              -12
            ]
          ]
        ]
      },
      "properties": {
        "name": "#0"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              18.149414,
              30.812629
            ],
            [
              17.182617,
              31.128199
            ],
            [
              16.627808,
              31.226894
            ],
            [
              16.100464,
              31.25977
            ],
            [
              15.69397,
              31.43335
            ],
            [
              15.3479,
              31.961484
            ],
            [
              15.353394,
              32.175612
            ],
            [
              15.199585,
              32.407792
            ],
            [
              14.644775,
              32.458791
            ],
            [
              14.61016,
              32.5
            ],
            [
              14.582794,
              32.5
            ],
            [
              14.433058,
              32.553625
            ],
            [
              14.337511,
              32.639178
            ],
            [
              14.251135,
              32.6907
            ],
            [
              13.945561,
              32.772236
            ],
            [
              13.803064,
              32.802508
            ],
            [
              13.535508,
              32.81994
            ],
            [
              13.393999,
              32.893441
            ],
            [
              13.38134,
              32.897585
            ],
            [
              13.212681,
              32.921089
            ],
            [
              12.997506,
              32.836392
            ],
            [
              12.688075,
              32.793892
            ],
            [
              12.438617,
              32.820758
            ],
            [
              12.191819,
              32.888426
            ],
            [
              11.908339,
              33.046111
            ],
            [
              11.688894,
              33.133072
            ],
            [
              11.629736,
              33.133072
            ],
            [
              11.561389,
              33.175008
            ],
            [
              11.667586,
              33.35458
            ],
            [
              11.708744,
              33.332888
            ],
            [
              11.740594,
              33.328827
            ],
            [
              11.790647,
              33.314439
            ],
            [
              11.873206,
              33.281709
            ],
            [
              11.910314,
              33.273129
            ],
            [
              11.948005,
              33.258327
            ],
            [
              12.055114,
              33.204841
            ],
            [
              12.296159,
              33.070654
            ],
            [
              12.490867,
              33.017288
            ],
            [
              12.683942,
              32.996494
            ],
            [
              12.926711,
              33.029839
            ],
            [
              13.116624,
              33.104586
            ],
            [
              13.161032,
              33.116844
            ],
            [
              13.222914,
              33.121508
            ],
            [
              13.253892,
              33.118607
            ],
            [
              13.436502,
              33.093533
            ],
            [
              13.484734,
              33.080485
            ],
            [
              13.610523,
              33.016179
            ],
            [
              13.829006,
              33.001801
            ],
            [
              13.859661,
              32.997231
            ],
            [
              13.974078,
              32.972884
            ],
            [
              14.034272,
              32.958867
            ],
            [
              14.273153,
              32.894728
            ],
            [
              14.317244,
              32.8841
            ],
            [
              14.358964,
              32.869352
            ],
            [
              14.385244,
              32.856161
            ],
            [
              14.473142,
              32.803705
            ],
            [
              14.510035,
              32.776797
            ],
            [
              14.57125,
              32.721893
            ],
            [
              14.630856,
              32.700539
            ],
            [
              20.213516,
              32.700539
            ],
            [
              20.422198,
              32.700507
            ],
            [
              20.446033,
              32.71442
            ],
            [
              20.561449,
              32.770446
            ],
            [
              20.835649,
              32.894563
            ],
            [
              20.962625,
              32.943721
            ],
            [
              21.015072,
              32.958971
            ],
            [
              21.055462,
              32.967543
            ],
            [
              21.10716,
              32.972318
            ],
            [
              21.33417,
              32.989585
            ],
            [
              21.468917,
              33.075695
            ],
            [
              21.509178,
              33.099806
            ],
            [
              21.546801,
              33.114608
            ],
            [
              21.58333,
              33.123324
            ],
            [
              21.672819,
              33.138738
            ],
            [
              21.700064,
              33.14091
            ],
            [
              21.756719,
              33.138284
            ],
            [
              21.939085,
              33.10745
            ],
            [
              22.036869,
              33.124392
            ],
            [
              22.072941,
              33.132113
            ],
            [
              22.119209,
              33.137794
            ],
            [
              22.150202,
              33.139088
            ],
            [
              22.187201,
              33.135764
            ],
            [
              22.240134,
              33.122762
            ],
            [
              22.28412,
              33.105699
            ],
            [
              22.334296,
              33.077694
            ],
            [
              22.411501,
              33.0706
            ],
            [
              22.434593,
              33.066812
            ],
            [
              22.561345,
              33.034017
            ],
            [
              22.589345,
              33.02502
            ],
            [
              22.756485,
              32.960856
            ],
            [
              23.025049,
              32.857705
            ],
            [
              23.075386,
              32.852339
            ],
            [
              23.171783,
              32.828387
            ],
            [
              23.210355,
              32.815691
            ],
            [
              23.245716,
              32.797523
            ],
            [
              23.270795,
              32.780676
            ],
            [
              23.300004,
              32.75592
            ],
            [
              23.333584,
              32.714388
            ],
            [
              23.35098,
              32.682678
            ],
            [
              23.36159,
              32.648894
            ],
            [
              23.364988,
              32.608346
            ],
            [
              23.363087,
              32.582479
            ],
            [
              23.375137,
              32.567887
            ],
            [
              23.450055,
              32.463772
            ],
            [
              23.464918,
              32.431166
            ],
            [
              23.479077,
              32.386379
            ],
            [
              23.500371,
              32.37938
            ],
            [
              23.680336,
              32.382675
            ],
            [
              23.742359,
              32.377465
            ],
            [
              23.776607,
              32.372156
            ],
            [
              23.830758,
              32.359966
            ],
            [
              24.059742,
              32.292503
            ],
            [
              24.12179,
              32.264502
            ],
            [
              24.15456,
              32.24489
            ],
            [
              24.200313,
              32.208606
            ],
            [
              24.269767,
              32.207462
            ],
            [
              24.343664,
              32.202771
            ],
            [
              24.62188,
              32.219623
            ],
            [
              24.708951,
              32.223636
            ],
            [
              24.740377,
              32.222416
            ],
            [
              24.804678,
              32.215927
            ],
            [
              24.829748,
              32.210938
            ],
            [
              24.930461,
              32.181825
            ],
            [
              25.0175,
              32.169512
            ],
            [
              25.054676,
              32.161559
            ],
            [
              25.112875,
              32.137802
            ],
            [
              25.146498,
              32.117714
            ],
            [
              25.199043,
              32.079867
            ],
            [
              25.226061,
              32.053546
            ],
            [
              25.247288,
              32.023625
            ],
            [
              25.343339,
              31.804823
            ],
            [
              25.372709,
              31.735393
            ],
            [
              25.37535,
              31.719406
            ],
            [
              25.17157,
              31.675139
            ],
            [
              25.145498,
              31.676622
            ],
            [
              25.129488,
              31.720815
            ],
            [
              25.035025,
              31.935303
            ],
            [
              24.995022,
              31.964169
            ],
            [
              24.978892,
              31.971669
            ],
            [
              24.872789,
              31.986678
            ],
            [
              24.763764,
              32.018295
            ],
            [
              24.682797,
              32.022239
            ],
            [
              24.346661,
              32.001971
            ],
            [
              24.109322,
              32.011482
            ],
            [
              24.103721,
              32.01224
            ],
            [
              24.010787,
              32.084192
            ],
            [
              23.973136,
              32.10562
            ],
            [
              23.775342,
              32.163798
            ],
            [
              23.717225,
              32.178056
            ],
            [
              23.666669,
              32.181669
            ],
            [
              23.458366,
              32.178153
            ],
            [
              23.286464,
              32.234637
            ],
            [
              23.284107,
              32.236325
            ],
            [
              23.236488,
              32.375938
            ],
            [
              23.17335,
              32.463075
            ],
            [
              23.107988,
              32.53256
            ],
            [
              23.128153,
              32.614287
            ],
            [
              23.107233,
              32.634189
            ],
            [
              23.029645,
              32.654525
            ],
            [
              22.95925,
              32.662778
            ],
            [
              22.490847,
              32.842503
            ],
            [
              22.377244,
              32.872231
            ],
            [
              22.317233,
              32.877231
            ],
            [
              22.267093,
              32.874408
            ],
            [
              22.175847,
              32.925835
            ],
            [
              22.145003,
              32.938611
            ],
            [
              21.939744,
              32.902781
            ],
            [
              21.715556,
              32.940847
            ],
            [
              21.627581,
              32.925414
            ],
            [
              21.422569,
              32.794966
            ],
            [
              21.102363,
              32.77061
            ],
            [
              21.060853,
              32.761133
            ],
            [
              20.947792,
              32.717803
            ],
            [
              20.673333,
              32.593636
            ],
            [
              20.5739,
              32.545006
            ],
            [
              20.500889,
              32.5
            ],
            [
              20.493733,
              32.5
            ],
            [
              20.500488,
              32.481963
            ],
            [
              20.061035,
              32.161663
            ],
            [
              19.945679,
              31.970804
            ],
            [
              19.929199,
              31.723495
            ],
            [
              20.01709,
              31.395847
            ],
            [
              20.181885,
              31.147006
            ],
            [
              19.709473,
              30.462879
            ],
            [
              19.13269,
              30.2733
            ],
            [
              18.792114,
              30.358656
            ],
            [
              18.149414,
              30.812629
            ]
          ]
        ]
      },
      "properties": {
        "name": "#1"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              49.787292,
              26.909825
            ],
            [
              49.96582,
              26.838776
            ],
            [
              50.111389,
              26.676913
            ],
            [
              50.004272,
              26.68673
            ],
            [
              50.155334,
              26.463197
            ],
            [
              50.202026,
              26.504989
            ],
            [
              50.232239,
              26.342653
            ],
            [
              50.216789,
              26.252316
            ],
            [
              50.221396,
              26.251679
            ],
            [
              50.221079,
              26.191733
            ],
            [
              50.19697,
              26.161697
            ],
            [
              50.183704,
              26.174326
            ],
            [
              50.167944,
              26.203167
            ],
            [
              50.164386,
              26.147375
            ],
            [
              50.16891,
              26.136365
            ],
            [
              50.160437,
              26.108703
            ],
            [
              50.162598,
              26.092783
            ],
            [
              50.149847,
              26.068421
            ],
            [
              50.156604,
              26.050725
            ],
            [
              50.154797,
              26.038166
            ],
            [
              50.137568,
              26.030275
            ],
            [
              50.132717,
              26.043666
            ],
            [
              50.119424,
              26.056915
            ],
            [
              50.120986,
              26.078195
            ],
            [
              50.094733,
              26.120566
            ],
            [
              50.07975,
              26.125329
            ],
            [
              50.07629,
              26.141287
            ],
            [
              50.059315,
              26.185207
            ],
            [
              50.033623,
              26.201451
            ],
            [
              50.021567,
              26.191406
            ],
            [
              50.022457,
              26.180935
            ],
            [
              50.010343,
              26.166466
            ],
            [
              50.006286,
              26.14558
            ],
            [
              49.98806,
              26.115868
            ],
            [
              49.990592,
              26.102968
            ],
            [
              50.014358,
              26.084974
            ],
            [
              49.999553,
              26.068433
            ],
            [
              50.001202,
              26.015206
            ],
            [
              49.996665,
              26.007377
            ],
            [
              50.006684,
              25.982068
            ],
            [
              50.041569,
              26.008558
            ],
            [
              50.060804,
              26.001076
            ],
            [
              50.064919,
              25.989249
            ],
            [
              50.07997,
              25.985243
            ],
            [
              50.102663,
              25.987669
            ],
            [
              50.119603,
              25.964347
            ],
            [
              50.114474,
              25.94874
            ],
            [
              50.122613,
              25.929966
            ],
            [
              50.112974,
              25.926262
            ],
            [
              50.102398,
              25.89964
            ],
            [
              50.117597,
              25.867614
            ],
            [
              50.135103,
              25.839844
            ],
            [
              50.135384,
              25.8307
            ],
            [
              50.161591,
              25.798419
            ],
            [
              50.192209,
              25.752932
            ],
            [
              50.218904,
              25.741799
            ],
            [
              50.229107,
              25.722233
            ],
            [
              50.235306,
              25.693494
            ],
            [
              50.260581,
              25.673767
            ],
            [
              50.265904,
              25.655148
            ],
            [
              50.257676,
              25.647179
            ],
            [
              50.243358,
              25.66279
            ],
            [
              50.234964,
              25.683212
            ],
            [
              50.221859,
              25.680675
            ],
            [
              50.186716,
              25.705873
            ],
            [
              50.175901,
              25.707167
            ],
            [
              50.164478,
              25.730188
            ],
            [
              50.143271,
              25.725934
            ],
            [
              50.156186,
              25.694507
            ],
            [
              50.195678,
              25.662328
            ],
            [
              50.196725,
              25.679019
            ],
            [
              50.211666,
              25.680193
            ],
            [
              50.211036,
              25.665297
            ],
            [
              50.220419,
              25.650539
            ],
            [
              50.211049,
              25.637432
            ],
            [
              50.231954,
              25.603586
            ],
            [
              50.256529,
              25.589699
            ],
            [
              50.260067,
              25.573238
            ],
            [
              50.27317,
              25.555698
            ],
            [
              50.309471,
              25.543938
            ],
            [
              50.303419,
              25.532923
            ],
            [
              50.312001,
              25.515139
            ],
            [
              50.332773,
              25.502602
            ],
            [
              50.3471,
              25.474697
            ],
            [
              50.36199,
              25.466378
            ],
            [
              50.371011,
              25.448283
            ],
            [
              50.388554,
              25.443679
            ],
            [
              50.393798,
              25.420237
            ],
            [
              50.406437,
              25.424526
            ],
            [
              50.395428,
              25.454305
            ],
            [
              50.382303,
              25.463283
            ],
            [
              50.38146,
              25.475839
            ],
            [
              50.360991,
              25.502699
            ],
            [
              50.389356,
              25.505721
            ],
            [
              50.395841,
              25.496235
            ],
            [
              50.385867,
              25.485976
            ],
            [
              50.430993,
              25.443837
            ],
            [
              50.449928,
              25.443072
            ],
            [
              50.486368,
              25.413139
            ],
            [
              50.494897,
              25.396283
            ],
            [
              50.492851,
              25.381904
            ],
            [
              50.502342,
              25.37406
            ],
            [
              50.509288,
              25.344446
            ],
            [
              50.521908,
              25.329381
            ],
            [
              50.530991,
              25.298304
            ],
            [
              50.532192,
              25.269917
            ],
            [
              50.519964,
              25.249582
            ],
            [
              50.521398,
              25.234167
            ],
            [
              50.532851,
              25.214039
            ],
            [
              50.551944,
              25.19889
            ],
            [
              50.559646,
              25.167801
            ],
            [
              50.557447,
              25.150329
            ],
            [
              50.547168,
              25.139705
            ],
            [
              50.557344,
              25.111702
            ],
            [
              50.560999,
              25.078823
            ],
            [
              50.569741,
              25.063065
            ],
            [
              50.580832,
              25.071243
            ],
            [
              50.611472,
              25.038892
            ],
            [
              50.630307,
              25.001613
            ],
            [
              50.654805,
              24.978119
            ],
            [
              50.661513,
              24.95938
            ],
            [
              50.674815,
              24.943206
            ],
            [
              50.67328,
              24.910854
            ],
            [
              50.686395,
              24.889917
            ],
            [
              50.70431,
              24.891118
            ],
            [
              50.725974,
              24.874546
            ],
            [
              50.736024,
              24.828712
            ],
            [
              50.747924,
              24.818499
            ],
            [
              50.747692,
              24.783403
            ],
            [
              50.753001,
              24.763414
            ],
            [
              50.763588,
              24.749655
            ],
            [
              50.766814,
              24.720638
            ],
            [
              50.791406,
              24.746759
            ],
            [
              50.811698,
              24.744459
            ],
            [
              50.808357,
              24.782546
            ],
            [
              50.814171,
              24.797583
            ],
            [
              50.801936,
              24.818362
            ],
            [
              50.793132,
              24.868237
            ],
            [
              50.785948,
              24.893485
            ],
            [
              50.782847,
              24.931399
            ],
            [
              50.77007,
              24.955735
            ],
            [
              50.751338,
              24.97883
            ],
            [
              50.723029,
              25.007271
            ],
            [
              50.715127,
              25.039906
            ],
            [
              50.691977,
              25.072851
            ],
            [
              50.675124,
              25.110051
            ],
            [
              50.665951,
              25.146303
            ],
            [
              50.654921,
              25.235521
            ],
            [
              50.647318,
              25.262406
            ],
            [
              50.648098,
              25.312498
            ],
            [
              50.638466,
              25.363388
            ],
            [
              50.620921,
              25.425741
            ],
            [
              50.615871,
              25.476953
            ],
            [
              50.570485,
              25.55352
            ],
            [
              50.564526,
              25.577647
            ],
            [
              50.529874,
              25.595551
            ],
            [
              50.435487,
              25.6825
            ],
            [
              50.41755,
              25.707661
            ],
            [
              50.366864,
              25.819019
            ],
            [
              50.301839,
              25.883758
            ],
            [
              50.293177,
              25.952568
            ],
            [
              50.269625,
              26.080583
            ],
            [
              50.314538,
              26.171745
            ],
            [
              50.318832,
              26.254082
            ],
            [
              50.314435,
              26.254154
            ],
            [
              50.317788,
              26.272197
            ],
            [
              50.319269,
              26.256428
            ],
            [
              50.340713,
              26.371514
            ],
            [
              50.371808,
              26.406648
            ],
            [
              50.3875,
              26.53
            ],
            [
              50.488671,
              26.584323
            ],
            [
              50.487204,
              26.59004
            ],
            [
              50.461665,
              26.80778
            ],
            [
              50.437816,
              27.011143
            ],
            [
              50.425627,
              27.058567
            ],
            [
              50.409155,
              27.090287
            ],
            [
              50.394547,
              27.110164
            ],
            [
              50.280296,
              27.247142
            ],
            [
              50.105446,
              27.456777
            ],
            [
              50.073388,
              27.502116
            ],
            [
              50.045679,
              27.526868
            ],
            [
              50.014645,
              27.546382
            ],
            [
              50.037832,
              27.594542
            ],
            [
              50.045013,
              27.627882
            ],
            [
              50.046191,
              27.6583
            ],
            [
              50.054798,
              27.687939
            ],
            [
              50.05795,
              27.733633
            ],
            [
              50.05352,
              27.763995
            ],
            [
              50.044776,
              27.791435
            ],
            [
              50.021063,
              27.83341
            ],
            [
              50.0039,
              27.854027
            ],
            [
              49.976103,
              27.878778
            ],
            [
              49.950256,
              27.895443
            ],
            [
              49.91515,
              27.911281
            ],
            [
              49.869303,
              27.922926
            ],
            [
              49.827623,
              27.925953
            ],
            [
              49.778787,
              27.920714
            ],
            [
              49.745922,
              27.911491
            ],
            [
              49.717189,
              27.899068
            ],
            [
              49.677111,
              27.874487
            ],
            [
              49.649315,
              27.849735
            ],
            [
              49.626786,
              27.821065
            ],
            [
              49.602529,
              27.777965
            ],
            [
              49.522256,
              27.847197
            ],
            [
              49.356462,
              28.039532
            ],
            [
              49.281424,
              28.126584
            ],
            [
              49.15901,
              28.303538
            ],
            [
              49.143501,
              28.323191
            ],
            [
              49.120878,
              28.344978
            ],
            [
              49.099791,
              28.360496
            ],
            [
              48.858653,
              28.516915
            ],
            [
              48.696801,
              28.621904
            ],
            [
              48.687408,
              28.644284
            ],
            [
              48.670019,
              28.673427
            ],
            [
              48.663889,
              28.665556
            ],
            [
              48.589444,
              28.638889
            ],
            [
              48.47865,
              28.564595
            ],
            [
              48.479319,
              28.562913
            ],
            [
              48.435974,
              28.538687
            ],
            [
              48.496399,
              28.471106
            ],
            [
              48.521118,
              28.299544
            ],
            [
              48.625488,
              28.205188
            ],
            [
              48.617249,
              28.115594
            ],
            [
              48.869934,
              27.83179
            ],
            [
              48.850708,
              27.678664
            ],
            [
              49.196777,
              27.544806
            ],
            [
              49.32312,
              27.276602
            ],
            [
              49.787292,
              26.909825
            ]
          ]
        ]
      },
      "properties": {
        "name": "#2"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              2.677148,
              3
            ],
            [
              6.963089,
              3
            ],
            [
              7.121514,
              3.042153
            ],
            [
              7.819528,
              3.645111
            ],
            [
              7.819444,
              3.710278
            ],
            [
              8.324795,
              4.060917
            ],
            [
              8.407,
              4.522222
            ],
            [
              8.414777,
              4.534362
            ],
            [
              6.093292,
              4.242334
            ],
            [
              5.692291,
              4.488809
            ],
            [
              5.450592,
              4.844681
            ],
            [
              5.29953,
              5.349419
            ],
            [
              4.573059,
              6.285269
            ],
            [
              4.075928,
              6.406743
            ],
            [
              2.860565,
              6.383542
            ],
            [
              2.042084,
              6.301649
            ],
            [
              1.428223,
              6.176054
            ],
            [
              1.198128,
              6.101973
            ],
            [
              1.210002,
              6.088486
            ],
            [
              1.322502,
              5.795625
            ],
            [
              2.075311,
              3
            ],
            [
              2.507776,
              3
            ],
            [
              2.667507,
              3.013626
            ],
            [
              2.677148,
              3
            ]
          ]
        ]
      },
      "properties": {
        "name": "#3"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              35.143567,
              33.126102
            ],
            [
              35.116424,
              33.115607
            ],
            [
              35.103783,
              33.09507
            ],
            [
              35.105613,
              33.076633
            ],
            [
              35.100967,
              33.050444
            ],
            [
              35.088112,
              33.013722
            ],
            [
              35.066454,
              32.918636
            ],
            [
              35.082482,
              32.906111
            ],
            [
              35.077359,
              32.879297
            ],
            [
              35.059492,
              32.842788
            ],
            [
              35.042266,
              32.822845
            ],
            [
              35.015454,
              32.812451
            ],
            [
              34.981682,
              32.83672
            ],
            [
              34.95604,
              32.826613
            ],
            [
              34.947267,
              32.737092
            ],
            [
              34.936993,
              32.707222
            ],
            [
              34.928212,
              32.701196
            ],
            [
              34.924488,
              32.657073
            ],
            [
              34.921195,
              32.651545
            ],
            [
              34.91035,
              32.577169
            ],
            [
              34.900445,
              32.553324
            ],
            [
              34.899179,
              32.534297
            ],
            [
              34.888616,
              32.502046
            ],
            [
              34.885937,
              32.47824
            ],
            [
              34.87196,
              32.422874
            ],
            [
              34.859611,
              32.397234
            ],
            [
              34.859781,
              32.383557
            ],
            [
              34.829364,
              32.269108
            ],
            [
              34.813988,
              32.220301
            ],
            [
              34.804688,
              32.200893
            ],
            [
              34.78386,
              32.129133
            ],
            [
              34.753798,
              32.057171
            ],
            [
              34.746503,
              32.052899
            ],
            [
              34.718606,
              31.970163
            ],
            [
              34.705519,
              31.941501
            ],
            [
              34.688699,
              31.918179
            ],
            [
              34.671381,
              31.875351
            ],
            [
              34.649921,
              31.830309
            ],
            [
              34.638244,
              31.816406
            ],
            [
              34.626056,
              31.791768
            ],
            [
              34.589838,
              31.730826
            ],
            [
              34.55827,
              31.684172
            ],
            [
              34.519028,
              31.63247
            ],
            [
              34.512575,
              31.626961
            ],
            [
              34.472704,
              31.572656
            ],
            [
              34.296129,
              31.708907
            ],
            [
              34.323494,
              31.750801
            ],
            [
              34.369248,
              31.806352
            ],
            [
              34.402801,
              31.859307
            ],
            [
              34.420025,
              31.911293
            ],
            [
              34.438883,
              31.942334
            ],
            [
              34.46055,
              31.967019
            ],
            [
              34.47539,
              32.00276
            ],
            [
              34.494359,
              32.031686
            ],
            [
              34.523356,
              32.117169
            ],
            [
              34.557179,
              32.189485
            ],
            [
              34.562994,
              32.21495
            ],
            [
              34.587528,
              32.279792
            ],
            [
              34.60648,
              32.34415
            ],
            [
              34.614364,
              32.365129
            ],
            [
              34.631641,
              32.450413
            ],
            [
              34.630511,
              32.474199
            ],
            [
              34.634911,
              32.508957
            ],
            [
              34.646373,
              32.542537
            ],
            [
              34.662456,
              32.570889
            ],
            [
              34.673322,
              32.610435
            ],
            [
              34.688877,
              32.691559
            ],
            [
              34.689876,
              32.712149
            ],
            [
              34.696968,
              32.746587
            ],
            [
              34.714754,
              32.78877
            ],
            [
              34.720499,
              32.859541
            ],
            [
              34.731133,
              32.893324
            ],
            [
              34.74857,
              32.925034
            ],
            [
              34.780664,
              32.961966
            ],
            [
              34.811196,
              32.98562
            ],
            [
              34.842343,
              33.003063
            ],
            [
              34.86554,
              33.08897
            ],
            [
              34.865983,
              33.107212
            ],
            [
              34.865976,
              33.107212
            ],
            [
              34.876567,
              33.156317
            ],
            [
              34.893403,
              33.19423
            ],
            [
              34.91064,
              33.219412
            ],
            [
              34.951312,
              33.260236
            ],
            [
              34.954901,
              33.307957
            ],
            [
              34.965608,
              33.341728
            ],
            [
              34.983148,
              33.37342
            ],
            [
              35.013574,
              33.408862
            ],
            [
              35.033968,
              33.470931
            ],
            [
              35.053036,
              33.515346
            ],
            [
              35.06677,
              33.541204
            ],
            [
              35.089496,
              33.573892
            ],
            [
              35.131127,
              33.613674
            ],
            [
              35.145912,
              33.654397
            ],
            [
              35.160812,
              33.678894
            ],
            [
              35.16654,
              33.700938
            ],
            [
              35.18996,
              33.756925
            ],
            [
              35.218063,
              33.803232
            ],
            [
              35.234723,
              33.840086
            ],
            [
              35.227308,
              33.878544
            ],
            [
              35.226892,
              33.904766
            ],
            [
              35.234226,
              33.94537
            ],
            [
              35.246521,
              33.976266
            ],
            [
              35.264937,
              34.006226
            ],
            [
              35.293601,
              34.03745
            ],
            [
              35.3146,
              34.054066
            ],
            [
              35.357357,
              34.078549
            ],
            [
              35.392671,
              34.09167
            ],
            [
              35.399393,
              34.108798
            ],
            [
              35.393426,
              34.129805
            ],
            [
              35.388701,
              34.174192
            ],
            [
              35.39508,
              34.227215
            ],
            [
              35.410182,
              34.271707
            ],
            [
              35.410986,
              34.300703
            ],
            [
              35.418655,
              34.335063
            ],
            [
              35.438157,
              34.375605
            ],
            [
              35.480569,
              34.426788
            ],
            [
              35.509516,
              34.454128
            ],
            [
              35.528889,
              34.480169
            ],
            [
              35.531771,
              34.529881
            ],
            [
              35.54263,
              34.563645
            ],
            [
              35.560419,
              34.595332
            ],
            [
              35.584602,
              34.623977
            ],
            [
              35.614447,
              34.648708
            ],
            [
              35.649047,
              34.668771
            ],
            [
              35.697483,
              34.686375
            ],
            [
              35.692326,
              34.70611
            ],
            [
              35.67048,
              34.724889
            ],
            [
              35.650316,
              34.747789
            ],
            [
              35.633134,
              34.774886
            ],
            [
              35.619869,
              34.806793
            ],
            [
              35.612781,
              34.842916
            ],
            [
              35.613617,
              34.878753
            ],
            [
              35.610739,
              34.906696
            ],
            [
              35.616909,
              34.955039
            ],
            [
              35.628295,
              34.98482
            ],
            [
              35.642343,
              35.040665
            ],
            [
              35.644284,
              35.12538
            ],
            [
              35.652485,
              35.160884
            ],
            [
              35.667011,
              35.192554
            ],
            [
              35.685382,
              35.220832
            ],
            [
              35.675949,
              35.274872
            ],
            [
              35.675735,
              35.313581
            ],
            [
              35.640287,
              35.330241
            ],
            [
              35.605165,
              35.352031
            ],
            [
              35.572442,
              35.378895
            ],
            [
              35.547906,
              35.407496
            ],
            [
              35.534174,
              35.430073
            ],
            [
              35.521998,
              35.459061
            ],
            [
              35.497679,
              35.495244
            ],
            [
              35.482096,
              35.526992
            ],
            [
              35.475153,
              35.550475
            ],
            [
              35.471346,
              35.585277
            ],
            [
              35.472483,
              35.6048
            ],
            [
              35.486135,
              35.654397
            ],
            [
              35.50416,
              35.686079
            ],
            [
              35.528638,
              35.714692
            ],
            [
              35.545249,
              35.754424
            ],
            [
              35.567376,
              35.787032
            ],
            [
              35.557816,
              35.817178
            ],
            [
              35.553996,
              35.851979
            ],
            [
              35.555831,
              35.877701
            ],
            [
              35.563049,
              35.907501
            ],
            [
              35.582923,
              35.948034
            ],
            [
              35.601532,
              35.972175
            ],
            [
              35.636711,
              36.003929
            ],
            [
              35.666534,
              36.022581
            ],
            [
              35.69239,
              36.034565
            ],
            [
              35.723053,
              36.022256
            ],
            [
              35.918103,
              35.929889
            ],
            [
              35.901234,
              35.921669
            ],
            [
              35.887752,
              35.90285
            ],
            [
              35.879852,
              35.873806
            ],
            [
              35.846514,
              35.850533
            ],
            [
              35.828839,
              35.849591
            ],
            [
              35.813723,
              35.857354
            ],
            [
              35.806802,
              35.835407
            ],
            [
              35.820684,
              35.826273
            ],
            [
              35.820775,
              35.812333
            ],
            [
              35.831471,
              35.800342
            ],
            [
              35.84095,
              35.775751
            ],
            [
              35.845372,
              35.751269
            ],
            [
              35.833993,
              35.737315
            ],
            [
              35.830014,
              35.715193
            ],
            [
              35.805516,
              35.700537
            ],
            [
              35.793993,
              35.682613
            ],
            [
              35.770342,
              35.673978
            ],
            [
              35.76802,
              35.656958
            ],
            [
              35.777459,
              35.651198
            ],
            [
              35.784524,
              35.633097
            ],
            [
              35.775431,
              35.611918
            ],
            [
              35.763704,
              35.608938
            ],
            [
              35.741624,
              35.581993
            ],
            [
              35.732913,
              35.563417
            ],
            [
              35.763302,
              35.544163
            ],
            [
              35.771616,
              35.532519
            ],
            [
              35.760959,
              35.508883
            ],
            [
              35.811385,
              35.499797
            ],
            [
              35.83728,
              35.484632
            ],
            [
              35.879194,
              35.455441
            ],
            [
              35.901205,
              35.435512
            ],
            [
              35.920825,
              35.380719
            ],
            [
              35.91723,
              35.377286
            ],
            [
              35.924568,
              35.261877
            ],
            [
              35.93847,
              35.247411
            ],
            [
              35.947999,
              35.227057
            ],
            [
              35.953203,
              35.200885
            ],
            [
              35.950804,
              35.189351
            ],
            [
              35.923739,
              35.172596
            ],
            [
              35.927298,
              35.156669
            ],
            [
              35.916551,
              35.149064
            ],
            [
              35.905213,
              35.120114
            ],
            [
              35.88717,
              35.106066
            ],
            [
              35.891021,
              35.074358
            ],
            [
              35.885642,
              35.052596
            ],
            [
              35.894204,
              35.035038
            ],
            [
              35.898173,
              35.007984
            ],
            [
              35.87766,
              34.988752
            ],
            [
              35.874762,
              34.964103
            ],
            [
              35.879773,
              34.920409
            ],
            [
              35.862595,
              34.913024
            ],
            [
              35.880736,
              34.882177
            ],
            [
              35.911754,
              34.810712
            ],
            [
              35.930294,
              34.77164
            ],
            [
              35.93252,
              34.735291
            ],
            [
              35.972543,
              34.640212
            ],
            [
              35.98555,
              34.606674
            ],
            [
              35.99164,
              34.56805
            ],
            [
              35.986269,
              34.529715
            ],
            [
              35.976031,
              34.517495
            ],
            [
              35.963395,
              34.518085
            ],
            [
              35.903329,
              34.467091
            ],
            [
              35.831313,
              34.452166
            ],
            [
              35.810822,
              34.456122
            ],
            [
              35.811455,
              34.433777
            ],
            [
              35.820535,
              34.415652
            ],
            [
              35.811046,
              34.403898
            ],
            [
              35.773291,
              34.383219
            ],
            [
              35.734719,
              34.374829
            ],
            [
              35.720539,
              34.316763
            ],
            [
              35.703798,
              34.305567
            ],
            [
              35.690316,
              34.314145
            ],
            [
              35.670884,
              34.30317
            ],
            [
              35.65834,
              34.284741
            ],
            [
              35.656064,
              34.250215
            ],
            [
              35.660415,
              34.244534
            ],
            [
              35.648335,
              34.211512
            ],
            [
              35.637467,
              34.204178
            ],
            [
              35.626497,
              34.149972
            ],
            [
              35.640165,
              34.134999
            ],
            [
              35.65024,
              34.106304
            ],
            [
              35.649482,
              34.085783
            ],
            [
              35.640828,
              34.057505
            ],
            [
              35.624955,
              34.038402
            ],
            [
              35.623013,
              34.018003
            ],
            [
              35.641675,
              34.012683
            ],
            [
              35.644114,
              34.00297
            ],
            [
              35.634879,
              33.986722
            ],
            [
              35.613123,
              33.986366
            ],
            [
              35.581522,
              33.933101
            ],
            [
              35.581964,
              33.915037
            ],
            [
              35.571187,
              33.904214
            ],
            [
              35.554011,
              33.898411
            ],
            [
              35.537409,
              33.908959
            ],
            [
              35.512741,
              33.903877
            ],
            [
              35.472575,
              33.902558
            ],
            [
              35.46728,
              33.892953
            ],
            [
              35.477154,
              33.882844
            ],
            [
              35.48238,
              33.849082
            ],
            [
              35.474971,
              33.844927
            ],
            [
              35.481571,
              33.821908
            ],
            [
              35.478153,
              33.793055
            ],
            [
              35.447634,
              33.745412
            ],
            [
              35.443974,
              33.714428
            ],
            [
              35.436943,
              33.699277
            ],
            [
              35.415482,
              33.688452
            ],
            [
              35.415496,
              33.653877
            ],
            [
              35.397548,
              33.647153
            ],
            [
              35.398556,
              33.61739
            ],
            [
              35.387721,
              33.606769
            ],
            [
              35.383043,
              33.580634
            ],
            [
              35.366455,
              33.565532
            ],
            [
              35.358294,
              33.523291
            ],
            [
              35.348307,
              33.507209
            ],
            [
              35.314147,
              33.472241
            ],
            [
              35.287935,
              33.461784
            ],
            [
              35.267928,
              33.425607
            ],
            [
              35.249302,
              33.375687
            ],
            [
              35.242499,
              33.327729
            ],
            [
              35.222294,
              33.308811
            ],
            [
              35.20826,
              33.261061
            ],
            [
              35.21235,
              33.245467
            ],
            [
              35.204761,
              33.204358
            ],
            [
              35.195955,
              33.197078
            ],
            [
              35.186769,
              33.171791
            ],
            [
              35.16773,
              33.165039
            ],
            [
              35.143567,
              33.126102
            ]
          ]
        ]
      },
      "properties": {
        "name": "#4"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              50.402042,
              27.997677
            ],
            [
              50.396394,
              27.94755
            ],
            [
              50.384484,
              27.914206
            ],
            [
              50.369167,
              27.886389
            ],
            [
              49.985556,
              27.879722
            ],
            [
              49.970833,
              27.905556
            ],
            [
              49.953889,
              27.955833
            ],
            [
              49.950556,
              27.995278
            ],
            [
              49.958889,
              28.0475
            ],
            [
              49.968611,
              28.072222
            ],
            [
              49.998056,
              28.116389
            ],
            [
              50.016944,
              28.135
            ],
            [
              50.061111,
              28.164167
            ],
            [
              50.070546,
              28.175126
            ],
            [
              50.116103,
              28.189768
            ],
            [
              50.152721,
              28.194948
            ],
            [
              50.195989,
              28.194388
            ],
            [
              50.253464,
              28.182038
            ],
            [
              50.289228,
              28.16723
            ],
            [
              50.321534,
              28.147136
            ],
            [
              50.34619,
              28.125696
            ],
            [
              50.369471,
              28.097455
            ],
            [
              50.386857,
              28.066057
            ],
            [
              50.397823,
              28.032457
            ],
            [
              50.402042,
              27.997677
            ]
          ]
        ]
      },
      "properties": {
        "name": "#5"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              53.908307,
              37.348749
            ],
            [
              53.937102,
              37.340397
            ],
            [
              53.952189,
              37.318894
            ],
            [
              53.979251,
              37.339634
            ],
            [
              53.998147,
              37.258159
            ],
            [
              53.990886,
              37.228456
            ],
            [
              53.991102,
              37.201311
            ],
            [
              54.007383,
              37.142123
            ],
            [
              54.035852,
              37.069556
            ],
            [
              54.043611,
              37.024972
            ],
            [
              54.03001,
              37.005381
            ],
            [
              54.025334,
              36.972998
            ],
            [
              54.045628,
              36.948225
            ],
            [
              54.045665,
              36.914063
            ],
            [
              54.042135,
              36.898136
            ],
            [
              54.052375,
              36.881166
            ],
            [
              54.051158,
              36.855088
            ],
            [
              54.044098,
              36.852295
            ],
            [
              54.036353,
              36.829448
            ],
            [
              54.034425,
              36.806492
            ],
            [
              53.972694,
              36.788059
            ],
            [
              53.949386,
              36.78932
            ],
            [
              53.931599,
              36.777654
            ],
            [
              53.901825,
              36.782613
            ],
            [
              53.882933,
              36.775699
            ],
            [
              53.854696,
              36.783129
            ],
            [
              53.814646,
              36.785435
            ],
            [
              53.769918,
              36.784346
            ],
            [
              53.754292,
              36.781279
            ],
            [
              53.71032,
              36.784493
            ],
            [
              53.676288,
              36.79255
            ],
            [
              53.654361,
              36.786858
            ],
            [
              53.626594,
              36.785785
            ],
            [
              53.616613,
              36.790041
            ],
            [
              53.599617,
              36.780743
            ],
            [
              53.523899,
              36.786307
            ],
            [
              53.509696,
              36.790369
            ],
            [
              53.504771,
              36.803462
            ],
            [
              53.47492,
              36.795203
            ],
            [
              53.443385,
              36.804011
            ],
            [
              53.438975,
              36.815656
            ],
            [
              53.418199,
              36.837798
            ],
            [
              53.4375,
              36.842076
            ],
            [
              53.495953,
              36.832619
            ],
            [
              53.547215,
              36.831961
            ],
            [
              53.575542,
              36.825085
            ],
            [
              53.594996,
              36.830973
            ],
            [
              53.581186,
              36.841903
            ],
            [
              53.55136,
              36.845431
            ],
            [
              53.573426,
              36.861578
            ],
            [
              53.583574,
              36.860285
            ],
            [
              53.612805,
              36.868832
            ],
            [
              53.646222,
              36.861916
            ],
            [
              53.656531,
              36.864192
            ],
            [
              53.695254,
              36.859375
            ],
            [
              53.734749,
              36.865441
            ],
            [
              53.752344,
              36.873145
            ],
            [
              53.770108,
              36.872568
            ],
            [
              53.783504,
              36.880888
            ],
            [
              53.807191,
              36.876467
            ],
            [
              53.832526,
              36.877687
            ],
            [
              53.846972,
              36.883906
            ],
            [
              53.8819,
              36.887526
            ],
            [
              53.911629,
              36.887307
            ],
            [
              53.933191,
              36.896757
            ],
            [
              53.949902,
              36.895677
            ],
            [
              53.951861,
              36.907063
            ],
            [
              53.916456,
              36.906456
            ],
            [
              53.895229,
              36.901567
            ],
            [
              53.857558,
              36.903108
            ],
            [
              53.823622,
              36.898724
            ],
            [
              53.753793,
              36.893665
            ],
            [
              53.693514,
              36.886998
            ],
            [
              53.607227,
              36.880499
            ],
            [
              53.490372,
              36.869669
            ],
            [
              53.35696,
              36.853596
            ],
            [
              53.286631,
              36.84268
            ],
            [
              53.249361,
              36.841547
            ],
            [
              53.211225,
              36.83135
            ],
            [
              53.182959,
              36.828095
            ],
            [
              53.111555,
              36.813841
            ],
            [
              53.057151,
              36.796652
            ],
            [
              52.950791,
              36.768727
            ],
            [
              52.851296,
              36.745219
            ],
            [
              52.789389,
              36.733009
            ],
            [
              52.749918,
              36.728486
            ],
            [
              52.552018,
              36.694518
            ],
            [
              52.44007,
              36.679682
            ],
            [
              52.42511,
              36.674056
            ],
            [
              52.307217,
              36.646253
            ],
            [
              52.286689,
              36.64333
            ],
            [
              52.163041,
              36.609587
            ],
            [
              52.07214,
              36.588485
            ],
            [
              51.974252,
              36.572823
            ],
            [
              51.892569,
              36.571376
            ],
            [
              51.848215,
              36.574021
            ],
            [
              51.816692,
              36.583342
            ],
            [
              51.790661,
              36.587128
            ],
            [
              51.751775,
              36.587263
            ],
            [
              51.662066,
              36.599333
            ],
            [
              51.62498,
              36.607731
            ],
            [
              51.591587,
              36.62093
            ],
            [
              51.568695,
              36.634487
            ],
            [
              51.520378,
              36.649304
            ],
            [
              51.503832,
              36.659938
            ],
            [
              51.47264,
              36.6649
            ],
            [
              51.426316,
              36.685459
            ],
            [
              51.287305,
              36.696574
            ],
            [
              51.207781,
              36.709542
            ],
            [
              51.127271,
              36.724755
            ],
            [
              51.036636,
              36.748783
            ],
            [
              50.98159,
              36.768061
            ],
            [
              50.946129,
              36.783234
            ],
            [
              50.891909,
              36.812782
            ],
            [
              50.861884,
              36.831803
            ],
            [
              50.813277,
              36.850025
            ],
            [
              50.784951,
              36.864159
            ],
            [
              50.77179,
              36.875067
            ],
            [
              50.723223,
              36.890638
            ],
            [
              50.69356,
              36.903858
            ],
            [
              50.674111,
              36.919776
            ],
            [
              50.655297,
              36.942062
            ],
            [
              50.586379,
              36.96884
            ],
            [
              50.574872,
              36.981258
            ],
            [
              50.521484,
              37.001728
            ],
            [
              50.481897,
              37.021109
            ],
            [
              50.464947,
              37.042583
            ],
            [
              50.418888,
              37.068397
            ],
            [
              50.385956,
              37.090205
            ],
            [
              50.381727,
              37.098446
            ],
            [
              50.338228,
              37.119058
            ],
            [
              50.308553,
              37.142406
            ],
            [
              50.286712,
              37.17487
            ],
            [
              50.27563,
              37.207128
            ],
            [
              50.254934,
              37.243731
            ],
            [
              50.23178,
              37.298775
            ],
            [
              50.222883,
              37.313727
            ],
            [
              50.223588,
              37.344774
            ],
            [
              50.206963,
              37.362933
            ],
            [
              50.200026,
              37.380214
            ],
            [
              50.151333,
              37.393919
            ],
            [
              50.087513,
              37.400978
            ],
            [
              50.032594,
              37.409186
            ],
            [
              49.982048,
              37.425061
            ],
            [
              49.952145,
              37.446393
            ],
            [
              49.946386,
              37.46836
            ],
            [
              49.930397,
              37.473185
            ],
            [
              49.903056,
              37.469616
            ],
            [
              49.887184,
              37.452768
            ],
            [
              49.845378,
              37.444552
            ],
            [
              49.75998,
              37.448661
            ],
            [
              49.723378,
              37.452489
            ],
            [
              49.552286,
              37.466547
            ],
            [
              49.449923,
              37.481054
            ],
            [
              49.377558,
              37.49923
            ],
            [
              49.327875,
              37.515142
            ],
            [
              49.241415,
              37.548903
            ],
            [
              49.205735,
              37.567418
            ],
            [
              49.124236,
              37.618056
            ],
            [
              49.087411,
              37.645812
            ],
            [
              49.036038,
              37.692455
            ],
            [
              49.0018,
              37.733694
            ],
            [
              48.996441,
              37.760221
            ],
            [
              48.97579,
              37.79171
            ],
            [
              48.980808,
              37.818563
            ],
            [
              48.979386,
              37.834253
            ],
            [
              48.947924,
              37.869558
            ],
            [
              48.931819,
              37.903092
            ],
            [
              48.930462,
              37.92628
            ],
            [
              48.938028,
              37.967041
            ],
            [
              48.924811,
              37.992909
            ],
            [
              48.91693,
              38.023562
            ],
            [
              48.920556,
              38.04149
            ],
            [
              48.910406,
              38.07158
            ],
            [
              48.909373,
              38.090599
            ],
            [
              48.915682,
              38.098653
            ],
            [
              48.909356,
              38.126939
            ],
            [
              48.916045,
              38.144531
            ],
            [
              48.892124,
              38.213275
            ],
            [
              48.894111,
              38.232773
            ],
            [
              48.881479,
              38.280931
            ],
            [
              48.882107,
              38.296634
            ],
            [
              48.874334,
              38.333889
            ],
            [
              48.875833,
              38.415443
            ],
            [
              48.884867,
              38.444737
            ],
            [
              48.896284,
              38.443355
            ],
            [
              49.136868,
              38.451572
            ],
            [
              49.135839,
              38.401255
            ],
            [
              49.128241,
              38.352246
            ],
            [
              49.136273,
              38.293753
            ],
            [
              49.143116,
              38.272598
            ],
            [
              49.148112,
              38.23287
            ],
            [
              49.161083,
              38.199844
            ],
            [
              49.169647,
              38.15269
            ],
            [
              49.16842,
              38.083139
            ],
            [
              49.173876,
              38.039902
            ],
            [
              49.185261,
              38.010147
            ],
            [
              49.190119,
              37.985078
            ],
            [
              49.190328,
              37.944662
            ],
            [
              49.21882,
              37.898414
            ],
            [
              49.229326,
              37.8637
            ],
            [
              49.233379,
              37.818704
            ],
            [
              49.267921,
              37.785961
            ],
            [
              49.29726,
              37.764269
            ],
            [
              49.373482,
              37.720691
            ],
            [
              49.430373,
              37.698308
            ],
            [
              49.491576,
              37.680183
            ],
            [
              49.584438,
              37.665496
            ],
            [
              49.789138,
              37.648482
            ],
            [
              49.849104,
              37.666504
            ],
            [
              49.891584,
              37.672602
            ],
            [
              49.9633,
              37.67184
            ],
            [
              49.990508,
              37.667763
            ],
            [
              50.038476,
              37.655772
            ],
            [
              50.068024,
              37.644152
            ],
            [
              50.108312,
              37.621746
            ],
            [
              50.137704,
              37.598486
            ],
            [
              50.21379,
              37.588017
            ],
            [
              50.275262,
              37.573245
            ],
            [
              50.310903,
              37.560149
            ],
            [
              50.345724,
              37.543521
            ],
            [
              50.389147,
              37.512182
            ],
            [
              50.426327,
              37.46905
            ],
            [
              50.45965,
              37.413073
            ],
            [
              50.470872,
              37.379312
            ],
            [
              50.475508,
              37.348699
            ],
            [
              50.488124,
              37.318953
            ],
            [
              50.514149,
              37.268654
            ],
            [
              50.549753,
              37.247026
            ],
            [
              50.571105,
              37.229748
            ],
            [
              50.594565,
              37.204718
            ],
            [
              50.60876,
              37.184222
            ],
            [
              50.665253,
              37.169159
            ],
            [
              50.700049,
              37.154736
            ],
            [
              50.741406,
              37.130715
            ],
            [
              50.794302,
              37.108602
            ],
            [
              50.811883,
              37.098243
            ],
            [
              50.852072,
              37.066007
            ],
            [
              50.883966,
              37.054132
            ],
            [
              50.94298,
              37.022179
            ],
            [
              50.971862,
              37.011723
            ],
            [
              51.015631,
              36.990582
            ],
            [
              51.07807,
              36.953831
            ],
            [
              51.128179,
              36.935328
            ],
            [
              51.155358,
              36.92761
            ],
            [
              51.236572,
              36.909751
            ],
            [
              51.340938,
              36.893337
            ],
            [
              51.463478,
              36.883618
            ],
            [
              51.512048,
              36.873844
            ],
            [
              51.548353,
              36.861418
            ],
            [
              51.595693,
              36.851642
            ],
            [
              51.635064,
              36.836844
            ],
            [
              51.664768,
              36.820592
            ],
            [
              51.73035,
              36.792641
            ],
            [
              51.775694,
              36.787175
            ],
            [
              51.812376,
              36.786767
            ],
            [
              51.897329,
              36.772925
            ],
            [
              51.939875,
              36.773484
            ],
            [
              52.013596,
              36.783395
            ],
            [
              52.054349,
              36.792587
            ],
            [
              52.162975,
              36.822199
            ],
            [
              52.337784,
              36.862398
            ],
            [
              52.373232,
              36.872736
            ],
            [
              52.457099,
              36.885723
            ],
            [
              52.504435,
              36.89829
            ],
            [
              52.562386,
              36.903018
            ],
            [
              52.612541,
              36.914591
            ],
            [
              52.655665,
              36.917484
            ],
            [
              52.746516,
              36.931429
            ],
            [
              52.79759,
              36.941569
            ],
            [
              52.976807,
              36.986634
            ],
            [
              53.052163,
              37.00848
            ],
            [
              53.141739,
              37.025719
            ],
            [
              53.202714,
              37.043524
            ],
            [
              53.245917,
              37.048095
            ],
            [
              53.272129,
              37.047835
            ],
            [
              53.298516,
              37.055939
            ],
            [
              53.341062,
              37.063518
            ],
            [
              53.379156,
              37.065189
            ],
            [
              53.411744,
              37.062861
            ],
            [
              53.464508,
              37.068986
            ],
            [
              53.57106,
              37.078781
            ],
            [
              53.666247,
              37.086361
            ],
            [
              53.729532,
              37.0931
            ],
            [
              53.689978,
              37.195061
            ],
            [
              53.675389,
              37.243506
            ],
            [
              53.66157,
              37.313446
            ],
            [
              53.661536,
              37.355764
            ],
            [
              53.788848,
              37.369693
            ],
            [
              53.908307,
              37.348749
            ]
          ]
        ]
      },
      "properties": {
        "name": "#6"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              34.919417,
              29.449959
            ],
            [
              34.902277,
              29.489815
            ],
            [
              34.914205,
              29.498275
            ],
            [
              34.955544,
              29.549455
            ],
            [
              34.978065,
              29.542523
            ],
            [
              34.978056,
              29.5425
            ],
            [
              34.969502,
              29.525394
            ],
            [
              34.951646,
              29.495678
            ],
            [
              34.933611,
              29.466944
            ],
            [
              34.919417,
              29.449959
            ]
          ]
        ]
      },
      "properties": {
        "name": "#7"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              34.217077,
              31.324394
            ],
            [
              34.080861,
              31.49006
            ],
            [
              34.095687,
              31.502601
            ],
            [
              34.231498,
              31.335976
            ],
            [
              34.217077,
              31.324394
            ]
          ]
        ]
      },
      "properties": {
        "name": "#8"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              51.601829,
              24.722936
            ],
            [
              51.725431,
              24.749984
            ],
            [
              51.709718,
              24.724006
            ],
            [
              51.663025,
              24.653836
            ],
            [
              51.605529,
              24.558725
            ],
            [
              51.518863,
              24.4282
            ],
            [
              51.5171,
              24.425163
            ],
            [
              51.516839,
              24.401527
            ],
            [
              51.526596,
              24.381209
            ],
            [
              51.561757,
              24.347314
            ],
            [
              51.57025,
              24.335171
            ],
            [
              51.578669,
              24.308496
            ],
            [
              51.592309,
              24.27896
            ],
            [
              51.590568,
              24.259918
            ],
            [
              51.506828,
              24.401395
            ],
            [
              51.565278,
              24.567222
            ],
            [
              51.604461,
              24.719933
            ],
            [
              51.601829,
              24.722936
            ]
          ]
        ]
      },
      "properties": {
        "name": "#9"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              42.059156,
              15.56132
            ],
            [
              42.059335,
              15.527452
            ],
            [
              42.049123,
              15.477021
            ],
            [
              42.037048,
              15.446523
            ],
            [
              42.01595,
              15.412859
            ],
            [
              41.993573,
              15.388388
            ],
            [
              41.975255,
              15.372868
            ],
            [
              41.942275,
              15.352345
            ],
            [
              41.898474,
              15.333883
            ],
            [
              41.863989,
              15.325139
            ],
            [
              41.838744,
              15.322367
            ],
            [
              41.808012,
              15.322854
            ],
            [
              41.777424,
              15.32747
            ],
            [
              41.747288,
              15.336682
            ],
            [
              41.705194,
              15.358268
            ],
            [
              41.688818,
              15.369825
            ],
            [
              41.659738,
              15.397335
            ],
            [
              41.639004,
              15.426024
            ],
            [
              41.623574,
              15.456499
            ],
            [
              41.611166,
              15.497873
            ],
            [
              41.60786,
              15.527318
            ],
            [
              41.608194,
              15.554296
            ],
            [
              41.616136,
              15.596892
            ],
            [
              41.623936,
              15.618546
            ],
            [
              41.641875,
              15.651504
            ],
            [
              41.675448,
              15.692465
            ],
            [
              41.704462,
              15.716867
            ],
            [
              41.734716,
              15.73441
            ],
            [
              41.75899,
              15.74472
            ],
            [
              41.8124,
              15.757276
            ],
            [
              41.855881,
              15.758358
            ],
            [
              41.904139,
              15.750031
            ],
            [
              41.933641,
              15.738908
            ],
            [
              41.982376,
              15.708628
            ],
            [
              42.00793,
              15.683847
            ],
            [
              42.028754,
              15.654965
            ],
            [
              42.042274,
              15.629265
            ],
            [
              42.051203,
              15.604565
            ],
            [
              42.059156,
              15.56132
            ]
          ]
        ]
      },
      "properties": {
        "name": "#10"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -65.308347,
              11.188055
            ],
            [
              -65.260341,
              11.181952
            ],
            [
              -65.215554,
              11.165653
            ],
            [
              -65.166376,
              11.15715
            ],
            [
              -65.132154,
              11.143835
            ],
            [
              -65.114252,
              11.134001
            ],
            [
              -65.078199,
              11.107163
            ],
            [
              -65.058319,
              11.086401
            ],
            [
              -65.037982,
              11.057688
            ],
            [
              -65.023005,
              11.025921
            ],
            [
              -65.005194,
              10.978563
            ],
            [
              -64.996032,
              10.944708
            ],
            [
              -64.992959,
              10.909795
            ],
            [
              -64.996067,
              10.874884
            ],
            [
              -65.00526,
              10.841035
            ],
            [
              -65.028905,
              10.795382
            ],
            [
              -65.062585,
              10.756919
            ],
            [
              -65.093082,
              10.734301
            ],
            [
              -65.118789,
              10.720512
            ],
            [
              -65.156083,
              10.707873
            ],
            [
              -65.207949,
              10.696958
            ],
            [
              -65.25274,
              10.690562
            ],
            [
              -65.293399,
              10.688357
            ],
            [
              -65.335899,
              10.691282
            ],
            [
              -65.363739,
              10.697186
            ],
            [
              -65.440695,
              10.723261
            ],
            [
              -65.491373,
              10.734538
            ],
            [
              -65.523501,
              10.749344
            ],
            [
              -65.552544,
              10.769441
            ],
            [
              -65.577619,
              10.794216
            ],
            [
              -65.597965,
              10.822918
            ],
            [
              -65.607069,
              10.840443
            ],
            [
              -65.629226,
              10.896475
            ],
            [
              -65.638421,
              10.930324
            ],
            [
              -65.64153,
              10.965235
            ],
            [
              -65.639767,
              10.991764
            ],
            [
              -65.631326,
              11.028808
            ],
            [
              -65.619462,
              11.057153
            ],
            [
              -65.605079,
              11.081147
            ],
            [
              -65.588517,
              11.101921
            ],
            [
              -65.545026,
              11.138859
            ],
            [
              -65.515374,
              11.15511
            ],
            [
              -65.477489,
              11.179085
            ],
            [
              -65.455662,
              11.188345
            ],
            [
              -65.421384,
              11.197418
            ],
            [
              -65.388251,
              11.200449
            ],
            [
              -65.336079,
              11.195866
            ],
            [
              -65.308347,
              11.188055
            ]
          ]
        ]
      },
      "properties": {
        "name": "#11"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -62.855946,
              11.395725
            ],
            [
              -62.853361,
              11.356398
            ],
            [
              -62.85966,
              11.31307
            ],
            [
              -62.865557,
              11.294253
            ],
            [
              -62.880578,
              11.262497
            ],
            [
              -62.900955,
              11.233795
            ],
            [
              -62.926068,
              11.209021
            ],
            [
              -62.950512,
              11.191641
            ],
            [
              -62.987654,
              11.173901
            ],
            [
              -63.021943,
              11.164834
            ],
            [
              -63.042661,
              11.162398
            ],
            [
              -63.07289,
              11.150667
            ],
            [
              -63.096628,
              11.145058
            ],
            [
              -63.134208,
              11.142028
            ],
            [
              -63.169199,
              11.145398
            ],
            [
              -63.195092,
              11.151309
            ],
            [
              -63.229865,
              11.164902
            ],
            [
              -63.263535,
              11.186064
            ],
            [
              -63.300729,
              11.223558
            ],
            [
              -63.326835,
              11.269276
            ],
            [
              -63.338807,
              11.307291
            ],
            [
              -63.345106,
              11.350619
            ],
            [
              -63.343642,
              11.400647
            ],
            [
              -63.340405,
              11.42694
            ],
            [
              -63.331228,
              11.460794
            ],
            [
              -63.31623,
              11.492559
            ],
            [
              -63.295863,
              11.521272
            ],
            [
              -63.270748,
              11.546058
            ],
            [
              -63.23188,
              11.571369
            ],
            [
              -63.203144,
              11.583114
            ],
            [
              -63.168533,
              11.591077
            ],
            [
              -63.109712,
              11.594381
            ],
            [
              -63.061466,
              11.587055
            ],
            [
              -62.994858,
              11.562846
            ],
            [
              -62.951884,
              11.539437
            ],
            [
              -62.91698,
              11.512399
            ],
            [
              -62.903401,
              11.497948
            ],
            [
              -62.883037,
              11.469236
            ],
            [
              -62.863874,
              11.427558
            ],
            [
              -62.855946,
              11.395725
            ]
          ]
        ]
      },
      "properties": {
        "name": "#12"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -64.2435,
              11.900625
            ],
            [
              -64.233138,
              11.874867
            ],
            [
              -64.212237,
              11.845569
            ],
            [
              -64.197219,
              11.813804
            ],
            [
              -64.188032,
              11.779951
            ],
            [
              -64.185436,
              11.73143
            ],
            [
              -64.19404,
              11.685071
            ],
            [
              -64.214461,
              11.636599
            ],
            [
              -64.23522,
              11.60292
            ],
            [
              -64.267255,
              11.569576
            ],
            [
              -64.297138,
              11.548467
            ],
            [
              -64.332134,
              11.532022
            ],
            [
              -64.358831,
              11.524433
            ],
            [
              -64.398577,
              11.519441
            ],
            [
              -64.430995,
              11.520734
            ],
            [
              -64.457203,
              11.525579
            ],
            [
              -64.490728,
              11.537196
            ],
            [
              -64.518002,
              11.551939
            ],
            [
              -64.558414,
              11.586091
            ],
            [
              -64.575005,
              11.606934
            ],
            [
              -64.598683,
              11.606927
            ],
            [
              -64.638192,
              11.612918
            ],
            [
              -64.709431,
              11.63305
            ],
            [
              -64.735802,
              11.644663
            ],
            [
              -64.769471,
              11.666194
            ],
            [
              -64.796893,
              11.691245
            ],
            [
              -64.826985,
              11.734542
            ],
            [
              -64.842661,
              11.775497
            ],
            [
              -64.849998,
              11.812627
            ],
            [
              -64.853118,
              11.847536
            ],
            [
              -64.846631,
              11.897892
            ],
            [
              -64.839927,
              11.919085
            ],
            [
              -64.824904,
              11.950849
            ],
            [
              -64.798746,
              11.996518
            ],
            [
              -64.775865,
              12.028823
            ],
            [
              -64.750704,
              12.053609
            ],
            [
              -64.721549,
              12.073715
            ],
            [
              -64.678728,
              12.091984
            ],
            [
              -64.639454,
              12.099677
            ],
            [
              -64.603849,
              12.10006
            ],
            [
              -64.568718,
              12.094347
            ],
            [
              -64.53016,
              12.083135
            ],
            [
              -64.488362,
              12.063809
            ],
            [
              -64.436174,
              12.025432
            ],
            [
              -64.397244,
              12.021157
            ],
            [
              -64.35499,
              12.007531
            ],
            [
              -64.337178,
              11.998531
            ],
            [
              -64.308031,
              11.978425
            ],
            [
              -64.271165,
              11.942949
            ],
            [
              -64.2435,
              11.900625
            ]
          ]
        ]
      },
      "properties": {
        "name": "#13"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -66.426491,
              11.96401
            ],
            [
              -66.426201,
              11.951539
            ],
            [
              -66.400935,
              11.900576
            ],
            [
              -66.395591,
              11.88376
            ],
            [
              -66.375351,
              11.923273
            ],
            [
              -66.356404,
              11.947616
            ],
            [
              -66.315967,
              11.981804
            ],
            [
              -66.291987,
              11.995087
            ],
            [
              -66.252336,
              12.009018
            ],
            [
              -66.21844,
              12.035012
            ],
            [
              -66.168744,
              12.059854
            ],
            [
              -66.13436,
              12.068927
            ],
            [
              -66.096668,
              12.071959
            ],
            [
              -66.070029,
              12.069951
            ],
            [
              -66.035357,
              12.061989
            ],
            [
              -65.988958,
              12.040867
            ],
            [
              -65.959807,
              12.020761
            ],
            [
              -65.934649,
              11.995976
            ],
            [
              -65.914248,
              11.967264
            ],
            [
              -65.899224,
              11.935499
            ],
            [
              -65.890965,
              11.906576
            ],
            [
              -65.884734,
              11.851908
            ],
            [
              -65.887854,
              11.816999
            ],
            [
              -65.895668,
              11.787165
            ],
            [
              -65.900509,
              11.755761
            ],
            [
              -65.909913,
              11.726458
            ],
            [
              -65.935102,
              11.678189
            ],
            [
              -65.958618,
              11.646274
            ],
            [
              -65.979357,
              11.624293
            ],
            [
              -66.002473,
              11.605292
            ],
            [
              -66.025128,
              11.591415
            ],
            [
              -66.071045,
              11.573703
            ],
            [
              -66.104805,
              11.567388
            ],
            [
              -66.166092,
              11.568024
            ],
            [
              -66.216198,
              11.579958
            ],
            [
              -66.24842,
              11.594763
            ],
            [
              -66.278919,
              11.612846
            ],
            [
              -66.329296,
              11.648427
            ],
            [
              -66.361167,
              11.681542
            ],
            [
              -66.385796,
              11.719235
            ],
            [
              -66.400086,
              11.683281
            ],
            [
              -66.413691,
              11.660661
            ],
            [
              -66.443505,
              11.62625
            ],
            [
              -66.466905,
              11.606957
            ],
            [
              -66.507236,
              11.584136
            ],
            [
              -66.561909,
              11.564123
            ],
            [
              -66.644276,
              11.552473
            ],
            [
              -66.675314,
              11.550469
            ],
            [
              -66.72324,
              11.556634
            ],
            [
              -66.765047,
              11.544785
            ],
            [
              -66.825879,
              11.535676
            ],
            [
              -66.856981,
              11.535676
            ],
            [
              -66.910575,
              11.546388
            ],
            [
              -66.944472,
              11.560522
            ],
            [
              -66.986819,
              11.589032
            ],
            [
              -67.007563,
              11.608825
            ],
            [
              -67.028592,
              11.635795
            ],
            [
              -67.049057,
              11.645945
            ],
            [
              -67.07819,
              11.66604
            ],
            [
              -67.092854,
              11.679434
            ],
            [
              -67.119374,
              11.710255
            ],
            [
              -67.132892,
              11.730386
            ],
            [
              -67.147939,
              11.762141
            ],
            [
              -67.157163,
              11.795988
            ],
            [
              -67.159872,
              11.818339
            ],
            [
              -67.159338,
              11.851047
            ],
            [
              -67.155008,
              11.876994
            ],
            [
              -67.142073,
              11.914529
            ],
            [
              -67.132655,
              11.94935
            ],
            [
              -67.11763,
              11.981115
            ],
            [
              -67.105377,
              11.999593
            ],
            [
              -67.07047,
              12.036647
            ],
            [
              -67.041317,
              12.056753
            ],
            [
              -67.009057,
              12.071568
            ],
            [
              -66.902602,
              12.104978
            ],
            [
              -66.865541,
              12.11337
            ],
            [
              -66.841079,
              12.115307
            ],
            [
              -66.817201,
              12.124609
            ],
            [
              -66.772906,
              12.148764
            ],
            [
              -66.726659,
              12.1611
            ],
            [
              -66.684646,
              12.163099
            ],
            [
              -66.652359,
              12.159877
            ],
            [
              -66.62483,
              12.154067
            ],
            [
              -66.588317,
              12.149845
            ],
            [
              -66.546043,
              12.136219
            ],
            [
              -66.528223,
              12.127219
            ],
            [
              -66.499062,
              12.107113
            ],
            [
              -66.473896,
              12.082327
            ],
            [
              -66.453489,
              12.053616
            ],
            [
              -66.43846,
              12.021851
            ],
            [
              -66.429266,
              11.987999
            ],
            [
              -66.426491,
              11.96401
            ]
          ]
        ]
      },
      "properties": {
        "name": "#14"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -67.512411,
              12.135286
            ],
            [
              -67.46306,
              12.146197
            ],
            [
              -67.406696,
              12.147983
            ],
            [
              -67.365444,
              12.140362
            ],
            [
              -67.34478,
              12.134138
            ],
            [
              -67.312513,
              12.119324
            ],
            [
              -67.283353,
              12.099218
            ],
            [
              -67.258187,
              12.074432
            ],
            [
              -67.23763,
              12.045463
            ],
            [
              -67.22175,
              12.012232
            ],
            [
              -67.212556,
              11.97838
            ],
            [
              -67.209473,
              11.943469
            ],
            [
              -67.212594,
              11.90856
            ],
            [
              -67.226006,
              11.864194
            ],
            [
              -67.250462,
              11.82253
            ],
            [
              -67.267853,
              11.802581
            ],
            [
              -67.303693,
              11.773871
            ],
            [
              -67.331775,
              11.758622
            ],
            [
              -67.36965,
              11.745963
            ],
            [
              -67.39598,
              11.741683
            ],
            [
              -67.442372,
              11.739054
            ],
            [
              -67.50091,
              11.746866
            ],
            [
              -67.545648,
              11.76485
            ],
            [
              -67.569808,
              11.779933
            ],
            [
              -67.613184,
              11.770963
            ],
            [
              -67.648747,
              11.770581
            ],
            [
              -67.685516,
              11.774711
            ],
            [
              -67.726453,
              11.783423
            ],
            [
              -67.769272,
              11.801686
            ],
            [
              -67.798347,
              11.819779
            ],
            [
              -67.836569,
              11.854469
            ],
            [
              -67.856992,
              11.883168
            ],
            [
              -67.872047,
              11.914924
            ],
            [
              -67.881277,
              11.94877
            ],
            [
              -67.884398,
              11.983678
            ],
            [
              -67.881315,
              12.018589
            ],
            [
              -67.87212,
              12.052441
            ],
            [
              -67.85709,
              12.084206
            ],
            [
              -67.836681,
              12.112918
            ],
            [
              -67.811512,
              12.137703
            ],
            [
              -67.782348,
              12.157809
            ],
            [
              -67.757794,
              12.170403
            ],
            [
              -67.721732,
              12.183149
            ],
            [
              -67.677688,
              12.189339
            ],
            [
              -67.646541,
              12.188001
            ],
            [
              -67.607435,
              12.179465
            ],
            [
              -67.543602,
              12.154505
            ],
            [
              -67.512411,
              12.135286
            ]
          ]
        ]
      },
      "properties": {
        "name": "#15"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -69.696822,
              12.198998
            ],
            [
              -69.635679,
              12.082926
            ],
            [
              -69.621033,
              12.036428
            ],
            [
              -69.609269,
              12.010436
            ],
            [
              -69.600075,
              11.976583
            ],
            [
              -69.596992,
              11.941672
            ],
            [
              -69.600113,
              11.906764
            ],
            [
              -69.605242,
              11.885291
            ],
            [
              -69.592653,
              11.832679
            ],
            [
              -69.566182,
              11.757464
            ],
            [
              -69.544317,
              11.704448
            ],
            [
              -69.500069,
              11.706114
            ],
            [
              -69.439779,
              11.700549
            ],
            [
              -69.405713,
              11.694325
            ],
            [
              -69.37976,
              11.710605
            ],
            [
              -69.353365,
              11.722242
            ],
            [
              -69.301271,
              11.734013
            ],
            [
              -69.254569,
              11.735004
            ],
            [
              -69.202229,
              11.725321
            ],
            [
              -69.173479,
              11.713576
            ],
            [
              -69.134932,
              11.69302
            ],
            [
              -69.105185,
              11.694549
            ],
            [
              -69.065438,
              11.690255
            ],
            [
              -69.023234,
              11.676629
            ],
            [
              -68.978587,
              11.649687
            ],
            [
              -68.937299,
              11.65119
            ],
            [
              -68.895839,
              11.648899
            ],
            [
              -68.853334,
              11.651465
            ],
            [
              -68.831183,
              11.649553
            ],
            [
              -68.770338,
              11.636272
            ],
            [
              -68.721856,
              11.614599
            ],
            [
              -68.680724,
              11.581288
            ],
            [
              -68.658466,
              11.553592
            ],
            [
              -68.603415,
              11.540104
            ],
            [
              -68.560678,
              11.521835
            ],
            [
              -68.522496,
              11.494859
            ],
            [
              -68.492993,
              11.464667
            ],
            [
              -68.455674,
              11.451493
            ],
            [
              -68.419046,
              11.432538
            ],
            [
              -68.398483,
              11.417227
            ],
            [
              -68.358683,
              11.403001
            ],
            [
              -68.322834,
              11.381592
            ],
            [
              -68.269451,
              11.34104
            ],
            [
              -68.24246,
              11.314933
            ],
            [
              -68.213544,
              11.279784
            ],
            [
              -68.191407,
              11.240665
            ],
            [
              -68.17645,
              11.188099
            ],
            [
              -68.159027,
              11.160186
            ],
            [
              -68.128959,
              11.143462
            ],
            [
              -68.11195,
              11.130778
            ],
            [
              -68.08687,
              11.105992
            ],
            [
              -68.066532,
              11.077279
            ],
            [
              -68.051554,
              11.045512
            ],
            [
              -68.040867,
              11.00147
            ],
            [
              -68.023552,
              10.972342
            ],
            [
              -68.007613,
              10.925898
            ],
            [
              -68.002395,
              10.890012
            ],
            [
              -68.004047,
              10.844457
            ],
            [
              -67.995188,
              10.804263
            ],
            [
              -67.993996,
              10.773916
            ],
            [
              -68.000281,
              10.730586
            ],
            [
              -68.007486,
              10.708349
            ],
            [
              -67.966646,
              10.710502
            ],
            [
              -67.919552,
              10.703233
            ],
            [
              -67.886383,
              10.690947
            ],
            [
              -67.868687,
              10.68149
            ],
            [
              -67.816646,
              10.689854
            ],
            [
              -67.793777,
              10.695992
            ],
            [
              -67.712057,
              10.704869
            ],
            [
              -67.672595,
              10.701685
            ],
            [
              -67.648735,
              10.708236
            ],
            [
              -67.613554,
              10.712989
            ],
            [
              -67.586385,
              10.721942
            ],
            [
              -67.533266,
              10.72814
            ],
            [
              -67.50457,
              10.735331
            ],
            [
              -67.471488,
              10.738363
            ],
            [
              -67.435926,
              10.735651
            ],
            [
              -67.405144,
              10.736604
            ],
            [
              -67.379318,
              10.742317
            ],
            [
              -67.341296,
              10.745608
            ],
            [
              -67.318348,
              10.744644
            ],
            [
              -67.247705,
              10.756503
            ],
            [
              -67.211542,
              10.758144
            ],
            [
              -67.17422,
              10.768203
            ],
            [
              -67.139246,
              10.781906
            ],
            [
              -67.113954,
              10.795468
            ],
            [
              -67.080518,
              10.807101
            ],
            [
              -67.031433,
              10.815538
            ],
            [
              -67.000408,
              10.815538
            ],
            [
              -66.925191,
              10.80768
            ],
            [
              -66.88772,
              10.819315
            ],
            [
              -66.856959,
              10.823321
            ],
            [
              -66.822452,
              10.822451
            ],
            [
              -66.796334,
              10.818067
            ],
            [
              -66.748954,
              10.825941
            ],
            [
              -66.685936,
              10.824271
            ],
            [
              -66.622983,
              10.827006
            ],
            [
              -66.576067,
              10.830708
            ],
            [
              -66.552907,
              10.830144
            ],
            [
              -66.496432,
              10.83308
            ],
            [
              -66.43532,
              10.830806
            ],
            [
              -66.400066,
              10.831853
            ],
            [
              -66.371436,
              10.828266
            ],
            [
              -66.317177,
              10.84413
            ],
            [
              -66.277325,
              10.850117
            ],
            [
              -66.255172,
              10.851073
            ],
            [
              -66.208143,
              10.848232
            ],
            [
              -66.177851,
              10.841589
            ],
            [
              -66.143467,
              10.828661
            ],
            [
              -66.094557,
              10.7998
            ],
            [
              -66.053729,
              10.789066
            ],
            [
              -66.027822,
              10.78629
            ],
            [
              -65.993591,
              10.777217
            ],
            [
              -65.964206,
              10.7644
            ],
            [
              -65.943556,
              10.752141
            ],
            [
              -65.905023,
              10.72108
            ],
            [
              -65.882298,
              10.694767
            ],
            [
              -65.86485,
              10.665802
            ],
            [
              -65.852414,
              10.635091
            ],
            [
              -65.844245,
              10.60002
            ],
            [
              -65.842217,
              10.571589
            ],
            [
              -65.845119,
              10.537882
            ],
            [
              -65.823666,
              10.516426
            ],
            [
              -65.795636,
              10.494681
            ],
            [
              -65.729794,
              10.456516
            ],
            [
              -65.6432,
              10.419022
            ],
            [
              -65.573001,
              10.392858
            ],
            [
              -65.505869,
              10.370212
            ],
            [
              -65.415419,
              10.343729
            ],
            [
              -65.333321,
              10.323438
            ],
            [
              -65.226874,
              10.306456
            ],
            [
              -65.199241,
              10.303543
            ],
            [
              -65.13613,
              10.288537
            ],
            [
              -65.11214,
              10.313892
            ],
            [
              -65.087572,
              10.332574
            ],
            [
              -65.039501,
              10.356025
            ],
            [
              -65.005316,
              10.365099
            ],
            [
              -64.954422,
              10.36857
            ],
            [
              -64.943213,
              10.397072
            ],
            [
              -64.925196,
              10.427238
            ],
            [
              -64.908352,
              10.447575
            ],
            [
              -64.885513,
              10.468307
            ],
            [
              -64.851936,
              10.489495
            ],
            [
              -64.829581,
              10.499105
            ],
            [
              -64.781715,
              10.511581
            ],
            [
              -64.752712,
              10.515498
            ],
            [
              -64.716551,
              10.515163
            ],
            [
              -64.671875,
              10.506476
            ],
            [
              -64.642911,
              10.50681
            ],
            [
              -64.600433,
              10.539214
            ],
            [
              -64.554861,
              10.558612
            ],
            [
              -64.4913,
              10.573302
            ],
            [
              -64.496873,
              10.596361
            ],
            [
              -64.499978,
              10.631273
            ],
            [
              -64.496907,
              10.666187
            ],
            [
              -64.490988,
              10.690468
            ],
            [
              -64.478178,
              10.723592
            ],
            [
              -64.460142,
              10.753758
            ],
            [
              -64.443315,
              10.774069
            ],
            [
              -64.476972,
              10.784338
            ],
            [
              -64.514793,
              10.802527
            ],
            [
              -64.538153,
              10.819241
            ],
            [
              -64.563233,
              10.844016
            ],
            [
              -64.583582,
              10.872718
            ],
            [
              -64.598583,
              10.904476
            ],
            [
              -64.60974,
              10.952199
            ],
            [
              -64.608925,
              11.002757
            ],
            [
              -64.598941,
              11.044279
            ],
            [
              -64.584948,
              11.07666
            ],
            [
              -64.580318,
              11.096772
            ],
            [
              -64.56784,
              11.129577
            ],
            [
              -64.553722,
              11.154191
            ],
            [
              -64.526455,
              11.186892
            ],
            [
              -64.485089,
              11.218009
            ],
            [
              -64.429565,
              11.242646
            ],
            [
              -64.39528,
              11.251719
            ],
            [
              -64.375497,
              11.254173
            ],
            [
              -64.337594,
              11.26561
            ],
            [
              -64.298547,
              11.269889
            ],
            [
              -64.257781,
              11.282892
            ],
            [
              -64.226972,
              11.286898
            ],
            [
              -64.19895,
              11.286848
            ],
            [
              -64.143377,
              11.278748
            ],
            [
              -64.107232,
              11.265467
            ],
            [
              -64.079367,
              11.284724
            ],
            [
              -64.047503,
              11.299429
            ],
            [
              -64.013952,
              11.332084
            ],
            [
              -63.971589,
              11.359185
            ],
            [
              -63.942875,
              11.370929
            ],
            [
              -63.890743,
              11.380603
            ],
            [
              -63.852672,
              11.402845
            ],
            [
              -63.810509,
              11.416471
            ],
            [
              -63.779686,
              11.420477
            ],
            [
              -63.753033,
              11.42019
            ],
            [
              -63.707796,
              11.414785
            ],
            [
              -63.6555,
              11.402582
            ],
            [
              -63.623317,
              11.387767
            ],
            [
              -63.594234,
              11.36766
            ],
            [
              -63.571131,
              11.345191
            ],
            [
              -63.554113,
              11.322946
            ],
            [
              -63.533318,
              11.281868
            ],
            [
              -63.524147,
              11.248014
            ],
            [
              -63.521069,
              11.208393
            ],
            [
              -63.527829,
              11.152073
            ],
            [
              -63.537032,
              11.118225
            ],
            [
              -63.548294,
              11.093173
            ],
            [
              -63.579757,
              11.049692
            ],
            [
              -63.573879,
              11.017607
            ],
            [
              -63.574392,
              10.973837
            ],
            [
              -63.583063,
              10.935169
            ],
            [
              -63.604749,
              10.88958
            ],
            [
              -63.63857,
              10.844406
            ],
            [
              -63.604283,
              10.835808
            ],
            [
              -63.577876,
              10.847494
            ],
            [
              -63.532669,
              10.858165
            ],
            [
              -63.499095,
              10.860509
            ],
            [
              -63.469152,
              10.875556
            ],
            [
              -63.44461,
              10.884594
            ],
            [
              -63.414313,
              10.891237
            ],
            [
              -63.374477,
              10.892957
            ],
            [
              -63.337376,
              10.889495
            ],
            [
              -63.296366,
              10.882434
            ],
            [
              -63.259676,
              10.906056
            ],
            [
              -63.220456,
              10.921017
            ],
            [
              -63.176819,
              10.92813
            ],
            [
              -63.139894,
              10.928085
            ],
            [
              -63.113641,
              10.924385
            ],
            [
              -63.085092,
              10.916286
            ],
            [
              -63.019106,
              10.924232
            ],
            [
              -62.99056,
              10.924851
            ],
            [
              -62.942599,
              10.916488
            ],
            [
              -62.912106,
              10.904598
            ],
            [
              -62.855242,
              10.918231
            ],
            [
              -62.826442,
              10.936261
            ],
            [
              -62.775916,
              10.95674
            ],
            [
              -62.740366,
              10.964862
            ],
            [
              -62.704954,
              10.966774
            ],
            [
              -62.682856,
              10.964862
            ],
            [
              -62.638689,
              10.953761
            ],
            [
              -62.614345,
              10.943144
            ],
            [
              -62.572836,
              10.941315
            ],
            [
              -62.504585,
              10.934412
            ],
            [
              -62.458848,
              10.924634
            ],
            [
              -62.426552,
              10.924713
            ],
            [
              -62.387215,
              10.917891
            ],
            [
              -62.309131,
              10.910738
            ],
            [
              -62.260884,
              10.901832
            ],
            [
              -62.198369,
              10.901333
            ],
            [
              -62.171156,
              10.907087
            ],
            [
              -62.116303,
              10.907431
            ],
            [
              -62.034546,
              10.925523
            ],
            [
              -61.992568,
              10.928458
            ],
            [
              -61.971562,
              10.926689
            ],
            [
              -61.947511,
              10.932081
            ],
            [
              -61.900255,
              10.948118
            ],
            [
              -61.869482,
              10.952124
            ],
            [
              -61.834038,
              10.950977
            ],
            [
              -61.807883,
              10.946125
            ],
            [
              -61.76643,
              10.930696
            ],
            [
              -61.730289,
              10.907593
            ],
            [
              -61.763056,
              10.811389
            ],
            [
              -61.771389,
              10.793889
            ],
            [
              -61.802778,
              10.714444
            ],
            [
              -61.802778,
              10.591496
            ],
            [
              -61.803865,
              10.588884
            ],
            [
              -61.8625,
              10.588611
            ],
            [
              -61.922493,
              10.441047
            ],
            [
              -61.930571,
              10.443252
            ],
            [
              -61.973852,
              10.440709
            ],
            [
              -62.013553,
              10.432228
            ],
            [
              -62.075308,
              10.428873
            ],
            [
              -62.137942,
              10.43105
            ],
            [
              -62.166479,
              10.405331
            ],
            [
              -62.199586,
              10.380919
            ],
            [
              -62.255106,
              10.351213
            ],
            [
              -62.299287,
              10.336506
            ],
            [
              -62.325974,
              10.332121
            ],
            [
              -62.366157,
              10.331647
            ],
            [
              -62.340945,
              10.301749
            ],
            [
              -62.312083,
              10.254455
            ],
            [
              -62.267415,
              10.260152
            ],
            [
              -62.236445,
              10.260152
            ],
            [
              -62.200743,
              10.254887
            ],
            [
              -62.158742,
              10.241261
            ],
            [
              -62.141034,
              10.23226
            ],
            [
              -62.102729,
              10.204534
            ],
            [
              -62.02801,
              10.181507
            ],
            [
              -62.083056,
              10.046111
            ],
            [
              -61.973611,
              10.008056
            ],
            [
              -61.855,
              9.986667
            ],
            [
              -61.630556,
              9.986667
            ],
            [
              -61.5,
              9.97
            ],
            [
              -61.223333,
              9.875833
            ],
            [
              -61.213861,
              9.875058
            ],
            [
              -61.179125,
              9.841698
            ],
            [
              -61.102555,
              9.781507
            ],
            [
              -61.058634,
              9.762817
            ],
            [
              -61.031312,
              9.757704
            ],
            [
              -60.991397,
              9.745897
            ],
            [
              -60.924587,
              9.721966
            ],
            [
              -60.89564,
              9.705999
            ],
            [
              -60.860546,
              9.681391
            ],
            [
              -60.81723,
              9.665549
            ],
            [
              -60.790432,
              9.651295
            ],
            [
              -60.746862,
              9.620464
            ],
            [
              -60.71847,
              9.5954
            ],
            [
              -59.910382,
              8.730728
            ],
            [
              -59.885013,
              8.714171
            ],
            [
              -59.857792,
              8.691928
            ],
            [
              -59.837567,
              8.668976
            ],
            [
              -59.803294,
              8.640252
            ],
            [
              -59.770356,
              8.604329
            ],
            [
              -59.79294,
              8.556732
            ],
            [
              -59.833524,
              8.464935
            ],
            [
              -59.844108,
              8.429795
            ],
            [
              -59.844151,
              8.408743
            ],
            [
              -59.83235,
              8.381042
            ],
            [
              -59.841355,
              8.360716
            ],
            [
              -59.854943,
              8.370005
            ],
            [
              -59.876956,
              8.39556
            ],
            [
              -59.901719,
              8.443982
            ],
            [
              -59.939739,
              8.491996
            ],
            [
              -59.987532,
              8.530696
            ],
            [
              -60.000192,
              8.537145
            ],
            [
              -60.013538,
              8.557844
            ],
            [
              -60.036018,
              8.5699
            ],
            [
              -60.866667,
              9.458333
            ],
            [
              -60.89736,
              9.480532
            ],
            [
              -60.944504,
              9.496027
            ],
            [
              -60.959992,
              9.488571
            ],
            [
              -60.964644,
              9.502804
            ],
            [
              -60.982235,
              9.520647
            ],
            [
              -61.008225,
              9.538841
            ],
            [
              -61.026549,
              9.543351
            ],
            [
              -61.062214,
              9.557515
            ],
            [
              -61.087113,
              9.563759
            ],
            [
              -61.101344,
              9.561456
            ],
            [
              -61.188413,
              9.598876
            ],
            [
              -61.206192,
              9.601576
            ],
            [
              -61.202993,
              9.579747
            ],
            [
              -61.213769,
              9.580315
            ],
            [
              -61.224615,
              9.590922
            ],
            [
              -61.245504,
              9.590989
            ],
            [
              -61.288613,
              9.618004
            ],
            [
              -61.328708,
              9.6306
            ],
            [
              -61.332692,
              9.64195
            ],
            [
              -61.30837,
              9.641432
            ],
            [
              -61.30431,
              9.62919
            ],
            [
              -61.243764,
              9.591282
            ],
            [
              -61.230026,
              9.593679
            ],
            [
              -61.213567,
              9.581334
            ],
            [
              -61.204874,
              9.590348
            ],
            [
              -61.237233,
              9.630946
            ],
            [
              -61.316126,
              9.693141
            ],
            [
              -61.373609,
              9.750018
            ],
            [
              -61.395152,
              9.767327
            ],
            [
              -61.431899,
              9.812389
            ],
            [
              -61.449379,
              9.824715
            ],
            [
              -61.481613,
              9.827612
            ],
            [
              -61.505193,
              9.847389
            ],
            [
              -61.508718,
              9.843331
            ],
            [
              -61.484204,
              9.819863
            ],
            [
              -61.457635,
              9.813028
            ],
            [
              -61.451045,
              9.79078
            ],
            [
              -61.463837,
              9.790689
            ],
            [
              -61.494922,
              9.814378
            ],
            [
              -61.512,
              9.823437
            ],
            [
              -61.544381,
              9.849956
            ],
            [
              -61.582479,
              9.873999
            ],
            [
              -61.604336,
              9.881624
            ],
            [
              -61.636907,
              9.898512
            ],
            [
              -61.671794,
              9.898679
            ],
            [
              -61.656321,
              9.873638
            ],
            [
              -61.627464,
              9.865157
            ],
            [
              -61.633157,
              9.852432
            ],
            [
              -61.602253,
              9.830254
            ],
            [
              -61.584801,
              9.806713
            ],
            [
              -61.56311,
              9.788317
            ],
            [
              -61.524913,
              9.728083
            ],
            [
              -61.512711,
              9.688001
            ],
            [
              -61.509301,
              9.666223
            ],
            [
              -61.526768,
              9.645512
            ],
            [
              -61.531212,
              9.633162
            ],
            [
              -61.554101,
              9.599942
            ],
            [
              -61.571138,
              9.587756
            ],
            [
              -61.589556,
              9.564824
            ],
            [
              -61.592291,
              9.549725
            ],
            [
              -61.609672,
              9.536427
            ],
            [
              -61.621648,
              9.511254
            ],
            [
              -61.622742,
              9.491599
            ],
            [
              -61.631733,
              9.456458
            ],
            [
              -61.625533,
              9.441924
            ],
            [
              -61.65363,
              9.406889
            ],
            [
              -61.673854,
              9.39862
            ],
            [
              -61.665319,
              9.381948
            ],
            [
              -61.683059,
              9.365479
            ],
            [
              -61.6844,
              9.35226
            ],
            [
              -61.693558,
              9.342576
            ],
            [
              -61.707986,
              9.340123
            ],
            [
              -61.725647,
              9.344221
            ],
            [
              -61.721078,
              9.328893
            ],
            [
              -61.730812,
              9.316162
            ],
            [
              -61.753484,
              9.308441
            ],
            [
              -61.758536,
              9.291995
            ],
            [
              -61.752982,
              9.274004
            ],
            [
              -61.756045,
              9.262357
            ],
            [
              -61.77352,
              9.264991
            ],
            [
              -61.775377,
              9.223609
            ],
            [
              -61.785934,
              9.21382
            ],
            [
              -61.820199,
              9.170114
            ],
            [
              -61.832115,
              9.16011
            ],
            [
              -61.845953,
              9.131548
            ],
            [
              -61.862443,
              9.107213
            ],
            [
              -61.860766,
              9.086606
            ],
            [
              -61.850862,
              9.077487
            ],
            [
              -61.826638,
              9.076152
            ],
            [
              -61.818884,
              9.059696
            ],
            [
              -61.82057,
              9.033298
            ],
            [
              -61.831169,
              8.990023
            ],
            [
              -61.844372,
              8.974399
            ],
            [
              -61.860248,
              8.941957
            ],
            [
              -61.857575,
              8.92095
            ],
            [
              -61.861938,
              8.87833
            ],
            [
              -61.869973,
              8.868431
            ],
            [
              -61.876805,
              8.84548
            ],
            [
              -61.890699,
              8.856295
            ],
            [
              -61.906327,
              8.852526
            ],
            [
              -61.931758,
              8.832729
            ],
            [
              -61.936696,
              8.819427
            ],
            [
              -61.94743,
              8.814703
            ],
            [
              -61.95824,
              8.799996
            ],
            [
              -61.982141,
              8.814495
            ],
            [
              -62.001348,
              8.81858
            ],
            [
              -62.012112,
              8.837845
            ],
            [
              -62.04344,
              8.829211
            ],
            [
              -62.053334,
              8.817726
            ],
            [
              -62.056772,
              8.798848
            ],
            [
              -62.053915,
              8.782884
            ],
            [
              -62.059039,
              8.75611
            ],
            [
              -62.079435,
              8.741262
            ],
            [
              -62.09247,
              8.725851
            ],
            [
              -62.10563,
              8.721397
            ],
            [
              -62.111604,
              8.733575
            ],
            [
              -62.075781,
              8.749838
            ],
            [
              -62.059178,
              8.772738
            ],
            [
              -62.057301,
              8.785236
            ],
            [
              -62.062752,
              8.817317
            ],
            [
              -62.058025,
              8.825317
            ],
            [
              -62.024539,
              8.843791
            ],
            [
              -62.006799,
              8.83737
            ],
            [
              -62.00161,
              8.823678
            ],
            [
              -61.981529,
              8.817496
            ],
            [
              -61.95805,
              8.804481
            ],
            [
              -61.935879,
              8.833054
            ],
            [
              -61.909292,
              8.854654
            ],
            [
              -61.892645,
              8.859346
            ],
            [
              -61.878876,
              8.848371
            ],
            [
              -61.872903,
              8.869479
            ],
            [
              -61.863058,
              8.8849
            ],
            [
              -61.864956,
              8.898782
            ],
            [
              -61.860322,
              8.920262
            ],
            [
              -61.863356,
              8.942833
            ],
            [
              -61.849813,
              8.973391
            ],
            [
              -61.833437,
              8.996271
            ],
            [
              -61.833908,
              9.003549
            ],
            [
              -61.823408,
              9.060454
            ],
            [
              -61.827912,
              9.072358
            ],
            [
              -61.85207,
              9.074527
            ],
            [
              -61.866722,
              9.092492
            ],
            [
              -61.865252,
              9.109489
            ],
            [
              -61.851478,
              9.129501
            ],
            [
              -61.83907,
              9.157183
            ],
            [
              -61.808962,
              9.188694
            ],
            [
              -61.799261,
              9.205217
            ],
            [
              -61.779791,
              9.224245
            ],
            [
              -61.786912,
              9.24701
            ],
            [
              -61.777435,
              9.266814
            ],
            [
              -61.758579,
              9.267084
            ],
            [
              -61.761927,
              9.293758
            ],
            [
              -61.75249,
              9.313587
            ],
            [
              -61.731234,
              9.319515
            ],
            [
              -61.728057,
              9.34756
            ],
            [
              -61.70879,
              9.343542
            ],
            [
              -61.688237,
              9.353265
            ],
            [
              -61.68632,
              9.366793
            ],
            [
              -61.66901,
              9.378368
            ],
            [
              -61.677272,
              9.398543
            ],
            [
              -61.65771,
              9.407929
            ],
            [
              -61.631461,
              9.43558
            ],
            [
              -61.635649,
              9.465723
            ],
            [
              -61.626984,
              9.485961
            ],
            [
              -61.621995,
              9.523894
            ],
            [
              -61.594329,
              9.561377
            ],
            [
              -61.575347,
              9.596164
            ],
            [
              -61.550569,
              9.614357
            ],
            [
              -61.535529,
              9.63407
            ],
            [
              -61.528969,
              9.651422
            ],
            [
              -61.51474,
              9.673863
            ],
            [
              -61.52258,
              9.69659
            ],
            [
              -61.523211,
              9.711635
            ],
            [
              -61.530561,
              9.730021
            ],
            [
              -61.551031,
              9.756164
            ],
            [
              -61.573787,
              9.792417
            ],
            [
              -61.600741,
              9.813703
            ],
            [
              -61.629727,
              9.827567
            ],
            [
              -61.643587,
              9.826926
            ],
            [
              -61.625805,
              9.798025
            ],
            [
              -61.658569,
              9.793874
            ],
            [
              -61.680585,
              9.798011
            ],
            [
              -61.736072,
              9.818374
            ],
            [
              -61.77526,
              9.829421
            ],
            [
              -61.820189,
              9.82977
            ],
            [
              -61.828753,
              9.826084
            ],
            [
              -61.82338,
              9.807587
            ],
            [
              -61.809887,
              9.802793
            ],
            [
              -61.803293,
              9.786369
            ],
            [
              -61.810623,
              9.758831
            ],
            [
              -61.822781,
              9.756302
            ],
            [
              -61.832142,
              9.769644
            ],
            [
              -61.831987,
              9.797437
            ],
            [
              -61.863909,
              9.807397
            ],
            [
              -61.917068,
              9.873047
            ],
            [
              -61.958948,
              9.90592
            ],
            [
              -61.977429,
              9.916902
            ],
            [
              -62.028111,
              9.959448
            ],
            [
              -62.066668,
              9.98102
            ],
            [
              -62.104332,
              9.995227
            ],
            [
              -62.122074,
              9.997556
            ],
            [
              -62.149133,
              10.008812
            ],
            [
              -62.195793,
              10.020851
            ],
            [
              -62.212344,
              10.010981
            ],
            [
              -62.227834,
              9.992273
            ],
            [
              -62.24117,
              9.982884
            ],
            [
              -62.244115,
              9.961969
            ],
            [
              -62.228467,
              9.951142
            ],
            [
              -62.212922,
              9.930161
            ],
            [
              -62.17113,
              9.938309
            ],
            [
              -62.149083,
              9.937836
            ],
            [
              -62.132653,
              9.925253
            ],
            [
              -62.117363,
              9.92296
            ],
            [
              -62.101983,
              9.910314
            ],
            [
              -62.098815,
              9.897818
            ],
            [
              -62.081187,
              9.885551
            ],
            [
              -62.056086,
              9.881768
            ],
            [
              -62.056886,
              9.87409
            ],
            [
              -62.084534,
              9.877015
            ],
            [
              -62.100937,
              9.897557
            ],
            [
              -62.10313,
              9.909512
            ],
            [
              -62.115302,
              9.920537
            ],
            [
              -62.136302,
              9.925821
            ],
            [
              -62.149672,
              9.936377
            ],
            [
              -62.188115,
              9.933233
            ],
            [
              -62.207201,
              9.926105
            ],
            [
              -62.20471,
              9.911939
            ],
            [
              -62.179758,
              9.881165
            ],
            [
              -62.170227,
              9.863142
            ],
            [
              -62.175013,
              9.799577
            ],
            [
              -62.16466,
              9.787256
            ],
            [
              -62.165643,
              9.754504
            ],
            [
              -62.162904,
              9.717917
            ],
            [
              -62.169376,
              9.701433
            ],
            [
              -62.181263,
              9.694113
            ],
            [
              -62.18531,
              9.650218
            ],
            [
              -62.190785,
              9.640934
            ],
            [
              -62.204425,
              9.644395
            ],
            [
              -62.199619,
              9.658945
            ],
            [
              -62.186596,
              9.673431
            ],
            [
              -62.187428,
              9.686854
            ],
            [
              -62.166448,
              9.710187
            ],
            [
              -62.167052,
              9.742926
            ],
            [
              -62.179261,
              9.777234
            ],
            [
              -62.176762,
              9.795601
            ],
            [
              -62.176736,
              9.850223
            ],
            [
              -62.186931,
              9.882951
            ],
            [
              -62.210922,
              9.915865
            ],
            [
              -62.217252,
              9.930629
            ],
            [
              -62.244946,
              9.954102
            ],
            [
              -62.254676,
              9.971158
            ],
            [
              -62.265997,
              9.960379
            ],
            [
              -62.253788,
              9.928088
            ],
            [
              -62.256239,
              9.910532
            ],
            [
              -62.245006,
              9.87957
            ],
            [
              -62.245006,
              9.8532
            ],
            [
              -62.273481,
              9.79753
            ],
            [
              -62.284115,
              9.766675
            ],
            [
              -62.283103,
              9.758253
            ],
            [
              -62.291856,
              9.728684
            ],
            [
              -62.301865,
              9.720495
            ],
            [
              -62.320602,
              9.715344
            ],
            [
              -62.33975,
              9.701544
            ],
            [
              -62.350188,
              9.686191
            ],
            [
              -62.347125,
              9.657429
            ],
            [
              -62.350281,
              9.645187
            ],
            [
              -62.362583,
              9.636789
            ],
            [
              -62.39447,
              9.603163
            ],
            [
              -62.416384,
              9.570776
            ],
            [
              -62.43452,
              9.557995
            ],
            [
              -62.442618,
              9.54085
            ],
            [
              -62.437072,
              9.515423
            ],
            [
              -62.442455,
              9.495736
            ],
            [
              -62.432607,
              9.485491
            ],
            [
              -62.408692,
              9.488531
            ],
            [
              -62.398865,
              9.479091
            ],
            [
              -62.397158,
              9.466699
            ],
            [
              -62.404557,
              9.434086
            ],
            [
              -62.410902,
              9.420598
            ],
            [
              -62.404041,
              9.408348
            ],
            [
              -62.376629,
              9.395162
            ],
            [
              -62.361947,
              9.397811
            ],
            [
              -62.346809,
              9.38167
            ],
            [
              -62.325041,
              9.368465
            ],
            [
              -62.32219,
              9.352529
            ],
            [
              -62.339383,
              9.337751
            ],
            [
              -62.342777,
              9.329088
            ],
            [
              -62.337532,
              9.311675
            ],
            [
              -62.322698,
              9.294939
            ],
            [
              -62.296321,
              9.297014
            ],
            [
              -62.278571,
              9.2858
            ],
            [
              -62.277535,
              9.30012
            ],
            [
              -62.263944,
              9.306847
            ],
            [
              -62.239959,
              9.303228
            ],
            [
              -62.236811,
              9.295607
            ],
            [
              -62.242126,
              9.271487
            ],
            [
              -62.215309,
              9.245066
            ],
            [
              -62.216975,
              9.223534
            ],
            [
              -62.201646,
              9.21788
            ],
            [
              -62.191272,
              9.205936
            ],
            [
              -62.187546,
              9.181551
            ],
            [
              -62.172544,
              9.179078
            ],
            [
              -62.152361,
              9.159544
            ],
            [
              -62.145411,
              9.138776
            ],
            [
              -62.131347,
              9.127994
            ],
            [
              -62.100897,
              9.127216
            ],
            [
              -62.097012,
              9.121605
            ],
            [
              -62.103979,
              9.095277
            ],
            [
              -62.101163,
              9.084167
            ],
            [
              -62.06755,
              9.069446
            ],
            [
              -62.052571,
              9.054566
            ],
            [
              -62.05324,
              9.033118
            ],
            [
              -62.063095,
              9.0113
            ],
            [
              -62.082222,
              8.988444
            ],
            [
              -62.084808,
              8.964844
            ],
            [
              -62.078087,
              8.949058
            ],
            [
              -62.059777,
              8.936293
            ],
            [
              -62.059364,
              8.907542
            ],
            [
              -62.055693,
              8.886044
            ],
            [
              -62.03371,
              8.883254
            ],
            [
              -62.035477,
              8.874581
            ],
            [
              -62.055753,
              8.879812
            ],
            [
              -62.065542,
              8.912802
            ],
            [
              -62.08986,
              8.963308
            ],
            [
              -62.086552,
              8.987982
            ],
            [
              -62.074508,
              9.005991
            ],
            [
              -62.071976,
              9.023177
            ],
            [
              -62.058294,
              9.03114
            ],
            [
              -62.056915,
              9.050927
            ],
            [
              -62.099922,
              9.077056
            ],
            [
              -62.112569,
              9.065707
            ],
            [
              -62.10884,
              9.051736
            ],
            [
              -62.116929,
              9.046428
            ],
            [
              -62.143684,
              9.061105
            ],
            [
              -62.148314,
              9.076548
            ],
            [
              -62.143008,
              9.090308
            ],
            [
              -62.147938,
              9.101068
            ],
            [
              -62.165415,
              9.085246
            ],
            [
              -62.187687,
              9.084792
            ],
            [
              -62.185082,
              9.074867
            ],
            [
              -62.192871,
              9.062051
            ],
            [
              -62.203321,
              9.065203
            ],
            [
              -62.217892,
              9.058181
            ],
            [
              -62.22825,
              9.061266
            ],
            [
              -62.224056,
              9.084616
            ],
            [
              -62.241413,
              9.093221
            ],
            [
              -62.266045,
              9.111168
            ],
            [
              -62.263773,
              9.131677
            ],
            [
              -62.28241,
              9.129234
            ],
            [
              -62.301709,
              9.136657
            ],
            [
              -62.324468,
              9.125917
            ],
            [
              -62.330715,
              9.131617
            ],
            [
              -62.328212,
              9.166495
            ],
            [
              -62.321041,
              9.1791
            ],
            [
              -62.304874,
              9.189802
            ],
            [
              -62.313532,
              9.216102
            ],
            [
              -62.302358,
              9.226369
            ],
            [
              -62.329119,
              9.263252
            ],
            [
              -62.331134,
              9.284457
            ],
            [
              -62.347585,
              9.324144
            ],
            [
              -62.345324,
              9.335106
            ],
            [
              -62.326418,
              9.353656
            ],
            [
              -62.325301,
              9.361747
            ],
            [
              -62.349395,
              9.378935
            ],
            [
              -62.361036,
              9.394263
            ],
            [
              -62.374177,
              9.391424
            ],
            [
              -62.405968,
              9.401815
            ],
            [
              -62.4143,
              9.418576
            ],
            [
              -62.409058,
              9.432685
            ],
            [
              -62.403081,
              9.467847
            ],
            [
              -62.413172,
              9.485916
            ],
            [
              -62.439507,
              9.482452
            ],
            [
              -62.44583,
              9.498399
            ],
            [
              -62.441024,
              9.513034
            ],
            [
              -62.4471,
              9.541926
            ],
            [
              -62.436219,
              9.56187
            ],
            [
              -62.4471,
              9.578512
            ],
            [
              -62.423341,
              9.613742
            ],
            [
              -62.383017,
              9.654486
            ],
            [
              -62.371278,
              9.673129
            ],
            [
              -62.371443,
              9.684545
            ],
            [
              -62.362823,
              9.706901
            ],
            [
              -62.338833,
              9.728686
            ],
            [
              -62.321651,
              9.73852
            ],
            [
              -62.309562,
              9.76229
            ],
            [
              -62.345884,
              9.814146
            ],
            [
              -62.359035,
              9.84375
            ],
            [
              -62.364746,
              9.881015
            ],
            [
              -62.394837,
              9.903878
            ],
            [
              -62.403654,
              9.919187
            ],
            [
              -62.417455,
              9.930252
            ],
            [
              -62.44235,
              9.930095
            ],
            [
              -62.43013,
              9.95191
            ],
            [
              -62.415627,
              9.967772
            ],
            [
              -62.425792,
              9.980877
            ],
            [
              -62.433597,
              10.006871
            ],
            [
              -62.434909,
              10.02802
            ],
            [
              -62.453784,
              10.046236
            ],
            [
              -62.475708,
              10.110235
            ],
            [
              -62.484126,
              10.144781
            ],
            [
              -62.510521,
              10.190447
            ],
            [
              -62.539177,
              10.211952
            ],
            [
              -62.594286,
              10.233044
            ],
            [
              -62.615668,
              10.235436
            ],
            [
              -62.623465,
              10.22896
            ],
            [
              -62.620623,
              10.199185
            ],
            [
              -62.61215,
              10.176426
            ],
            [
              -62.606778,
              10.127628
            ],
            [
              -62.61013,
              10.104763
            ],
            [
              -62.6616,
              10.064499
            ],
            [
              -62.704154,
              10.055832
            ],
            [
              -62.70546,
              10.064214
            ],
            [
              -62.664138,
              10.073429
            ],
            [
              -62.638428,
              10.09829
            ],
            [
              -62.623247,
              10.106073
            ],
            [
              -62.616495,
              10.122264
            ],
            [
              -62.62174,
              10.12887
            ],
            [
              -62.63008,
              10.166025
            ],
            [
              -62.646183,
              10.177726
            ],
            [
              -62.662755,
              10.197974
            ],
            [
              -62.669318,
              10.225948
            ],
            [
              -62.668076,
              10.257637
            ],
            [
              -62.67898,
              10.295347
            ],
            [
              -62.687231,
              10.30271
            ],
            [
              -62.68424,
              10.320161
            ],
            [
              -62.689995,
              10.329211
            ],
            [
              -62.710333,
              10.327879
            ],
            [
              -62.724846,
              10.355714
            ],
            [
              -62.723706,
              10.369328
            ],
            [
              -62.73092,
              10.384458
            ],
            [
              -62.799134,
              10.419781
            ],
            [
              -62.808285,
              10.397282
            ],
            [
              -62.82912,
              10.378936
            ],
            [
              -62.849467,
              10.378598
            ],
            [
              -62.869985,
              10.368097
            ],
            [
              -62.886217,
              10.368925
            ],
            [
              -62.904763,
              10.397241
            ],
            [
              -62.917888,
              10.405624
            ],
            [
              -62.945585,
              10.400891
            ],
            [
              -62.952871,
              10.391917
            ],
            [
              -62.952748,
              10.364135
            ],
            [
              -62.937373,
              10.358398
            ],
            [
              -62.936975,
              10.338287
            ],
            [
              -62.929688,
              10.310547
            ],
            [
              -62.920125,
              10.294739
            ],
            [
              -62.935754,
              10.278246
            ],
            [
              -62.953975,
              10.27704
            ],
            [
              -62.971214,
              10.312396
            ],
            [
              -62.971684,
              10.325473
            ],
            [
              -62.96285,
              10.344674
            ],
            [
              -62.952658,
              10.354918
            ],
            [
              -62.961183,
              10.371094
            ],
            [
              -62.961828,
              10.397194
            ],
            [
              -62.975451,
              10.399466
            ],
            [
              -62.993021,
              10.382687
            ],
            [
              -63.004953,
              10.387849
            ],
            [
              -63.007104,
              10.418496
            ],
            [
              -63.021509,
              10.41493
            ],
            [
              -63.031269,
              10.423689
            ],
            [
              -63.029032,
              10.438495
            ],
            [
              -63.037573,
              10.454396
            ],
            [
              -63.013772,
              10.460272
            ],
            [
              -62.99842,
              10.445796
            ],
            [
              -62.973849,
              10.468629
            ],
            [
              -62.954232,
              10.474548
            ],
            [
              -62.937669,
              10.489299
            ],
            [
              -62.919462,
              10.519047
            ],
            [
              -62.885494,
              10.53144
            ],
            [
              -62.867649,
              10.53271
            ],
            [
              -62.851589,
              10.539744
            ],
            [
              -62.827698,
              10.535653
            ],
            [
              -62.792278,
              10.555533
            ],
            [
              -62.768387,
              10.562037
            ],
            [
              -62.747858,
              10.556444
            ],
            [
              -62.733121,
              10.559916
            ],
            [
              -62.689824,
              10.560327
            ],
            [
              -62.672501,
              10.576224
            ],
            [
              -62.658418,
              10.577758
            ],
            [
              -62.624509,
              10.573389
            ],
            [
              -62.592456,
              10.564879
            ],
            [
              -62.577415,
              10.565261
            ],
            [
              -62.528942,
              10.543901
            ],
            [
              -62.487536,
              10.553503
            ],
            [
              -62.467443,
              10.552382
            ],
            [
              -62.451744,
              10.538053
            ],
            [
              -62.429922,
              10.53461
            ],
            [
              -62.410114,
              10.550991
            ],
            [
              -62.391914,
              10.554438
            ],
            [
              -62.365248,
              10.541574
            ],
            [
              -62.359582,
              10.532519
            ],
            [
              -62.321929,
              10.53882
            ],
            [
              -62.306043,
              10.561901
            ],
            [
              -62.294566,
              10.569103
            ],
            [
              -62.282666,
              10.595802
            ],
            [
              -62.24903,
              10.635091
            ],
            [
              -62.209471,
              10.636078
            ],
            [
              -62.194823,
              10.633091
            ],
            [
              -62.164244,
              10.635882
            ],
            [
              -62.117294,
              10.634464
            ],
            [
              -62.113284,
              10.629207
            ],
            [
              -62.066094,
              10.639888
            ],
            [
              -62.034623,
              10.631221
            ],
            [
              -62.024393,
              10.643973
            ],
            [
              -61.997139,
              10.640938
            ],
            [
              -61.9832,
              10.651295
            ],
            [
              -61.975819,
              10.641748
            ],
            [
              -61.954155,
              10.644168
            ],
            [
              -61.93322,
              10.664176
            ],
            [
              -61.925203,
              10.656315
            ],
            [
              -61.89258,
              10.672485
            ],
            [
              -61.879806,
              10.70426
            ],
            [
              -61.875,
              10.726283
            ],
            [
              -61.857194,
              10.727798
            ],
            [
              -61.867832,
              10.741808
            ],
            [
              -61.876603,
              10.72937
            ],
            [
              -61.909224,
              10.729294
            ],
            [
              -61.925799,
              10.714083
            ],
            [
              -61.939262,
              10.714574
            ],
            [
              -61.957883,
              10.724257
            ],
            [
              -61.967774,
              10.713354
            ],
            [
              -61.997836,
              10.725248
            ],
            [
              -62.005054,
              10.709176
            ],
            [
              -62.019573,
              10.705322
            ],
            [
              -62.039776,
              10.71572
            ],
            [
              -62.050938,
              10.704181
            ],
            [
              -62.070034,
              10.700445
            ],
            [
              -62.082652,
              10.705873
            ],
            [
              -62.097273,
              10.700201
            ],
            [
              -62.123239,
              10.702537
            ],
            [
              -62.151013,
              10.694096
            ],
            [
              -62.155378,
              10.684881
            ],
            [
              -62.185619,
              10.686028
            ],
            [
              -62.200948,
              10.700361
            ],
            [
              -62.213309,
              10.695362
            ],
            [
              -62.242633,
              10.700531
            ],
            [
              -62.260732,
              10.699595
            ],
            [
              -62.28286,
              10.689624
            ],
            [
              -62.333049,
              10.710634
            ],
            [
              -62.351644,
              10.709226
            ],
            [
              -62.364328,
              10.714873
            ],
            [
              -62.401609,
              10.715276
            ],
            [
              -62.440318,
              10.722557
            ],
            [
              -62.458617,
              10.721194
            ],
            [
              -62.467119,
              10.726208
            ],
            [
              -62.512657,
              10.728061
            ],
            [
              -62.5638,
              10.73535
            ],
            [
              -62.583833,
              10.735075
            ],
            [
              -62.631958,
              10.743401
            ],
            [
              -62.670341,
              10.74128
            ],
            [
              -62.689632,
              10.745617
            ],
            [
              -62.711611,
              10.76584
            ],
            [
              -62.734509,
              10.756464
            ],
            [
              -62.757157,
              10.737638
            ],
            [
              -62.784174,
              10.733851
            ],
            [
              -62.814773,
              10.719336
            ],
            [
              -62.860463,
              10.70829
            ],
            [
              -62.873969,
              10.698721
            ],
            [
              -62.895293,
              10.700981
            ],
            [
              -62.903437,
              10.692
            ],
            [
              -62.929688,
              10.69894
            ],
            [
              -62.964627,
              10.699849
            ],
            [
              -63.000573,
              10.719708
            ],
            [
              -63.014918,
              10.711401
            ],
            [
              -63.042236,
              10.711491
            ],
            [
              -63.052421,
              10.717798
            ],
            [
              -63.10691,
              10.708235
            ],
            [
              -63.119052,
              10.700488
            ],
            [
              -63.1475,
              10.707526
            ],
            [
              -63.161822,
              10.714426
            ],
            [
              -63.228502,
              10.688495
            ],
            [
              -63.233372,
              10.675253
            ],
            [
              -63.255377,
              10.670118
            ],
            [
              -63.274929,
              10.671935
            ],
            [
              -63.278346,
              10.663855
            ],
            [
              -63.296662,
              10.667041
            ],
            [
              -63.319328,
              10.678639
            ],
            [
              -63.339529,
              10.668456
            ],
            [
              -63.355234,
              10.675877
            ],
            [
              -63.390484,
              10.685698
            ],
            [
              -63.4072,
              10.674911
            ],
            [
              -63.409006,
              10.665552
            ],
            [
              -63.441141,
              10.652695
            ],
            [
              -63.446787,
              10.661347
            ],
            [
              -63.466783,
              10.659492
            ],
            [
              -63.492955,
              10.644151
            ],
            [
              -63.498311,
              10.634387
            ],
            [
              -63.532542,
              10.626915
            ],
            [
              -63.581307,
              10.634679
            ],
            [
              -63.590068,
              10.628979
            ],
            [
              -63.608228,
              10.634809
            ],
            [
              -63.63164,
              10.634292
            ],
            [
              -63.664852,
              10.641153
            ],
            [
              -63.682705,
              10.641329
            ],
            [
              -63.711893,
              10.656905
            ],
            [
              -63.734084,
              10.653252
            ],
            [
              -63.762098,
              10.658966
            ],
            [
              -63.787171,
              10.681501
            ],
            [
              -63.809559,
              10.706028
            ],
            [
              -63.814443,
              10.688756
            ],
            [
              -63.831749,
              10.648577
            ],
            [
              -63.840081,
              10.6428
            ],
            [
              -63.916434,
              10.625136
            ],
            [
              -63.954703,
              10.634259
            ],
            [
              -63.965922,
              10.628413
            ],
            [
              -63.989615,
              10.63528
            ],
            [
              -64.01143,
              10.6287
            ],
            [
              -64.04086,
              10.633771
            ],
            [
              -64.060516,
              10.649871
            ],
            [
              -64.06665,
              10.64082
            ],
            [
              -64.083954,
              10.634773
            ],
            [
              -64.105958,
              10.633692
            ],
            [
              -64.120902,
              10.618995
            ],
            [
              -64.137652,
              10.615744
            ],
            [
              -64.154833,
              10.618968
            ],
            [
              -64.170097,
              10.629392
            ],
            [
              -64.182014,
              10.624962
            ],
            [
              -64.190854,
              10.640048
            ],
            [
              -64.217407,
              10.639134
            ],
            [
              -64.245631,
              10.643232
            ],
            [
              -64.259057,
              10.664437
            ],
            [
              -64.271699,
              10.649304
            ],
            [
              -64.29488,
              10.636699
            ],
            [
              -64.28284,
              10.598888
            ],
            [
              -64.272885,
              10.583117
            ],
            [
              -64.258816,
              10.572453
            ],
            [
              -64.262881,
              10.543638
            ],
            [
              -64.24075,
              10.512116
            ],
            [
              -64.229271,
              10.506503
            ],
            [
              -64.218386,
              10.516872
            ],
            [
              -64.214193,
              10.540477
            ],
            [
              -64.206999,
              10.5521
            ],
            [
              -64.180982,
              10.558064
            ],
            [
              -64.165911,
              10.57083
            ],
            [
              -64.124278,
              10.579401
            ],
            [
              -64.119663,
              10.568522
            ],
            [
              -64.100292,
              10.567563
            ],
            [
              -64.052367,
              10.576646
            ],
            [
              -64.03901,
              10.574527
            ],
            [
              -64.009558,
              10.578636
            ],
            [
              -63.978621,
              10.576857
            ],
            [
              -63.97176,
              10.580236
            ],
            [
              -63.937716,
              10.572543
            ],
            [
              -63.912638,
              10.554475
            ],
            [
              -63.883675,
              10.550275
            ],
            [
              -63.864443,
              10.554334
            ],
            [
              -63.81855,
              10.549944
            ],
            [
              -63.791855,
              10.528433
            ],
            [
              -63.761823,
              10.522017
            ],
            [
              -63.734174,
              10.497546
            ],
            [
              -63.706139,
              10.490462
            ],
            [
              -63.692517,
              10.481516
            ],
            [
              -63.655591,
              10.495909
            ],
            [
              -63.663654,
              10.475755
            ],
            [
              -63.722687,
              10.461612
            ],
            [
              -63.742594,
              10.459321
            ],
            [
              -63.777937,
              10.449279
            ],
            [
              -63.796952,
              10.44093
            ],
            [
              -63.833585,
              10.440054
            ],
            [
              -63.838339,
              10.447197
            ],
            [
              -63.854805,
              10.442038
            ],
            [
              -63.892279,
              10.446172
            ],
            [
              -63.908101,
              10.455105
            ],
            [
              -63.913751,
              10.448553
            ],
            [
              -63.935649,
              10.447842
            ],
            [
              -63.957329,
              10.453044
            ],
            [
              -63.975215,
              10.444831
            ],
            [
              -63.99081,
              10.44567
            ],
            [
              -64.020692,
              10.440112
            ],
            [
              -64.044301,
              10.439937
            ],
            [
              -64.074159,
              10.445059
            ],
            [
              -64.092186,
              10.452878
            ],
            [
              -64.112173,
              10.477474
            ],
            [
              -64.151389,
              10.473743
            ],
            [
              -64.173765,
              10.479799
            ],
            [
              -64.192103,
              10.475687
            ],
            [
              -64.190848,
              10.453518
            ],
            [
              -64.196247,
              10.442576
            ],
            [
              -64.216704,
              10.42023
            ],
            [
              -64.234544,
              10.413256
            ],
            [
              -64.276665,
              10.413497
            ],
            [
              -64.290362,
              10.406898
            ],
            [
              -64.310377,
              10.409603
            ],
            [
              -64.328979,
              10.401835
            ],
            [
              -64.344717,
              10.380854
            ],
            [
              -64.340071,
              10.347104
            ],
            [
              -64.361158,
              10.338861
            ],
            [
              -64.358219,
              10.359187
            ],
            [
              -64.345701,
              10.372981
            ],
            [
              -64.357744,
              10.393558
            ],
            [
              -64.3763,
              10.392934
            ],
            [
              -64.392359,
              10.375362
            ],
            [
              -64.380035,
              10.336561
            ],
            [
              -64.39343,
              10.337507
            ],
            [
              -64.421225,
              10.329386
            ],
            [
              -64.426587,
              10.318665
            ],
            [
              -64.438313,
              10.318209
            ],
            [
              -64.455915,
              10.33256
            ],
            [
              -64.456847,
              10.315022
            ],
            [
              -64.44019,
              10.313136
            ],
            [
              -64.421624,
              10.317963
            ],
            [
              -64.393976,
              10.313578
            ],
            [
              -64.376515,
              10.320549
            ],
            [
              -64.36785,
              10.316371
            ],
            [
              -64.365678,
              10.301755
            ],
            [
              -64.379003,
              10.298955
            ],
            [
              -64.399904,
              10.284197
            ],
            [
              -64.421207,
              10.286186
            ],
            [
              -64.435559,
              10.282043
            ],
            [
              -64.454762,
              10.256809
            ],
            [
              -64.481248,
              10.242775
            ],
            [
              -64.492291,
              10.24149
            ],
            [
              -64.514196,
              10.25083
            ],
            [
              -64.542512,
              10.23743
            ],
            [
              -64.557486,
              10.243395
            ],
            [
              -64.580854,
              10.239466
            ],
            [
              -64.578735,
              10.256304
            ],
            [
              -64.604742,
              10.256731
            ],
            [
              -64.621944,
              10.24438
            ],
            [
              -64.635836,
              10.241532
            ],
            [
              -64.633252,
              10.229506
            ],
            [
              -64.652116,
              10.211667
            ],
            [
              -64.696603,
              10.197039
            ],
            [
              -64.699835,
              10.176759
            ],
            [
              -64.710974,
              10.169784
            ],
            [
              -64.707784,
              10.157545
            ],
            [
              -64.717648,
              10.128132
            ],
            [
              -64.742683,
              10.109167
            ],
            [
              -64.766649,
              10.097615
            ],
            [
              -64.817813,
              10.085738
            ],
            [
              -64.869105,
              10.084331
            ],
            [
              -64.941437,
              10.097737
            ],
            [
              -64.954807,
              10.096473
            ],
            [
              -64.998171,
              10.0762
            ],
            [
              -65.047444,
              10.066136
            ],
            [
              -65.062562,
              10.052899
            ],
            [
              -65.097286,
              10.046735
            ],
            [
              -65.107562,
              10.050733
            ],
            [
              -65.149976,
              10.039522
            ],
            [
              -65.168422,
              10.045112
            ],
            [
              -65.188279,
              10.039092
            ],
            [
              -65.193571,
              10.050284
            ],
            [
              -65.1816,
              10.062724
            ],
            [
              -65.169522,
              10.056964
            ],
            [
              -65.177706,
              10.091753
            ],
            [
              -65.234491,
              10.105537
            ],
            [
              -65.248414,
              10.106056
            ],
            [
              -65.302492,
              10.115484
            ],
            [
              -65.331802,
              10.118441
            ],
            [
              -65.37411,
              10.126357
            ],
            [
              -65.457796,
              10.14645
            ],
            [
              -65.567454,
              10.178578
            ],
            [
              -65.652012,
              10.207072
            ],
            [
              -65.717717,
              10.231945
            ],
            [
              -65.77552,
              10.255926
            ],
            [
              -65.821136,
              10.276822
            ],
            [
              -65.871297,
              10.303826
            ],
            [
              -65.860918,
              10.2889
            ],
            [
              -65.82291,
              10.271951
            ],
            [
              -65.842989,
              10.253682
            ],
            [
              -65.832169,
              10.24593
            ],
            [
              -65.802243,
              10.244953
            ],
            [
              -65.779977,
              10.228207
            ],
            [
              -65.756956,
              10.225383
            ],
            [
              -65.756107,
              10.23416
            ],
            [
              -65.804347,
              10.26519
            ],
            [
              -65.723573,
              10.231055
            ],
            [
              -65.721175,
              10.219941
            ],
            [
              -65.786701,
              10.214904
            ],
            [
              -65.807667,
              10.223451
            ],
            [
              -65.836419,
              10.242906
            ],
            [
              -65.84396,
              10.252346
            ],
            [
              -65.87085,
              10.259782
            ],
            [
              -65.872653,
              10.276602
            ],
            [
              -65.882628,
              10.286925
            ],
            [
              -65.907769,
              10.288456
            ],
            [
              -65.918122,
              10.297034
            ],
            [
              -65.929523,
              10.295154
            ],
            [
              -65.935799,
              10.308966
            ],
            [
              -65.921522,
              10.316766
            ],
            [
              -65.887199,
              10.295542
            ],
            [
              -65.877355,
              10.308068
            ],
            [
              -65.917101,
              10.333046
            ],
            [
              -65.96578,
              10.371094
            ],
            [
              -65.988398,
              10.395169
            ],
            [
              -66.025805,
              10.416903
            ],
            [
              -66.070651,
              10.450711
            ],
            [
              -66.095377,
              10.478361
            ],
            [
              -66.113675,
              10.508469
            ],
            [
              -66.115808,
              10.524945
            ],
            [
              -66.099578,
              10.530829
            ],
            [
              -66.07971,
              10.545279
            ],
            [
              -66.063995,
              10.548236
            ],
            [
              -66.047529,
              10.577706
            ],
            [
              -66.058348,
              10.586229
            ],
            [
              -66.068343,
              10.574602
            ],
            [
              -66.080254,
              10.577496
            ],
            [
              -66.101423,
              10.592072
            ],
            [
              -66.114952,
              10.593483
            ],
            [
              -66.168895,
              10.610433
            ],
            [
              -66.173805,
              10.608941
            ],
            [
              -66.228747,
              10.646159
            ],
            [
              -66.25739,
              10.650043
            ],
            [
              -66.299979,
              10.64005
            ],
            [
              -66.318079,
              10.615648
            ],
            [
              -66.34896,
              10.606645
            ],
            [
              -66.364584,
              10.609879
            ],
            [
              -66.380689,
              10.619946
            ],
            [
              -66.411152,
              10.631109
            ],
            [
              -66.418763,
              10.627556
            ],
            [
              -66.494214,
              10.632049
            ],
            [
              -66.569413,
              10.629773
            ],
            [
              -66.606569,
              10.625065
            ],
            [
              -66.651185,
              10.624926
            ],
            [
              -66.723191,
              10.619743
            ],
            [
              -66.737867,
              10.625197
            ],
            [
              -66.749686,
              10.616101
            ],
            [
              -66.787437,
              10.611916
            ],
            [
              -66.83197,
              10.61348
            ],
            [
              -66.843247,
              10.622457
            ],
            [
              -66.862939,
              10.612787
            ],
            [
              -66.886474,
              10.612132
            ],
            [
              -66.910908,
              10.601849
            ],
            [
              -66.9169,
              10.606815
            ],
            [
              -66.95315,
              10.602645
            ],
            [
              -66.988073,
              10.612088
            ],
            [
              -67.01592,
              10.615082
            ],
            [
              -67.037196,
              10.606939
            ],
            [
              -67.052674,
              10.593666
            ],
            [
              -67.072531,
              10.589954
            ],
            [
              -67.159497,
              10.559869
            ],
            [
              -67.185906,
              10.555349
            ],
            [
              -67.209286,
              10.556313
            ],
            [
              -67.220928,
              10.550925
            ],
            [
              -67.236622,
              10.555758
            ],
            [
              -67.255694,
              10.546875
            ],
            [
              -67.288145,
              10.546415
            ],
            [
              -67.317456,
              10.540551
            ],
            [
              -67.339078,
              10.544576
            ],
            [
              -67.377604,
              10.534101
            ],
            [
              -67.414722,
              10.535848
            ],
            [
              -67.444264,
              10.530899
            ],
            [
              -67.46927,
              10.537331
            ],
            [
              -67.510123,
              10.526954
            ],
            [
              -67.514939,
              10.522066
            ],
            [
              -67.535914,
              10.527196
            ],
            [
              -67.545387,
              10.519585
            ],
            [
              -67.589126,
              10.507139
            ],
            [
              -67.604583,
              10.511992
            ],
            [
              -67.618155,
              10.502253
            ],
            [
              -67.645642,
              10.502428
            ],
            [
              -67.662611,
              10.496622
            ],
            [
              -67.70984,
              10.503837
            ],
            [
              -67.736503,
              10.492746
            ],
            [
              -67.751947,
              10.499253
            ],
            [
              -67.767996,
              10.487785
            ],
            [
              -67.801169,
              10.48939
            ],
            [
              -67.809165,
              10.479514
            ],
            [
              -67.835252,
              10.483026
            ],
            [
              -67.840503,
              10.461657
            ],
            [
              -67.852865,
              10.444895
            ],
            [
              -67.860352,
              10.453569
            ],
            [
              -67.85291,
              10.469498
            ],
            [
              -67.866654,
              10.474904
            ],
            [
              -67.895517,
              10.470287
            ],
            [
              -67.90283,
              10.473629
            ],
            [
              -67.920163,
              10.4545
            ],
            [
              -67.932148,
              10.472226
            ],
            [
              -67.946497,
              10.461863
            ],
            [
              -67.973507,
              10.486353
            ],
            [
              -68.008879,
              10.491013
            ],
            [
              -68.012853,
              10.477272
            ],
            [
              -68.023536,
              10.474722
            ],
            [
              -68.060647,
              10.497976
            ],
            [
              -68.088064,
              10.494978
            ],
            [
              -68.104669,
              10.480936
            ],
            [
              -68.127466,
              10.484113
            ],
            [
              -68.149678,
              10.497761
            ],
            [
              -68.164983,
              10.500888
            ],
            [
              -68.183936,
              10.516765
            ],
            [
              -68.209908,
              10.545387
            ],
            [
              -68.240681,
              10.583539
            ],
            [
              -68.275795,
              10.63771
            ],
            [
              -68.29714,
              10.685009
            ],
            [
              -68.321453,
              10.753587
            ],
            [
              -68.323746,
              10.781013
            ],
            [
              -68.315449,
              10.791507
            ],
            [
              -68.296286,
              10.785499
            ],
            [
              -68.298965,
              10.806816
            ],
            [
              -68.324558,
              10.810151
            ],
            [
              -68.31936,
              10.831846
            ],
            [
              -68.297017,
              10.821805
            ],
            [
              -68.292831,
              10.829659
            ],
            [
              -68.312794,
              10.846095
            ],
            [
              -68.295388,
              10.861256
            ],
            [
              -68.240985,
              10.850761
            ],
            [
              -68.221265,
              10.851513
            ],
            [
              -68.221719,
              10.873093
            ],
            [
              -68.23774,
              10.888518
            ],
            [
              -68.254525,
              10.898437
            ],
            [
              -68.263474,
              10.894045
            ],
            [
              -68.311221,
              10.90858
            ],
            [
              -68.321728,
              10.91534
            ],
            [
              -68.341949,
              10.907557
            ],
            [
              -68.36446,
              10.921881
            ],
            [
              -68.361454,
              10.931317
            ],
            [
              -68.331664,
              10.93189
            ],
            [
              -68.317243,
              10.93688
            ],
            [
              -68.294405,
              10.928562
            ],
            [
              -68.292309,
              10.91506
            ],
            [
              -68.279207,
              10.903763
            ],
            [
              -68.268057,
              10.926521
            ],
            [
              -68.303747,
              10.97614
            ],
            [
              -68.319297,
              11.006238
            ],
            [
              -68.339451,
              11.067091
            ],
            [
              -68.369164,
              11.110067
            ],
            [
              -68.388278,
              11.145829
            ],
            [
              -68.379727,
              11.163597
            ],
            [
              -68.404463,
              11.190518
            ],
            [
              -68.418624,
              11.171222
            ],
            [
              -68.453406,
              11.178315
            ],
            [
              -68.480122,
              11.202946
            ],
            [
              -68.531201,
              11.264708
            ],
            [
              -68.545658,
              11.264793
            ],
            [
              -68.557574,
              11.273947
            ],
            [
              -68.571585,
              11.271544
            ],
            [
              -68.601861,
              11.281724
            ],
            [
              -68.624912,
              11.305145
            ],
            [
              -68.653504,
              11.340864
            ],
            [
              -68.686314,
              11.35439
            ],
            [
              -68.690963,
              11.344198
            ],
            [
              -68.706678,
              11.340967
            ],
            [
              -68.723259,
              11.348029
            ],
            [
              -68.742587,
              11.364553
            ],
            [
              -68.76645,
              11.373633
            ],
            [
              -68.798261,
              11.402107
            ],
            [
              -68.829536,
              11.443902
            ],
            [
              -68.840597,
              11.438028
            ],
            [
              -68.85768,
              11.449675
            ],
            [
              -68.882506,
              11.448478
            ],
            [
              -68.888221,
              11.441393
            ],
            [
              -68.909575,
              11.44831
            ],
            [
              -68.923465,
              11.445305
            ],
            [
              -68.944276,
              11.450406
            ],
            [
              -68.959623,
              11.447514
            ],
            [
              -68.967624,
              11.438679
            ],
            [
              -68.98937,
              11.434767
            ],
            [
              -69.008333,
              11.443012
            ],
            [
              -69.021702,
              11.435218
            ],
            [
              -69.042183,
              11.443503
            ],
            [
              -69.05102,
              11.439075
            ],
            [
              -69.072353,
              11.45452
            ],
            [
              -69.097856,
              11.486206
            ],
            [
              -69.10741,
              11.493529
            ],
            [
              -69.119261,
              11.483567
            ],
            [
              -69.133985,
              11.49113
            ],
            [
              -69.158926,
              11.493449
            ],
            [
              -69.176539,
              11.508341
            ],
            [
              -69.195969,
              11.509305
            ],
            [
              -69.207313,
              11.503091
            ],
            [
              -69.229789,
              11.509911
            ],
            [
              -69.26569,
              11.534272
            ],
            [
              -69.283603,
              11.533328
            ],
            [
              -69.309032,
              11.515271
            ],
            [
              -69.358059,
              11.486467
            ],
            [
              -69.368737,
              11.482401
            ],
            [
              -69.396049,
              11.483625
            ],
            [
              -69.42226,
              11.492133
            ],
            [
              -69.443527,
              11.493609
            ],
            [
              -69.459772,
              11.500487
            ],
            [
              -69.484532,
              11.500866
            ],
            [
              -69.513271,
              11.505503
            ],
            [
              -69.526651,
              11.502492
            ],
            [
              -69.560495,
              11.479515
            ],
            [
              -69.57112,
              11.458836
            ],
            [
              -69.586243,
              11.454826
            ],
            [
              -69.607034,
              11.458755
            ],
            [
              -69.638005,
              11.479403
            ],
            [
              -69.665402,
              11.509605
            ],
            [
              -69.68705,
              11.540589
            ],
            [
              -69.72379,
              11.606274
            ],
            [
              -69.753363,
              11.672827
            ],
            [
              -69.761695,
              11.700257
            ],
            [
              -69.784465,
              11.761579
            ],
            [
              -69.801049,
              11.821003
            ],
            [
              -69.814353,
              11.88727
            ],
            [
              -69.815449,
              11.908546
            ],
            [
              -69.810178,
              11.945316
            ],
            [
              -69.818938,
              11.964725
            ],
            [
              -69.823529,
              12.004039
            ],
            [
              -69.833434,
              12.011651
            ],
            [
              -69.839505,
              12.034289
            ],
            [
              -69.866928,
              12.083393
            ],
            [
              -69.873961,
              12.086359
            ],
            [
              -69.885009,
              12.120691
            ],
            [
              -69.905795,
              12.149557
            ],
            [
              -69.929971,
              12.170667
            ],
            [
              -69.944224,
              12.175469
            ],
            [
              -69.967295,
              12.171907
            ],
            [
              -69.983344,
              12.179072
            ],
            [
              -70.00046,
              12.194475
            ],
            [
              -70.022543,
              12.195465
            ],
            [
              -70.043788,
              12.184668
            ],
            [
              -70.069015,
              12.166858
            ],
            [
              -70.099221,
              12.149382
            ],
            [
              -70.120271,
              12.132394
            ],
            [
              -70.120271,
              12.126219
            ],
            [
              -70.147882,
              12.106733
            ],
            [
              -70.17879,
              12.101593
            ],
            [
              -70.209139,
              12.099644
            ],
            [
              -70.218342,
              12.082561
            ],
            [
              -70.208503,
              12.072107
            ],
            [
              -70.215587,
              12.047315
            ],
            [
              -70.233332,
              12.025338
            ],
            [
              -70.245047,
              11.999848
            ],
            [
              -70.257774,
              11.980273
            ],
            [
              -70.259101,
              11.957954
            ],
            [
              -70.280989,
              11.925103
            ],
            [
              -70.290864,
              11.901582
            ],
            [
              -70.288819,
              11.871858
            ],
            [
              -70.279395,
              11.849106
            ],
            [
              -70.281676,
              11.837494
            ],
            [
              -70.276554,
              11.817274
            ],
            [
              -70.260735,
              11.818515
            ],
            [
              -70.242119,
              11.773374
            ],
            [
              -70.227718,
              11.78073
            ],
            [
              -70.212883,
              11.775596
            ],
            [
              -70.206264,
              11.76437
            ],
            [
              -70.201507,
              11.728809
            ],
            [
              -70.215542,
              11.718372
            ],
            [
              -70.209368,
              11.70776
            ],
            [
              -70.21953,
              11.695657
            ],
            [
              -70.213149,
              11.672573
            ],
            [
              -70.23542,
              11.635287
            ],
            [
              -70.223555,
              11.610011
            ],
            [
              -70.207068,
              11.603882
            ],
            [
              -70.184693,
              11.604716
            ],
            [
              -70.141368,
              11.618657
            ],
            [
              -70.125867,
              11.616501
            ],
            [
              -70.08004,
              11.631415
            ],
            [
              -70.052569,
              11.63534
            ],
            [
              -70.042555,
              11.641211
            ],
            [
              -70.012332,
              11.64865
            ],
            [
              -70.001087,
              11.656217
            ],
            [
              -69.985196,
              11.656324
            ],
            [
              -69.960511,
              11.665671
            ],
            [
              -69.940943,
              11.655061
            ],
            [
              -69.920585,
              11.650516
            ],
            [
              -69.911813,
              11.662251
            ],
            [
              -69.898733,
              11.668543
            ],
            [
              -69.8714,
              11.663636
            ],
            [
              -69.864427,
              11.678421
            ],
            [
              -69.840868,
              11.691496
            ],
            [
              -69.822689,
              11.676651
            ],
            [
              -69.794133,
              11.702829
            ],
            [
              -69.807019,
              11.742906
            ],
            [
              -69.797775,
              11.763643
            ],
            [
              -69.804783,
              11.775207
            ],
            [
              -69.807929,
              11.815612
            ],
            [
              -69.826364,
              11.832729
            ],
            [
              -69.817266,
              11.848477
            ],
            [
              -69.786865,
              11.752372
            ],
            [
              -69.786234,
              11.741463
            ],
            [
              -69.770485,
              11.686263
            ],
            [
              -69.751397,
              11.641281
            ],
            [
              -69.742767,
              11.626006
            ],
            [
              -69.719372,
              11.573147
            ],
            [
              -69.663487,
              11.489614
            ],
            [
              -69.669311,
              11.466465
            ],
            [
              -69.692498,
              11.450211
            ],
            [
              -69.697368,
              11.461928
            ],
            [
              -69.717657,
              11.447106
            ],
            [
              -69.745436,
              11.454439
            ],
            [
              -69.785356,
              11.429755
            ],
            [
              -69.801662,
              11.427714
            ],
            [
              -69.810602,
              11.419446
            ],
            [
              -69.844077,
              11.42193
            ],
            [
              -69.870719,
              11.435927
            ],
            [
              -69.87853,
              11.449117
            ],
            [
              -69.875018,
              11.46682
            ],
            [
              -69.890294,
              11.466336
            ],
            [
              -69.899513,
              11.48938
            ],
            [
              -69.908838,
              11.487837
            ],
            [
              -69.927324,
              11.499289
            ],
            [
              -69.932044,
              11.517092
            ],
            [
              -69.947011,
              11.52299
            ],
            [
              -69.958486,
              11.507079
            ],
            [
              -69.976135,
              11.499217
            ],
            [
              -69.991021,
              11.513361
            ],
            [
              -70.005101,
              11.518636
            ],
            [
              -70.029457,
              11.509548
            ],
            [
              -70.043917,
              11.509341
            ],
            [
              -70.037378,
              11.474543
            ],
            [
              -70.040212,
              11.447324
            ],
            [
              -70.049432,
              11.435998
            ],
            [
              -70.066142,
              11.45225
            ],
            [
              -70.084692,
              11.448028
            ],
            [
              -70.092276,
              11.426975
            ],
            [
              -70.102107,
              11.426613
            ],
            [
              -70.127716,
              11.453867
            ],
            [
              -70.141834,
              11.453792
            ],
            [
              -70.147034,
              11.435637
            ],
            [
              -70.144004,
              11.418837
            ],
            [
              -70.161976,
              11.404469
            ],
            [
              -70.171989,
              11.377651
            ],
            [
              -70.192093,
              11.358009
            ],
            [
              -70.206821,
              11.355007
            ],
            [
              -70.239395,
              11.341272
            ],
            [
              -70.274514,
              11.354928
            ],
            [
              -70.290244,
              11.350779
            ],
            [
              -70.309614,
              11.330875
            ],
            [
              -70.325981,
              11.327539
            ],
            [
              -70.332381,
              11.319889
            ],
            [
              -70.356387,
              11.309736
            ],
            [
              -70.390885,
              11.30422
            ],
            [
              -70.419843,
              11.28045
            ],
            [
              -70.441507,
              11.278511
            ],
            [
              -70.472544,
              11.289636
            ],
            [
              -70.498115,
              11.284269
            ],
            [
              -70.511228,
              11.26983
            ],
            [
              -70.498109,
              11.264296
            ],
            [
              -70.499476,
              11.253158
            ],
            [
              -70.512517,
              11.247861
            ],
            [
              -70.515681,
              11.23814
            ],
            [
              -70.528952,
              11.231647
            ],
            [
              -70.556052,
              11.228881
            ],
            [
              -70.580135,
              11.23122
            ],
            [
              -70.606535,
              11.225534
            ],
            [
              -70.635073,
              11.225476
            ],
            [
              -70.660365,
              11.230676
            ],
            [
              -70.671355,
              11.226313
            ],
            [
              -70.711454,
              11.227182
            ],
            [
              -70.716763,
              11.222692
            ],
            [
              -70.756841,
              11.213226
            ],
            [
              -70.786309,
              11.201263
            ],
            [
              -70.843366,
              11.195104
            ],
            [
              -70.881635,
              11.175017
            ],
            [
              -70.919987,
              11.150605
            ],
            [
              -70.945312,
              11.139287
            ],
            [
              -70.952634,
              11.12853
            ],
            [
              -70.979377,
              11.117718
            ],
            [
              -71.025662,
              11.092059
            ],
            [
              -71.044507,
              11.07733
            ],
            [
              -71.077636,
              11.064031
            ],
            [
              -71.10359,
              11.047753
            ],
            [
              -71.13848,
              11.036763
            ],
            [
              -71.144178,
              11.025794
            ],
            [
              -71.198947,
              11.002299
            ],
            [
              -71.223886,
              10.995598
            ],
            [
              -71.247689,
              10.983845
            ],
            [
              -71.307381,
              10.970491
            ],
            [
              -71.332883,
              10.959927
            ],
            [
              -71.363919,
              10.961496
            ],
            [
              -71.413708,
              10.968162
            ],
            [
              -71.436077,
              10.968162
            ],
            [
              -71.461138,
              10.954938
            ],
            [
              -71.500833,
              10.949528
            ],
            [
              -71.528925,
              10.954037
            ],
            [
              -71.535222,
              10.962737
            ],
            [
              -71.563138,
              10.984616
            ],
            [
              -71.585266,
              10.998345
            ],
            [
              -71.609192,
              10.99812
            ],
            [
              -71.627662,
              11.004494
            ],
            [
              -71.652957,
              11.020061
            ],
            [
              -71.691319,
              11.038004
            ],
            [
              -71.734378,
              11.06382
            ],
            [
              -71.755047,
              11.079052
            ],
            [
              -71.8046,
              11.125239
            ],
            [
              -71.836605,
              11.162469
            ],
            [
              -71.865822,
              11.203736
            ],
            [
              -71.89623,
              11.252652
            ],
            [
              -71.914127,
              11.28948
            ],
            [
              -71.932047,
              11.3319
            ],
            [
              -71.948946,
              11.380363
            ],
            [
              -71.960206,
              11.425422
            ],
            [
              -71.966694,
              11.471959
            ],
            [
              -71.968687,
              11.524414
            ],
            [
              -71.965202,
              11.556666
            ],
            [
              -71.95738,
              11.58412
            ],
            [
              -71.94691,
              11.597863
            ],
            [
              -71.908298,
              11.60513
            ],
            [
              -71.872013,
              11.62418
            ],
            [
              -71.841402,
              11.63226
            ],
            [
              -71.809205,
              11.645897
            ],
            [
              -71.789025,
              11.646953
            ],
            [
              -71.761334,
              11.658564
            ],
            [
              -71.724626,
              11.65987
            ],
            [
              -71.688408,
              11.67023
            ],
            [
              -71.66107,
              11.681856
            ],
            [
              -71.637366,
              11.686874
            ],
            [
              -71.576031,
              11.693152
            ],
            [
              -71.531112,
              11.704904
            ],
            [
              -71.50354,
              11.706505
            ],
            [
              -71.48533,
              11.714404
            ],
            [
              -71.463039,
              11.716468
            ],
            [
              -71.434302,
              11.727451
            ],
            [
              -71.427784,
              11.742711
            ],
            [
              -71.41118,
              11.742358
            ],
            [
              -71.389544,
              11.750136
            ],
            [
              -71.37805,
              11.77464
            ],
            [
              -71.357027,
              11.780952
            ],
            [
              -71.338246,
              11.79391
            ],
            [
              -71.344655,
              11.811998
            ],
            [
              -71.333346,
              11.849869
            ],
            [
              -71.323613,
              11.842014
            ],
            [
              -71.297754,
              11.840685
            ],
            [
              -71.249097,
              11.816832
            ],
            [
              -71.177942,
              11.768142
            ],
            [
              -71.14158,
              11.740425
            ],
            [
              -71.156297,
              11.702978
            ],
            [
              -71.169903,
              11.680358
            ],
            [
              -71.192472,
              11.653282
            ],
            [
              -71.233268,
              11.619689
            ],
            [
              -71.265706,
              11.590229
            ],
            [
              -71.305509,
              11.566966
            ],
            [
              -71.327506,
              11.550683
            ],
            [
              -71.351412,
              11.537476
            ],
            [
              -71.39319,
              11.523057
            ],
            [
              -71.466169,
              11.508756
            ],
            [
              -71.495958,
              11.504751
            ],
            [
              -71.547224,
              11.494138
            ],
            [
              -71.610908,
              11.4843
            ],
            [
              -71.679755,
              11.463765
            ],
            [
              -71.717433,
              11.458694
            ],
            [
              -71.755258,
              11.447252
            ],
            [
              -71.739443,
              11.398496
            ],
            [
              -71.720502,
              11.355642
            ],
            [
              -71.702732,
              11.325427
            ],
            [
              -71.676524,
              11.287046
            ],
            [
              -71.644038,
              11.247056
            ],
            [
              -71.596167,
              11.215957
            ],
            [
              -71.560578,
              11.199201
            ],
            [
              -71.535634,
              11.19451
            ],
            [
              -71.502155,
              11.182877
            ],
            [
              -71.471636,
              11.166119
            ],
            [
              -71.438298,
              11.169189
            ],
            [
              -71.390804,
              11.167935
            ],
            [
              -71.360195,
              11.164509
            ],
            [
              -71.315374,
              11.17567
            ],
            [
              -71.275529,
              11.190079
            ],
            [
              -71.256527,
              11.202391
            ],
            [
              -71.220384,
              11.220806
            ],
            [
              -71.192186,
              11.230876
            ],
            [
              -71.145964,
              11.258606
            ],
            [
              -71.116098,
              11.272563
            ],
            [
              -71.071723,
              11.296887
            ],
            [
              -71.047152,
              11.313392
            ],
            [
              -71.019964,
              11.326616
            ],
            [
              -70.989214,
              11.345717
            ],
            [
              -70.935466,
              11.374412
            ],
            [
              -70.895649,
              11.389409
            ],
            [
              -70.828698,
              11.401328
            ],
            [
              -70.770606,
              11.419555
            ],
            [
              -70.731427,
              11.427248
            ],
            [
              -70.660439,
              11.431528
            ],
            [
              -70.637935,
              11.430476
            ],
            [
              -70.613179,
              11.450172
            ],
            [
              -70.573372,
              11.471324
            ],
            [
              -70.540698,
              11.482898
            ],
            [
              -70.510666,
              11.489443
            ],
            [
              -70.466599,
              11.490993
            ],
            [
              -70.421167,
              11.505341
            ],
            [
              -70.408379,
              11.514723
            ],
            [
              -70.430074,
              11.55708
            ],
            [
              -70.439291,
              11.590927
            ],
            [
              -70.442181,
              11.638724
            ],
            [
              -70.43362,
              11.688936
            ],
            [
              -70.462372,
              11.734247
            ],
            [
              -70.48639,
              11.793205
            ],
            [
              -70.495615,
              11.827051
            ],
            [
              -70.498427,
              11.872883
            ],
            [
              -70.493349,
              11.92712
            ],
            [
              -70.487486,
              11.955658
            ],
            [
              -70.468784,
              12.003991
            ],
            [
              -70.455949,
              12.028714
            ],
            [
              -70.445608,
              12.059161
            ],
            [
              -70.42119,
              12.106692
            ],
            [
              -70.416246,
              12.132399
            ],
            [
              -70.40297,
              12.172101
            ],
            [
              -70.392021,
              12.193705
            ],
            [
              -70.370566,
              12.223971
            ],
            [
              -70.352076,
              12.243294
            ],
            [
              -70.324545,
              12.265536
            ],
            [
              -70.301542,
              12.27894
            ],
            [
              -70.272732,
              12.290685
            ],
            [
              -70.235518,
              12.299826
            ],
            [
              -70.176444,
              12.343655
            ],
            [
              -70.136204,
              12.363962
            ],
            [
              -69.739167,
              12.262778
            ],
            [
              -69.733137,
              12.259273
            ],
            [
              -69.708027,
              12.221181
            ],
            [
              -69.696822,
              12.198998
            ]
          ]
        ]
      },
      "properties": {
        "name": "#16"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -70.680387,
              12.492386
            ],
            [
              -70.667729,
              12.468654
            ],
            [
              -70.656937,
              12.438424
            ],
            [
              -70.650405,
              12.396504
            ],
            [
              -70.650742,
              12.372399
            ],
            [
              -70.657376,
              12.334364
            ],
            [
              -70.671648,
              12.297539
            ],
            [
              -70.690258,
              12.267655
            ],
            [
              -70.703429,
              12.251879
            ],
            [
              -70.72972,
              12.228029
            ],
            [
              -70.763947,
              12.206982
            ],
            [
              -70.790914,
              12.187184
            ],
            [
              -70.826006,
              12.169939
            ],
            [
              -70.855871,
              12.161142
            ],
            [
              -70.888602,
              12.156523
            ],
            [
              -70.923835,
              12.157132
            ],
            [
              -70.99106,
              12.211413
            ],
            [
              -71.013073,
              12.234929
            ],
            [
              -71.049572,
              12.288166
            ],
            [
              -71.0617,
              12.314528
            ],
            [
              -71.080577,
              12.403185
            ],
            [
              -71.108213,
              12.445387
            ],
            [
              -71.128145,
              12.481048
            ],
            [
              -71.128082,
              12.502881
            ],
            [
              -71.122423,
              12.539689
            ],
            [
              -71.112631,
              12.568812
            ],
            [
              -71.087144,
              12.612444
            ],
            [
              -71.054152,
              12.646342
            ],
            [
              -71.030556,
              12.662914
            ],
            [
              -70.993843,
              12.680334
            ],
            [
              -70.96687,
              12.688001
            ],
            [
              -70.929308,
              12.692524
            ],
            [
              -70.89949,
              12.691245
            ],
            [
              -70.864861,
              12.684236
            ],
            [
              -70.829441,
              12.670267
            ],
            [
              -70.787423,
              12.643368
            ],
            [
              -70.762133,
              12.619825
            ],
            [
              -70.735245,
              12.582223
            ],
            [
              -70.716953,
              12.536639
            ],
            [
              -70.698602,
              12.517622
            ],
            [
              -70.680387,
              12.492386
            ]
          ]
        ]
      },
      "properties": {
        "name": "#17"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -63.409326,
              15.677052
            ],
            [
              -63.413,
              15.631383
            ],
            [
              -63.42484,
              15.591369
            ],
            [
              -63.441205,
              15.560135
            ],
            [
              -63.474887,
              15.520222
            ],
            [
              -63.50151,
              15.499554
            ],
            [
              -63.524431,
              15.48663
            ],
            [
              -63.555306,
              15.474422
            ],
            [
              -63.590795,
              15.466776
            ],
            [
              -63.620417,
              15.465043
            ],
            [
              -63.660799,
              15.469328
            ],
            [
              -63.699547,
              15.481164
            ],
            [
              -63.741883,
              15.504721
            ],
            [
              -63.771514,
              15.530607
            ],
            [
              -63.792691,
              15.556961
            ],
            [
              -63.815999,
              15.603226
            ],
            [
              -63.825381,
              15.637061
            ],
            [
              -63.828558,
              15.671959
            ],
            [
              -63.825433,
              15.706859
            ],
            [
              -63.816097,
              15.740702
            ],
            [
              -63.794932,
              15.781764
            ],
            [
              -63.772421,
              15.809579
            ],
            [
              -63.754341,
              15.82619
            ],
            [
              -63.724711,
              15.846292
            ],
            [
              -63.691923,
              15.861103
            ],
            [
              -63.63877,
              15.872743
            ],
            [
              -63.607099,
              15.873412
            ],
            [
              -63.568529,
              15.867844
            ],
            [
              -63.5406,
              15.859141
            ],
            [
              -63.501406,
              15.838941
            ],
            [
              -63.483589,
              15.825894
            ],
            [
              -63.458021,
              15.801114
            ],
            [
              -63.43729,
              15.772409
            ],
            [
              -63.419397,
              15.733134
            ],
            [
              -63.412335,
              15.705427
            ],
            [
              -63.409326,
              15.677052
            ]
          ]
        ]
      },
      "properties": {
        "name": "#18"
      }
    }
  ]
}
